export default {
  en: {
    'enter-exact-amount': 'Enter exact amount',
    'select-currency': 'Select currency',
    ai_chat_title: 'AI Chat Assistant',
    ai_chat_beta: 'BETA',
    ai_chat_greeting: "Hello! I'm your Paybyrd AI assistant. How can I help you today? I can assist with payment processing, transaction inquiries, refunds, and more.",
    ai_chat_placeholder: 'Type your message here...',
    ai_chat_send: 'Send message',
    ai_chat_close: 'Close chat',
    ai_chat_loading: 'Thinking...',
    ai_chat_error: 'Sorry, an error occurred. Please try again later.',
    ai_chat_footer: 'AI assistant is in beta. For critical issues, please contact support.',
    ai_chat_store_selection: 'Select a store for context',
    ai_chat_select_store_warning: 'For more specific help, please select a store first.',
    ai_chat_api_key_required: 'API key is required',
    ai_chat_api_key_invalid: 'Invalid API key. Please check and try again.',
    ai_chat_api_key_missing: 'API key not configured. Please set up your API key to use the AI assistant.',
    ai_chat_api_key_configure: 'Configure',
    ai_chat_api_key_clear: 'Clear Key',
    ai_chat_api_key: 'API Key',
    ai_chat_api_key_privacy: "Your API key is stored securely in your browser's local storage and is only used for communicating with the AI service.",
    ai_chat_api_config: 'AI Configuration',
    ai_chat_clear_chat: 'Clear Chat',
    ai_chat_settings: 'Settings',
    ai_chat_choose_provider: 'Choose AI Provider',
    ai_chat_openai_info: 'Enter your OpenAI API key to use GPT models',
    ai_chat_anthropic_info: 'Enter your Anthropic API key to use Claude models',
    ai_chat_openai_info_tooltip: 'You can get an API key from platform.openai.com',
    ai_chat_anthropic_info_tooltip: 'You can get an API key from console.anthropic.com',
    ai_chat_cancel: 'Cancel',
    ai_chat_save: 'Save',
    ai_chat_provider: 'AI Provider',
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'Configure API Key',
    ai_chat_try_asking: 'Try asking about:',
    ai_chat_suggestions_tooltip: 'Suggestions',
    ai_chat_suggestion_1: 'How can I create a payment link?',
    ai_chat_suggestion_2: 'Refund the total amount of the payment {paymentid}',
    ai_chat_suggestion_3: "What's the status of my latest payment link?",
    ai_chat_suggestion_4: 'Was the order {order_id} already paid?',
    ai_chat_suggestion_5: 'Create a payment link for {amount} {currency} with reference {reference} and send to {email}',
    ai_chat_suggestion_6: 'Search for orders with reference {order_ref} created yesterday',
    ai_chat_confirm_clear: 'Are you sure you want to clear all chat messages?',
    ai_chat_confirm_yes: 'Yes',
    ai_chat_confirm_no: 'No',
    'accessible-merchants': 'Accessible Merchants',
    'accessible-stores': 'Accessible Stores',
    'accessible-units': 'Accessible Units',
    accept: 'Accept',
    accepted: 'Accepted',
    acquirer: 'Acquirer',
    'acquirer-response': 'Acquirer Response',
    'acquirer-response-code': 'Acquirer Response Code',
    'acquirer-response-message': 'Acquirer Response Message',
    acquirerfailed: 'Failed',
    acquirerReferenceNumber: 'Acquirer Reference Number (ARN)',
    acquirerResponseCode: 'Acquirer Response Code',
    acquirerResponseMessage: 'Acquirer Response Message',
    acquirersuccess: 'Success',
    actions: 'Actions',
    add: 'Create',
    'add-filter': 'Add Filter',
    'administration-title': 'Administration',
    all: 'All',
    'available-columns': 'Available Columns',
    amount: 'Amount',
    'amount-greater-than-limit': 'The amount is greater than the transaction amount',
    'analytics-title': 'Analytics',
    'api-key-not-created': 'API Key not created',
    'api-keys': 'API Keys',
    'api-key-copied': 'API Key copied to clipboard',
    'no-api-keys-title': 'No API Keys Found',
    'no-api-keys-description': 'Create API keys to start integrating with our platform',
    'copy-to-clipboard': 'Copy to clipboard',
    channel: 'Channel',
    apply: 'Apply',
    'apply-filters': 'Apply Filters',
    'applied-filters': 'Filter will be applied to your dashboard',
    'aquirer-authorization-code': 'Aquirer Authorization Code',
    aquirerAuthorizationCode: 'Aquirer Authorization Code',
    'attachment-not-found-error': 'Attachment not found',
    attempt: 'Attempt',
    back: 'Back',
    'back-to-payouts': 'Back to Payouts',
    'batch-id': 'Batch ID',
    brand: 'Payment Method',
    cardScheme: 'Card Scheme',
    wallet: 'Digital Wallet',
    businessName: 'Business Name',
    cancel: 'Cancel',
    canceled: 'Canceled',
    capture: 'Capture',
    'capture-create-success': 'Capture successfully created',
    'capture-transaction': 'Capture Transaction',
    captured: 'Captured',
    capturing: 'Capturing...',
    'card-holder-name': 'Card Holder Name',
    'card-number': 'Card Number',
    cardHolderName: 'Card Holder Name',
    cardNumber: 'Card Number',
    category: 'Category',
    'custom-filters': 'Custom Filters',
    modes: 'Modes',
    chargeback: 'Chargeback',
    'chargeback-chat': 'Chargeback process comunitaction',
    'chargeback-create-success': 'Chargeback successfully created',
    'chargeback-confirm-attachment-delete': 'Delete attachment?',
    'chargeback-files': 'Chargeback process files',
    'chargeback-information': 'General Information',
    'chargeback-order-creationReason': 'Chargeback creation Reason',
    'chargeback-order-information': 'Order Information',
    'chargeback-ref': 'Chargeback Ref',
    'chargeback-store-information': 'Store Information',
    'chargeback-store-name': 'Store Name',
    'chargeback-title': 'Chargebacks',
    'chargeback-title-add': 'Start Chargeback Process',
    'chargeback-transaction-information': 'Transation Information',
    chargebackRef: 'Chargeback Reference',
    chargebacks: 'Chargebacks',
    'choose-file-type': 'Choose File Type',
    clear: 'Clear',
    'click-to-upload': 'Click here to upload',
    'client-frequent-flyer-number': 'Frequent Flyer Number',
    clientFrequentFlyerNumber: 'Frequent Flyer Number',
    clientFrequentFlightNumber: 'Frequent Flyer Number',
    closed: 'Closed',
    code: 'Code',
    'collect-shipping-data': 'Collect Shipping Data',
    content: 'Content',
    'copied-link': 'Link $1 copied to the clipboard!',
    costs: 'Costs',
    country: 'Country',
    'country-code': 'Country Code',
    'create-chargeback-from-transaction': 'Create Chargeback',
    'create-checkout': 'Create Checkout',
    created: 'Created',
    'created-date': 'Created Date',
    creating: 'Creating...',
    currency: 'Currency',
    'current-balance': 'Current Balance',
    'dashboard-title': 'Dashboard',
    date: 'Date',
    day: 'Day',
    days: 'Days',
    dccAmount: 'DCC Amount',
    'activate-user': 'Activate user',
    'deactivate-user': 'Deactivate user',
    declined: 'Declined',
    deductions: 'Deductions',
    'delete-attachment-forbidden-error': "You can't delete this attachment",
    denied: 'Denied',
    description: 'Description',
    details: 'Details',
    'developers-description': 'Please keep them private as much as possible.',
    'developers-link': 'Read more about integrating our API',
    'developers-subtitle': 'Use the Test API key to test your integration, and the Live API key to create real payments.',
    'developers-title': 'Developers',
    disputing: 'Disputing',
    'drag-drop-file-here': 'Drop file here',
    download: 'Download',
    downloading: 'Downloading...',
    doYouWannaFullChargeback: 'Do you want to partially chargeback or full chargeback?',
    doYouWannaFullRefund: 'Do you want to partially refund or full refund?',
    dutch: 'Dutch',
    ecommerce: 'Ecommerce',
    'edit-checkout': 'Edit Checkout',
    'edit-checkout-success': 'Social Payment successfully edited',
    'edit-data': 'Edit Data',
    editing: 'Editing...',
    email: 'Email',
    'end-date': 'End Date',
    'end-time': 'End time',
    english: 'English',
    environment: 'Environment',
    'environment-hint': 'Check to see Production transactions only. Uncheck to see Test transactions only',
    error: 'Error',
    'event-type': 'Event Type',
    'expire-at': 'Expire at',
    expired: 'Expired',
    export: 'Export $1',
    'export-details': 'Export',
    'export-details-help':
      'When you start exporting your file, our system will process your request. Once processing is complete, we will send the exported file directly to the e-mail address associated with your account ($1).',
    'export-details-alert': 'Attention',
    externalTransactionId: 'External Transaction Id',
    externalCustomId: 'Acquirer Id',
    'extra-filters-title': 'Custom Filtering',
    failed: 'Failed',
    fees: 'Fees',
    'file-sent': '$1 was sent.',
    'file-upload-helper': 'To upload a file, click in the label of the input',
    'filter-by': 'Filter by $1',
    'filter-by-enter': 'Filter by $1 (Press Enter to Search)',
    firstname: 'First Name',
    'forgot-password': 'Forgot Password?',
    french: 'French',
    fulfilled: 'Fulfilled',
    'full-chargeback': 'Full chargeback',
    'full-refund': 'Full refund',
    'full-capture': 'Full capture',
    german: 'German',
    'getting-started-title': 'Getting Started',
    'go-to': 'Go to $1',
    group: 'Group',
    groups: 'Groups',
    'group-id': 'Group ID',
    groupId: 'Group',
    hasChargeback: 'Chargeback Associated',
    hour: 'Hour',
    hours: 'Hours',
    'transaction-history': 'Transaction History',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'in $1 transactions',
    initiatedFrom: 'Initiated From',
    'international-shipping-amount': 'International Shipping Amount',
    'international-urgent-shipping-amount': 'International Urgent Shipping Amount',
    'invite-error': 'There was an error sending the invite.',
    'invite-merchants': 'Invite Merchants',
    'invite-sent': "The invitation was sent to '$1'. Onboarding form generated at: $2",
    invoice: 'Invoice',
    invoices: 'Invoices',
    'is-one-click-payment': 'Is one click',
    isoAmount: 'Amount',
    isOneClickPayment: 'Is one click',
    'item-service-amount': 'Item/Service Amount',
    'item-service-description': 'Item/Service Description',
    'item-service-image': 'Upload Item/Service Image',
    'item-service-name': 'Item/Service Name',
    language: 'Language',
    'last-month': 'Last Month',
    'last-refunds': 'Last $1 refunds',
    'last-revenue': 'Last $1 revenue',
    'last-week': 'Last Week',
    lastFourCardNumber: 'Last Four Card Number',
    lastname: 'Last Name',
    'latest-payments': 'Latest Payments (production only)',
    'link-validity': 'Link validity',
    'live-api-key': 'Live API Key',
    loading: 'Loading...',
    'loading-order': 'Loading Order Data',
    'loading-ref-transactions': 'Loading Related Transactions',
    'loading-transaction': 'Loading Transaction Data',
    'loading-webhook-attempts': 'Loading Webhook Attempts',
    'log-into-paybyrd': 'Log into Paybyrd',
    login: 'Login',
    logout: 'Logout',
    lost: 'Lost',
    'management-title': 'Management',
    'manage-user': 'Manage user',
    market: 'Market',
    maskedCardNumber: 'Masked Card Number',
    merchant: 'Merchant',
    merchants: 'Merchants',
    'merchant-id': 'Merchant ID',
    'merchant-information': 'Merchant Information',
    merchantId: 'Merchant',
    'message-label': 'Message',
    mode: 'Mode',
    month: 'Month',
    'monthly-revenue': 'Monthly Revenue (production only)',
    months: 'Months',
    name: 'Name',
    'national-shipping-amount': 'National Shipping Amount',
    'national-urgent-shipping-amount': 'National Urgent Shipping Amount',
    no: 'No',
    'no-balance': " We couldn't find a balance for the selected filters",
    'no-balance-description': 'Try selecting another month, or units above',
    'no-chargebacks': "We couldn't find chargebacks for the selected filters",
    'no-chargebacks-subtitle': 'Try selecting another range, units or status above',
    'no-info': 'No Info',
    'no-invoices': 'There is no invoices for the selected period',
    'no-invoices-description': 'Try selecting another year',
    'no-onboardings': "We couldn't find onboarding processes for the current filters",
    'no-onboardings-subtitle': 'Try another combination',
    'no-options': 'No Options',
    'no-orders': "We couldn't find orders for the selected filters",
    'no-orders-subtitle': 'Try changing the filters',
    'no-payments': 'There is no recent transactions',
    'no-payments-subtitle': 'Refresh the grid to check if there are new transactions available',
    'no-ref-transactions': "We couldn't find related transactions for this order",
    'no-ref-transactions-subtitle': 'Refresh the grid to check if there is new transactions available',
    'no-results': 'No Results',
    'no-settlements': 'There are no settlements for the selected period',
    'no-settlements-description': 'Try selecting another month',
    'no-payouts': 'There are no payouts for the selected period',
    'no-shifts': " We couldn't find transactions for the selected filters",
    'no-shifts-subtitle': 'Try selecting another range, units, status or modes above',
    'no-statistics': "We couldn't find statistics for the selected filters",
    'no-statistics-subtitle': 'Try selecting another period or units above',
    'no-totals': "We couldn't find statistics for the current month",
    'no-totals-subtitle': 'Check statistics pages for other periods',
    'no-transactions': "We couldn't find transactions for the selected filters",
    'no-transactions-subtitle': 'Try selecting another range, units, status or modes above',
    'no-users': "We couldn't find users for the selected filters",
    'no-users-subtitle': 'Try selecting another filter or units above',
    'no-webhooks': "We couldn't find webhooks for the selected filters",
    none: 'None',
    'not-confirmed': 'Not confirmed',
    'not-confirmed-message': 'Payout made directly by the acquirer.',
    now: 'Now',
    onboarding: 'Onboarding',
    'onboarding-details': 'Onboarding Details',
    onboardings: 'Onboardings',
    opened: 'Opened',
    'order-amount': 'Order Amount',
    'order-date': 'Order Date',
    'order-ref': 'Order Ref',
    'order-reference': 'Order Reference',
    order: 'Order',
    orderCreated: 'Order Created',
    noOrderInfo: 'No Order Info',
    'order-details': 'Order Details',
    orderId: 'Order Id',
    orderRef: 'Order Ref',
    orderref: 'Order Ref',
    orders: 'Orders',
    'orders-title': 'Orders',
    paid: 'Paid',
    'partially captured': 'Partially captured',
    'partially refunded': 'Partially refunded',
    'partial-chargeback': 'Partial chargeback',
    'partial-refund': 'Partial refund',
    'partial-capture': 'Partial capture',
    password: 'Password',
    'pay-by-link-create': 'Create new pay link',
    'pay-by-link-description': 'Create, send pay links and get paid online',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Pay link',
    'pay-links': 'pay links',
    paymentDetails: 'Payment Details',
    recipientInformation: 'Recipient Information',
    configuration: 'Configuration',
    payment: 'Payment',
    'payment-amount': 'Payment Amount',
    'payment-batch-not-found': 'Payment batch not found',
    'payment-link-error': 'An error occurred while sending the links',
    'payment-link-success': 'Payment link was successfully sent.',
    'payment-method': 'Payment Method',
    paymentId: 'Transaction Id',
    paymentInformation: 'Payment Information',
    paymentMethod: 'Payment Method',
    payments: 'Payments',
    'payment-reference': 'Payment Reference',
    'payments-title': 'Payments',
    'payouts-title': 'Payouts',
    'payout-information': 'Payout Information',
    'payout-title': 'Detail $1',
    'payout-paid-message': 'Payout already processed',
    'payout-pending-message': 'Payout not yet executed',
    'payout-no-info-message': 'Payout processed directly by the acquirer',
    'payouts-warning-message':
      'This feature is temporarily unavailable. We are making improvements to our system to serve you even better. We apologize for the inconvenience caused and will be quick to restore this functionality. For any further clarification, you may contact us through the usual channels.',
    pending: 'Pending',
    pendingaction: 'Pending Action',
    pendingmerchantaction: 'Pending Merchant Action',
    period: 'Period',
    'phone-number': 'Phone Number',
    phoneNumber: 'Phone Number',
    pnr: 'PNR',
    portuguese: 'Portuguese',
    pos: 'POS',
    'pre-auth': 'Pre-Auth',
    preauth: 'PreAuth',
    'predictions-dispute': 'I want to dispute',
    'preferred-payment-methods': 'Preferred Payment Methods',
    'previous-revenue': 'Previous Revenue',
    processing: 'Processing',
    prod: 'Production',
    quarter: 'Quarter',
    quarters: 'Quarters',
    range: 'Range',
    reason: 'Reason for initiating Chargeback',
    'recipient-email': 'Recipient Email',
    'recipient-name': 'Recipient name',
    'recipient-number': 'Recipient Phone Number',
    'recover-paybyrd-password': 'Recover password',
    'recovery-password-success': "We've sent you an email to reset your password.",
    reference: 'Reference',
    'reference-ids': 'Reference Ids',
    refresh: 'Refresh',
    refund: 'Refund',
    'refund-amount': 'Refund Amount',
    'refund-confirm-message': 'Do you really want to refund this transaction in the amount of $1?',
    'refund-transaction': 'Refund Transaction',
    refunded: 'Refunded',
    refunding: 'Refunding...',
    refunds: 'Refunds',
    'refund-create-success': 'Refund successfully created',
    'register-now': 'Register Now',
    'related-operation-status': 'Related Operation Status',
    'related-transactions': 'Related Transactions',
    relatedOperationStatus: 'Related Operation Status',
    release: 'Release',
    releasing: 'Releasing...',
    remark: 'Remark',
    'request-info': 'Request Info',
    'required-field': 'This field is required',
    resend: 'Resend',
    'resend-error': "There was an error when resending the webhook '$1'.",
    'resend-success': "The webhook '$1' was resent successfully",
    resending: 'Resending...',
    response: 'Response',
    revenue: 'Revenue',
    'reverse-confirmation': 'Are you sure you want to release the transaction with id $1?',
    'reverse-create-success': 'Reverse successfully created',
    role: 'Role',
    search: 'Search',
    'search-filters': 'Search filters',
    'select-all': 'Select All',
    'deselect-all': 'Deselect all',
    'select-filter': 'Select Filter',
    selected: 'selected',
    'selected-s': '$1 $2 selected',
    'send-invite': 'Send Invite',
    'send-link': 'Send link',
    'send-links': 'Send links',
    'send-message': 'Send Message',
    'send-message-and-dispute': 'Send message and open Dispute',
    'send-password-reset': 'Send password reset',
    'send-recover-email': 'Send email',
    sending: 'Sending...',
    'sent-at': 'Sent At',
    'settings-title': 'Settings',
    'settlement-date': 'Settlement Date',
    'settlement-details': 'Settlement Details',
    settlements: 'Settlements',
    settled: 'Settled',
    shift: 'Shift $1',
    'shift-id': 'Shift Id',
    'shift-details': 'Shift Details',
    'shifts-title': 'Shifts',
    'shopper-ip-address': 'Shopper IP Address',
    shopperEmail: 'Shopper Email',
    shopperInformation: 'Shopper Information',
    shopperIp: 'Shopper IP Address',
    'show-accessible-stores': 'Show accessible stores',
    'show-all': 'Show All',
    'hide-all': 'Hide All',
    'show-details': 'Show details',
    'signed-up-on': 'Signed up on $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Spanish',
    'start-date': 'Start Date',
    'start-time': 'Start time',
    'statistics-title': 'Statistics',
    status: 'Status',
    stock: 'Stock',
    'stock-quantity': 'Stock Quantity',
    store: 'Store',
    stores: 'Stores',
    'store-name': 'Store Name',
    storeId: 'Store',
    success: 'Success',
    summary: 'Summary',
    'system-language': 'System Language',
    'system-timezone': 'System Timezone',
    'team-users': 'Team Users',
    terminalPassword: 'Terminal Password',
    'new-password': 'New Password',
    'confirm-new-password': 'Confirm New Password',
    'save-password': 'Save Password',
    'changing-password': 'Changing Password...',
    'confirm-change-password-message': 'Confirm terminal password change?',
    'passwords-do-not-match-message': 'Passwords do not match!',
    'change-terminal-password': 'Change Terminal Password',
    'password-must-have-six-numbers': 'The password must have six numbers!',
    'password-changed-successfully': 'Password changed successfully!',
    test: 'Test',
    'test-api-key': 'Test API Key',
    'this-month': 'This Month',
    'this-week': 'This Week',
    title: 'Title',
    today: 'Today',
    total: 'Total',
    'total-amount': 'Total Amount',
    'total-revenue': 'Total Revenue',
    totals: 'Totals',
    'totals-per': 'Totals per $1',
    'transaction-details': 'Transaction Details',
    'transaction-type': 'Transaction Type',
    transactionId: 'Transaction Id',
    transactions: 'transactions',
    'transactions-count': 'Transactions Count',
    'transactions-title': 'Transactions',
    'transactions-volume': 'Transactions Volume',
    'transactions-multiple-currencies-found': 'When multiple currencies are selected, the total revenue/amount may not be displayed.',
    type: 'Type',
    unit: 'Store',
    units: 'Stores',
    user: 'User',
    'user-action-title': 'Are you sure?',
    'user-action-password-reset-confirmation': 'Are you sure you want to reset the user password?',
    'user-action-password-reset-success': 'Password reset email sent successfully!',
    'user-action-activate-user-confirmation': 'Are you sure you want to activate the user?',
    'user-action-activate-user-success': 'User activated successfully!',
    'user-action-deactivate-user-confirmation': 'Are you sure you want to deactivate the user?',
    'user-action-deactivate-user-success': 'User deactivated successfully!',
    'user-blocked': 'Blocked',
    'user-details': 'User details',
    'user-profile-title': 'User Profile',
    'user-profile-subtitle': 'Manage your account settings and preferences',
    'appearance-settings': 'Appearance',
    'appearance-settings-description': 'Customize the visual theme and display preferences',
    'language-settings': 'Language & Region',
    'language-settings-description': 'Set your preferred language and regional settings',
    'timezone-settings': 'Date & Time',
    'timezone-settings-description': 'Configure your timezone and date format preferences',
    'theme-mode': 'Theme Mode',
    'theme-mode-description': 'Choose between light and dark theme',
    'light-mode': 'Light',
    'dark-mode': 'Dark',
    'system-language-description': 'Select your preferred language for the interface',
    'system-timezone-description': 'Choose your timezone for accurate date and time display',
    'connected-stores': 'Connected Stores',
    'dashboard-user': 'Dashboard User',
    'validation-max-chars': 'The maximum length for this field is $1 characters',
    'view-by': 'View by $1',
    'view-details': 'View details',
    'view-less': 'View less',
    'view-more': '+$1 More',
    'view-transaction-details-hint': 'Click to view transaction details.',
    'visible-columns': 'Visible Columns',
    'hidden-columns': 'Hidden Columns',
    'manage-columns': 'Manage Columns',
    'search-columns': 'Search columns...',
    'reset-default': 'Reset to default',
    'no-columns-found': 'No columns found matching your search',
    volume: 'Volume',
    webhooks: 'Webhooks',
    week: 'Week',
    weeks: 'Weeks',
    won: 'Won',
    year: 'Year',
    years: 'Years',
    yes: 'Yes',
    yesterday: 'Yesterday',

    // AI Assistant
    ai_smart_assistant_title: 'AI Assistant',
    ai_smart_assistant_smart_suggestions: 'Smart Suggestions',
    ai_smart_assistant_smart_suggestions_description: 'Pre-configured prompts for common business operations. Fill in the details and execute instantly.',
    ai_smart_assistant_your_question: 'Your Question',
    ai_smart_assistant_selected_request: 'Selected Request',
    ai_smart_assistant_ai_response: 'AI Response',
    ai_smart_assistant_ready_help: 'Ready to help!',
    ai_smart_assistant_ready_help_description: 'Ask your question or try one of the smart suggestions.',
    ai_smart_assistant_processing: 'Processing your request...',
    ai_smart_assistant_placeholder_confirm: 'Please confirm or cancel the action above before sending a new message...',
    ai_smart_assistant_placeholder_completed: "Request completed. Click 'New Request' to start a fresh conversation...",
    ai_smart_assistant_placeholder_default: 'Ask me anything about your store data or try the smart suggestions...',
    ai_smart_assistant_new_request: 'New Request',
    ai_smart_assistant_send: 'Send',
    ai_smart_assistant_request_canceled: 'The request has been canceled by the user.',
    ai_smart_assistant_processing_button: 'Processing...',
    ai_smart_assistant_characters: 'characters',
    ai_smart_assistant_tip: "💡 Tip: Use Ctrl+Enter to send • Try the smart suggestions for quick actions • I'll ask for confirmation before performing sensitive operations",
    ai_smart_assistant_confirmation_required: 'Confirmation Required',
    ai_smart_assistant_confirmation_description: 'Please review the response below and confirm if you want to proceed.',
    ai_smart_assistant_confirm: 'Confirm',
    ai_smart_assistant_cancel: 'Cancel',
    ai_smart_assistant_store_selection: 'Store Selection',
    ai_smart_assistant_search_stores: 'Type to search stores...',
    ai_smart_assistant_configure_api_key: 'Configure API Key',
    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Export Orders',
    ai_smart_suggestion_export_orders_description: 'Export all paid orders from yesterday',
    ai_smart_suggestion_create_payment_link: 'Create Payment Link',
    ai_smart_suggestion_create_payment_link_description: 'Generate a payment link with custom details',
    ai_smart_suggestion_create_payment_link_template: 'Create payment link with reference {orderRef} of {amount} {currency} and send to {email}',
    ai_smart_suggestion_refund_transaction: 'Refund Transaction',
    ai_smart_suggestion_refund_transaction_description: 'Process a refund for a specific transaction',
    ai_smart_suggestion_refund_transaction_template: 'Refund transaction {transactionId} for {amount} {currency}',
    ai_smart_suggestion_order_reference: 'Order Reference',
    ai_smart_suggestion_order_reference_placeholder: 'e.g., ORD-001',
    ai_smart_suggestion_amount: 'Amount',
    ai_smart_suggestion_amount_placeholder: 'e.g., 50.00',
    ai_smart_suggestion_currency: 'Currency',
    ai_smart_suggestion_currency_placeholder: 'Select currency',
    ai_smart_suggestion_customer_email: 'Customer Email',
    ai_smart_suggestion_customer_email_placeholder: 'customer@example.com',
    ai_smart_suggestion_execute: 'Execute',
    ai_smart_suggestion_missing_fields: 'Please fill in all required fields:',
    ai_smart_suggestion_retrieve_transaction: 'Retrieve Transaction Details',
    ai_smart_suggestion_retrieve_transaction_description: 'Get detailed information about a specific transaction',
    ai_smart_suggestion_retrieve_transaction_template: 'Please retrieve the details for transaction ID {transactionId}',
    ai_smart_suggestion_transaction_id: 'Transaction ID',
    ai_smart_suggestion_transaction_id_placeholder: 'e.g., 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: 'Export Format',
    ai_smart_suggestion_export_format_placeholder: 'Select format',
    ai_smart_suggestion_export_orders_template_with_format: 'Please export all paid orders from yesterday in {format} format and send them to my email',
    ai_smart_suggestion_find_order: 'Find Order by ID',
    ai_smart_suggestion_find_order_description: 'Retrieve detailed information about a specific order',
    ai_smart_suggestion_find_order_template: 'Please find the order with ID {orderId}',
    ai_smart_suggestion_order_id: 'Order ID',
    ai_smart_suggestion_order_id_placeholder: 'e.g., 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Search Orders by Reference',
    ai_smart_suggestion_search_orders_by_ref_description: 'Find recent orders by reference (last 7 days)',
    ai_smart_suggestion_search_orders_by_ref_template: 'Search for orders with reference {orderRef} from the last 7 days',
    ai_smart_assistant_help: 'Help',
    ai_smart_assistant_help_tooltip: 'View documentation for AI Smart Assistant',

    // History
    ai_smart_assistant_request_history: 'Request History',
    ai_smart_assistant_clear_all: 'Clear All',
    ai_smart_assistant_no_history: 'No history yet',
    ai_smart_assistant_no_history_description: 'Your AI requests will be saved here for easy access.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: 'Sorry, I encountered an error processing your confirmation.',
    ai_smart_assistant_error_request: 'Sorry, I encountered an error processing your request.',
    ai_smart_assistant_error_api_key: 'API key is required. Please configure it first.',
    ai_smart_assistant_error_invalid_api_key: 'Invalid API key. Please check your configuration.',
    ai_smart_assistant_error_auth: 'Authentication issue. Please try logging in again.',

    // user roles
    'user-role': 'Role',
    'user-role-admin': 'Admin',
    'user-role-manager': 'Manager',
    'user-role-developer': 'Developer',
    'user-role-finance': 'Finance',
    'user-role-operator': 'Operator',
    'user-role-user': 'User',

    // Getting Started
    welcome: 'Welcome',
    'welcome-back': 'Welcome back',
    'try-paybyrd': 'Try Paybyrd',
    'try-paybyrd-description': `Connect Paybyrd to your website or platform using our test API key to explore the integration process. Once your account is approved, you'll receive your live API key to start accepting real payments.`,
    'try-paybyrd-cta': 'Test API',
    'resume-registration': 'Resume Registration',
    'resume-registration-description': `We still need some information and documents from you. Resume the registration process to complete it—you'll pick up right where you left off.`,
    'resume-registration-help': `Need help? Check out our $1 article or reach out via chat. `,
    'resume-registration-link': `Registration with Paybyrd`,
    'resume-registration-cta': 'Resume process',
    'init-registration': `Start with Paybyrd`,
    'init-registration-description': `To start accepting payments, you'll first need to complete the legal onboarding process. Please have the following documents and information ready — you can pause and resume anytime.`,
    'company-details': 'Company details',
    'shareholder-information': 'Shareholder Information',
    'bank-account-details': 'Bank Account Details',
    'business-activity-overview': 'Business Activity Overview',
    'init-registration-help': `👉 Need more details? Check out our help article: `,
    'init-registration-link': `Registration with Paybyrd`,
    'start-registration-cta': 'Start registration',
    'submitted-registration': 'Registration is Submitted!',
    'submitted-registration-description': `Our team is reviewing your submission. We'll update you via email within five business days as we complete the setup. If you need more merchants to onboard, we will send an invitation link separately.`,
    'submitted-registration-help': `Have questions? Check out our Help Center or reach out via chat.`,
    'submitted-registration-cta': 'Go Help Center',
    'go-to-dashboard-cta': 'Go to Dashboard',
    'start-next-onboarding-cta': 'Start Next Onboarding',
    processingData: 'Processing Data',
    'parent-payment-id': 'Parent Payment Id',
    acquirerId: 'Acquirer Id',
    'shift-code': 'Shift Code',
    'providing-access-to': 'Providing access to $1',
    'provide-access': 'Provide access',
    'select-units-type-to-add': 'Select unit type to add',
    'access-updated': 'Access updated!',
    'add-new-access-units': 'Add new access unit',
    'confirm-updating-access': 'Confirm updating access',
    'select-group-add': 'Select the group to add',
    'select-merchant-add': 'Select the merchant to add',
    'select-store-add': 'Select the store to add',
    'all-merchants': 'All merchants',
    'all-stores': 'All stores',
    'no-units-selected': 'No units selected',
    'remove-access': 'Remove access',
    'are-you-sure-remove-group': 'Are you sure you want to remove the group?',
    'are-you-sure-remove-merchant': 'Are you sure you want to remove the merchant?',
    'are-you-sure-remove-store': 'Are you sure you want to remove the store?',
    next: 'Next',
    'success-remove-unit': 'Unit removed successfully',
    'selected-items': '$1 $2 selected',
    item: 'item',
    items: 'items',
    'no-unit-selected-label': 'If no unit is selected, all available units will be added to the user',
    'paybyrd-user': 'Paybyrd user with access to all merchants',
    'no-groups': "We couldn't find groups for the selected user",
    'no-groups-subtitle': 'You can add new access units using the button above',
    'no-merchants': "We couldn't find merchants for the selected user",
    'no-merchants-subtitle': 'You can add new access units using the button above',
    'no-stores': "We couldn't find stores for the selected user",
    'no-stores-subtitle': 'You can add new access units using the button above',
    'invite-new-users': 'Invite new users',
    'add-emails': 'Add emails',
    'enter-valid-email': 'Please enter a valid email.',
    'invite-new-user': 'Invite new user',
    invite: 'Invite',
    close: 'Close',
    'feature-access': 'Feature access',
    'view-feature-access': 'View list of access features',
    'paybylink-description': 'Enable to create and manage payment links.',
    'shifts-description': 'Enable the creation of shifts.',
    'successfull-invite': 'Invitation sent successfully!',
    'manage-role': 'Manage role and access',
    'changing-user-roles': 'Changing user role',
    'role-operator': 'Allow selected action permission in the accessible areas.',
    'role-observer': 'Allow selected action permission in the accessible areas.',
    'role-admin': 'Allow a full control within the accessible areas.',
    current: 'Current',
    save: 'Save',
    transactionPayout: 'Transaction Payout',
    paymentReference: 'Payment Reference',
    threeDSecure: '3D Secure',
    installments: 'Installments',
    installmentAmount: 'Installment Amount',
    cardIssuerCountry: 'Card Issuer Country',
    authorizationCode: 'Authorization Code',
    LiabilityShift: 'Liability Shift',
    version: 'Version',
    transStatus: '3DS Transaction Status',
    authorizationStatus: '3DS Authorization Status',
    challengeOptions: '3DS Challenge Options',
    protocolVersion: 'Protocol Version',
    'settlement-status': 'Settlement',
    eci: 'ECI',
    done: 'Done',
    inProgress: 'In Progress',
  },
  pt: {
    'enter-exact-amount': 'Digite o valor exato',
    'select-currency': 'Selecione a moeda',
    summary: 'Resumo',
    ai_chat_title: 'Assistente de Chat IA',
    ai_chat_beta: 'BETA',
    ai_chat_greeting:
      'Olá! Sou seu assistente IA da Paybyrd. Como posso ajudar hoje? Posso ajudar com processamento de pagamentos, consultas de transações, reembolsos e muito mais.',
    ai_chat_placeholder: 'Digite sua mensagem aqui...',
    ai_chat_send: 'Enviar mensagem',
    ai_chat_close: 'Fechar chat',
    ai_chat_loading: 'Pensando...',
    ai_chat_error: 'Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.',
    ai_chat_footer: 'O assistente de IA está em beta. Para problemas críticos, entre em contato com o suporte.',
    ai_chat_store_selection: 'Selecione uma loja para contexto',
    ai_chat_select_store_warning: 'Para ajuda mais específica, selecione uma loja primeiro.',
    ai_chat_api_key_required: 'A chave API é obrigatória',
    ai_chat_api_key_invalid: 'Chave API inválida. Verifique e tente novamente.',
    ai_chat_api_key_missing: 'Chave API não configurada. Configure sua chave API para usar o assistente de IA.',
    ai_chat_api_key_configure: 'Configurar',
    ai_chat_api_key_clear: 'Limpar Chave',
    ai_chat_api_key: 'Chave API',
    ai_chat_api_key_privacy: 'Sua chave API é armazenada com segurança no armazenamento local do seu navegador e é usada apenas para comunicação com o serviço de IA.',
    ai_chat_api_config: 'Configuração de IA',
    ai_chat_clear_chat: 'Limpar Chat',
    ai_chat_settings: 'Configurações',
    ai_chat_choose_provider: 'Escolha o Provedor de IA',
    ai_chat_openai_info: 'Insira sua chave API OpenAI para usar modelos GPT',
    ai_chat_anthropic_info: 'Insira sua chave API Anthropic para usar modelos Claude',
    ai_chat_openai_info_tooltip: 'Você pode obter uma chave API em platform.openai.com',
    ai_chat_anthropic_info_tooltip: 'Você pode obter uma chave API em console.anthropic.com',
    ai_chat_cancel: 'Cancelar',
    ai_chat_save: 'Salvar',
    ai_chat_provider: 'Provedor de IA',
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'Configurar Chave API',
    ai_chat_try_asking: 'Tente perguntar sobre:',
    ai_chat_suggestions_tooltip: 'Sugestões',
    ai_chat_suggestion_1: 'Como posso criar um link de pagamento?',
    ai_chat_suggestion_2: 'Reembolsar o valor total do pagamento {paymentid}',
    ai_chat_suggestion_3: 'Qual é o status do meu último link de pagamento?',
    ai_chat_suggestion_4: 'O pedido {order_id} já foi pago?',
    ai_chat_suggestion_5: 'Criar um link de pagamento para {amount} {currency} com referência {reference} e enviar para {email}',
    ai_chat_suggestion_6: 'Buscar pedidos com referência {order_ref} criados ontem',
    ai_chat_confirm_clear: 'Tem certeza que deseja limpar todas as mensagens do chat?',
    ai_chat_confirm_yes: 'Sim',
    ai_chat_confirm_no: 'Não',
    'accessible-merchants': 'Comerciantes acessíveis',
    'accessible-stores': 'Lojas acessíveis',
    'accessible-units': 'Unidades acessíveis',
    accept: 'Aceitar',
    accepted: 'Aceite',
    acquirer: 'Adquirente',
    'acquirer-response': 'Resposta do Adquirente',
    'acquirer-response-code': 'Código de Resposta da Adquirente',
    'acquirer-response-message': 'Mensagem de Resposta da Adquirente',
    acquirerfailed: 'Falhou',
    acquirerReferenceNumber: 'Referência do Adquirente (ARN)',
    acquirerResponseCode: 'Código de resposta da Adquirente',
    acquirerResponseMessage: 'Mensagem de resposta da Adquirente',
    acquirersuccess: 'Successo',
    actions: 'Ações',
    add: 'Adicionar',
    'add-filter': 'Adicionar filtro',
    'administration-title': 'Administração',
    all: 'Todos(as)',
    'available-columns': 'Colunas Disponíveis',
    amount: 'Valor',
    'amount-greater-than-limit': 'O valor é maior do que o valor da transação',
    'analytics-title': 'Analytics',
    'api-key-not-created': 'API Key não foi criada',
    'api-key-copied': 'API Key copiada para a área de transferência',
    'no-api-keys-title': 'Nenhuma API Key encontrada',
    'no-api-keys-description': 'Crie API keys para começar a integrar com nossa plataforma',
    'copy-to-clipboard': 'Copiar para a área de transferência',
    'api-keys': 'API Keys',
    channel: 'Canal',
    apply: 'Aplicar',
    'apply-filters': 'Aplicar Filtros',
    'applied-filters': 'O filtro será aplicado ao seu dashboard',
    'aquirer-authorization-code': 'Código de autorização da adquirente',
    aquirerAuthorizationCode: 'Código de autorização da adquirente',
    'attachment-not-found-error': 'Anexo não encontrado',
    attempt: 'Tentativa',
    back: 'Voltar',
    'back-to-payouts': 'Voltar para pagamentos',
    'batch-id': 'Ref. do Lote',
    brand: 'Método de Pagamento',
    cardScheme: 'Bandeira',
    wallet: 'Carteira digital',
    businessName: 'Nome da Loja',
    cancel: 'Cancelar',
    canceled: 'Cancelado',
    capture: 'Cativação',
    'capture-create-success': 'Captura criada com sucesso',
    'capture-transaction': 'Transação de cativação',
    captured: 'Capturada',
    capturing: 'Efetuando a captura',
    'card-holder-name': 'Nome no cartão',
    'card-number': 'Número do cartão',
    cardHolderName: 'Titular do cartão',
    cardNumber: 'Número do cartão',
    category: 'Categoria',
    'custom-filters': 'Filtros personalizados',
    modes: 'Modalidades',
    chargeback: 'Disputa',
    'chargeback-chat': 'Comunicações do processo de Disputa',
    'chargeback-create-success': 'Chargeback criado com sucesso',
    'chargeback-confirm-attachment-delete': 'Eliminar anexo?',
    'chargeback-files': 'Ficheiros associados',
    'chargeback-information': 'Informação geral',
    'chargeback-order-creationReason': 'Razão para criação do Chargeback',
    'chargeback-order-information': 'Informação da Order',
    'chargeback-ref': 'Referencia',
    'chargeback-store-information': 'Informação da Loja',
    'chargeback-store-name': 'Nome da Loja',
    'chargeback-title': 'Disputas',
    'chargeback-title-add': 'Iniciar processo de Disputa',
    'chargeback-transaction-information': 'Informação da Transação',
    chargebackRef: 'Referencia da disputa',
    chargebacks: 'Chargebacks',
    'choose-file-type': 'Escolhe o tipo de ficheiro',
    clear: 'Limpar',
    'click-to-upload': 'Clique aqui para carregar',
    'client-frequent-flyer-number': 'Número de passageiro frequente',
    clientFrequentFlyerNumber: 'Número de Passageiro Frequente',
    clientFrequentFlightNumber: 'Número de Passageiro Frequente',
    closed: 'Fechado',
    code: 'Código',
    'collect-shipping-data': 'Dados de envio',
    content: 'Conteúdo',
    'copied-link': 'Link {1} copiado para a área de transferência!',
    costs: 'Custos',
    country: 'País',
    'country-code': 'Código do país',
    'create-chargeback-from-transaction': 'Criar Disputa',
    'create-checkout': 'Criar Check-out',
    created: 'Criado',
    'created-date': 'Data de criação',
    creating: 'Criando...',
    currency: 'Moeda',
    'current-balance': 'Balanço corrente',
    'dashboard-title': 'Painel de Controlo',
    date: 'Data',
    day: 'Dia',
    days: 'Dias',
    dccAmount: 'Valor DCC',
    'activate-user': 'Ativar usuário',
    'deactivate-user': 'Desativar usuário',
    declined: 'Recusado',
    deductions: 'Deduções',
    'delete-attachment-forbidden-error': 'Deleção do anexo não permitida',
    denied: 'Negado',
    description: 'Descrição',
    details: 'Detalhes',
    'developers-description': 'Por favor, mantenha-os privados tanto quanto possível.',
    'developers-link': 'Ler mais sobre como integrar a API',
    'developers-subtitle': 'Use a API Key de teste para testar a sua integração, e a Live API key para criar pagamentos reais.',
    'developers-title': 'Desenvolvedores',
    disputing: 'Em disputa',
    'drag-drop-file-here': 'Arrastar ficheiro para aqui',
    download: 'Download',
    downloading: 'Descarregando...',
    doYouWannaFullChargeback: 'Você quer fazer um estorno parcial ou completo?',
    doYouWannaFullRefund: 'Você quer fazer um reembolso parcial ou total?',
    dutch: 'Holandês',
    ecommerce: 'E-commerce',
    'edit-checkout': 'Editar check-out',
    'edit-checkout-success': 'Social Payment editado com sucesso',
    'edit-data': 'Editar dados',
    editing: 'Editando...',
    email: 'E-mail',
    'end-date': 'Data fim',
    'end-time': 'Hora de fim',
    english: 'Inglês',
    environment: 'Ambiente',
    'environment-hint': 'Marcar para ver transações de Produção. Desmarcar para ver transações de Teste.',
    error: 'Erro',
    'event-type': 'Tipo de Evento',
    'expire-at': 'Expira em',
    expired: 'Expirado',
    export: 'Exportar $1',
    'export-details': 'Exportação',
    'export-details-help':
      'Quando começar a exportar o seu ficheiro, o nosso sistema irá processar o seu pedido. Depois da conclusão do processamento, enviaremos o ficheiro exportado directamente para o e-mail associado à sua conta ($1).',
    'export-details-alert': 'Atenção',
    externalTransactionId: 'ID da transação externa',
    externalCustomId: 'Identificador do adquirente',
    'extra-filters-title': 'Filtros customizados',
    failed: 'Falhou',
    fees: 'Taxas',
    'file-sent': '$1 foi enviado',
    'file-upload-helper': 'Para efetuar upload de um arquivo, clique no rótulo da entrada',
    'filter-by': 'Filtrar por $1',
    'filter-by-enter': 'Filtrar por $1 (Pressione Enter para Pesquisar)',
    firstname: 'Primeiro nome',
    'forgot-password': 'Esqueceu-se da sua Password?',
    french: 'Francês',
    fulfilled: 'Realizada',
    'full-chargeback': 'Estorno completo',
    'full-refund': 'Reembolso total',
    'full-capture': 'Captura completa',
    german: 'Alemão',
    'getting-started-title': 'Início',
    'go-to': 'Ir para $1',
    group: 'Grupo',
    groups: 'Grupos',
    'group-id': 'ID do grupo',
    groupId: 'Grupo',
    hasChargeback: 'Tem Chargeback',
    hour: 'Hora',
    hours: 'Horas',
    'transaction-history': 'Histórico de Transações',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'em $1 transações',
    initiatedFrom: 'Inciado por',
    'international-shipping-amount': 'Valor do envio internacional',
    'international-urgent-shipping-amount': 'Valor do envio internacional urgente',
    'invite-error': 'Ocorreu um erro ao enviar o convite.',
    'invite-merchants': 'Convidar Comerciantes',
    'invite-sent': 'O convite foi enviado para $1. Formulário de Onboarding gerado em: $2',
    invoice: 'Fatura',
    invoices: 'Faturas',
    'is-one-click-payment': 'Pagamento com um clique',
    isoAmount: 'Valor',
    isOneClickPayment: 'Pagamento um clique',
    'item-service-amount': 'Preço do produto/serviço',
    'item-service-description': 'Descrição do produto/serviço',
    'item-service-image': 'Upload de imagem de produto/serviço',
    'item-service-name': 'Nome do produto/serviço',
    language: 'Idioma',
    'last-month': 'Mês passado',
    'last-refunds': 'Ultimo $1 de devoluções',
    'last-revenue': 'Ultimo $1 de receita',
    'last-week': 'Semana passada',
    lastFourCardNumber: 'Últimos digitos do cartão',
    lastname: 'Último nome',
    'latest-payments': 'Últimos Pagamentos (somente produção)',
    'link-validity': 'Validade do link',
    'live-api-key': 'Live API Key',
    loading: 'A carregar...',
    'loading-order': 'A carregar dados do Pedido',
    'loading-ref-transactions': 'A carregar transacções relacionadas',
    'loading-transaction': 'A carregar dados da Transação',
    'loading-webhook-attempts': 'A carregar tentativas de webhook',
    'log-into-paybyrd': 'Log into Paybyrd',
    login: 'Login',
    logout: 'Logout',
    lost: 'Perdida',
    'management-title': 'Gestão',
    'manage-user': 'Gerenciar usuário',
    market: 'Mercado',
    maskedCardNumber: 'Número do cartão',
    merchant: 'Comerciante',
    merchants: 'Comerciantes',
    'merchant-id': 'ID do comerciante',
    'merchant-information': 'Informações do comerciante',
    merchantId: 'Comerciante',
    'message-label': 'Mensagem',
    mode: 'Modo',
    month: 'Mês',
    'monthly-revenue': 'Receita Mensal (somente produção)',
    months: 'Meses',
    name: 'Nome',
    'national-shipping-amount': 'Valor do envio nacional',
    'national-urgent-shipping-amount': 'Valor do envio nacional urgente',
    no: 'Não',
    'no-balance': 'Não foi possível encontrar saldo para os filtros selecionados',
    'no-balance-description': 'Tente selecionar outro mês, ou unidades acima ',
    'no-chargebacks': 'Não houve ocorrências para a seleção de filtros efetuada',
    'no-chargebacks-subtitle': 'Tente selecionar outra combinação de filtros acima',
    'no-info': 'Sem informação',
    'no-invoices': 'Não há faturas para o período selecionado',
    'no-invoices-description': 'Tente selecionar outro ano',
    'no-onboardings': 'Não foi possível encontrar processos de Onboarding para os filtros selecionados',
    'no-onboardings-subtitle': 'Tente outra combinação de filtros',
    'no-options': 'Sem opções',
    'no-orders': 'Não houve ocorrências para a seleção de filtros efetuada',
    'no-orders-subtitle': 'Experimente mudar os filtros',
    'no-payments': 'Nao há registo de transações recentes',
    'no-payments-subtitle': 'Atualize os dados para verificar se existem novas transações',
    'no-ref-transactions': 'Não houve ocorrências relacionadas com este pedido',
    'no-ref-transactions-subtitle': 'Efetue refresh para verificar se existem novas transações,',
    'no-results': 'Sem ocorrências',
    'no-settlements': 'Não foram encontradas liquidações no período selecionado',
    'no-settlements-description': 'Tente selecionar outro mês',
    'no-payouts': 'Não foram encontrados payouts no período selecionado',
    'no-shifts': 'Não houve ocorrências para a seleção de filtros efetuada',
    'no-shifts-subtitle': 'Tente selecionar outro espaço de tempo, unidade, status ou canais acima',
    'no-statistics': 'Não há dados estatísticos para a seleção de filtros efetuada',
    'no-statistics-subtitle': 'Selecione outro período ou unidades acima',
    'no-totals': 'Não há estatísticas dispponíveis para o mês corrente',
    'no-totals-subtitle': 'Verificar páginas de estatísticas para outros períodos',
    'no-transactions': 'Não houve ocorrências para a seleção de filtros efetuada',
    'no-transactions-subtitle': 'Tente selecionar outro espaço de tempo, unidade, status ou canais acima',
    'no-users': 'Não houve ocorrências para a seleção de filtros efetuada',
    'no-users-subtitle': 'Tente selecionar outro filtro ou unidades acima',
    'no-webhooks': 'Não houve ocorrências para a seleção de filtros efetuada',
    none: 'Nenhum',
    'not-confirmed': 'Não confirmado',
    'not-confirmed-message': 'Payout realizado diretamente pela acquirer.',
    'not-visible-columns': 'Colunas Ocultas',
    now: 'Agora',
    onboarding: 'Onboarding',
    'onboarding-details': 'Detalhe do Onboarding',
    onboardings: 'Onboardings',
    opened: 'Aberto',
    'order-amount': 'Montante pedido',
    'order-date': 'Data do pedido',
    'order-ref': 'Ref. do Pedido',
    'order-reference': 'Referencia do Pedido',
    order: 'Pedido',
    orderCreated: 'Pedido Criado',
    noOrderInfo: 'Sem Informações do Pedido',
    'order-details': 'Detalhes do Pedido',
    orderId: 'Id do pedido',
    orderRef: 'Ref. do pedido',
    orderref: 'Ref. do Pedido',
    orders: 'Pedidos',
    'orders-title': 'Pedidos',
    paid: 'Pago',
    'partially captured': 'Parcialmente capturada',
    'partially refunded': 'Parcialmente devolvida',
    'partial-chargeback': 'Estorno parcial',
    'partial-refund': 'Reembolso parcial',
    'partial-capture': 'Captura parcial',
    password: 'Password',
    'pay-by-link-create': 'Criar novo link de pagamento',
    'pay-by-link-description': 'Criar, enviar links de pagamento e receber online',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Link de pagamento',
    'pay-links': 'links de pagamento',
    payment: 'Pagamento',
    'payment-amount': 'Valor do Pagamento',
    'payment-batch-not-found': 'Lote de pagamentos não encontrado',
    'payment-link-error': 'Ocorreu um erro ao enviar os links.',
    'payment-link-success': 'Link de pagamento enviado com sucesso.',
    'payment-method': 'Método de pagamento',
    paymentDetails: 'Detalhes do Pagamento',
    recipientInformation: 'Informações do Destinatário',
    configuration: 'Configuração',
    paymentId: 'Código de Pagamento',
    paymentInformation: 'Informação de pagamento',
    paymentMethod: 'Método de pagamento',
    payments: 'Pagamentos',
    'payment-reference': 'Referência do Pagamento',
    'payments-title': 'Pagamentos',
    'payouts-title': 'Pagamentos',
    'payout-information': 'Informação de Liquidação',
    'payout-title': 'Detalhe $1',
    'payouts-warning-message':
      'Esta funcionalidade encontra-se temporariamente indisponível. Estamos a proceder a melhorias no nosso sistema para o servir ainda melhor. Lamentamos o transtorno causado e seremos breves na reposição desta funcionalidade. Para qualquer esclarecimento adicional, poderão contactar-nos pelos canais habituais.',
    'payout-paid-message': 'Liquidação já processada',
    'payout-pending-message': 'Liquidação ainda não executada',
    'payout-no-info-message': 'Liquidação processada diretamente pelo adquirente',
    pending: 'Pendente',
    pendingaction: 'Ação pendente',
    pendingmerchantaction: 'Ação pendente do comerciante',
    period: 'Período',
    'phone-number': 'Número de telefone',
    phoneNumber: 'Número de telefone',
    pnr: 'PNR',
    portuguese: 'Português',
    pos: 'POS',
    'pre-auth': 'Pré-Autorização',
    preauth: 'Pre-autorização',
    'predictions-dispute': 'Quero abrir uma disputa',
    'preferred-payment-methods': 'Métodos de Pagamento Preferidos',
    'previous-revenue': 'Receita Anterior',
    processing: 'Processando',
    prod: 'Produção',
    quarter: 'Trimestre',
    quarters: 'Trimestres',
    range: 'Calendário',
    reason: 'Razão para iniciar o processo de Chargeback',
    'recipient-email': 'E-mail do destinatário',
    'recipient-name': 'Nome do destinatário ',
    'recipient-number': 'Contacto do destinatário',
    'recover-paybyrd-password': 'Recuperar password',
    'recovery-password-success': 'Foi enviado um e-mail para  redefinir sua password.',
    reference: 'Referência',
    'reference-ids': 'IDs de Referência',
    refresh: 'Atualizar',
    refund: 'Devolução',
    'refund-amount': 'Quantia da devolução',
    'refund-confirm-message': 'Deseja avançar com o refund desta transacção no valor de $1?',
    'refund-transaction': 'Transação de devolução',
    refunded: 'Devolvida',
    refunding: 'Efetuando a devolução',
    refunds: 'Devoluções',
    'refund-create-success': 'Reembolso criado com sucesso',
    'register-now': 'Registar Agora',
    'related-operation-status': 'Status de Operação Relacionado',
    'related-transactions': 'Transações relacionadas',
    relatedOperationStatus: 'Estado da operação associada',
    release: 'Cancelar autorização',
    releasing: 'Cancelando autorização...',
    remark: 'Detalhe',
    'request-info': 'Pedir Informação',
    'required-field': 'Campo é obrigatório',
    resend: 'Reenviar',
    'resend-error': "Ocorreu um erro ao reenviar o webhook '$1'.",
    'resend-success': "O webhook '$1' foi reenviado com sucesso.",
    resending: 'A reenviar...',
    response: 'Resposta',
    revenue: 'Receita',
    'reverse-confirmation': 'Tem certeza de que deseja liberar a transação com o id $1?',
    'reverse-create-success': 'Liberação efetuada com sucesso',
    role: 'Função',
    search: 'Buscar',
    'search-filters': 'Procurar',
    'select-all': 'Selecionar todos',
    'deselect-all': 'Desselecionar todos',
    'select-filter': 'Seleccionar Filtro',
    selected: 'selecionado',
    'selected-s': '$1 $2 selecionado(s)',
    'send-invite': 'Enviar convite',
    'send-link': 'Enviar link',
    'send-links': 'Enviar links',
    'send-message': 'Enviar mensagem',
    'send-message-and-dispute': 'Enviar mensagem e abrir Disputa',
    'send-password-reset': 'Enviar redefinição de senha',
    'send-recover-email': 'Enviar e-mail',
    sending: 'Enviando...',
    'sent-at': 'Enviado em',
    'settings-title': 'Definições',
    'settlement-date': 'Data de Liquidação',
    'settlement-details': 'Detalhe da Liquidação',
    settlements: 'Liquidações',
    settled: 'Liquidado',
    shift: 'Turno $1',
    'shift-id': 'Id do turno',
    'shift-details': 'Detalhes do turno',
    'shifts-title': 'Turnos',
    'shopper-ip-address': 'Endereço de IP do comprador',
    shopperEmail: 'Email do comprador',
    shopperInformation: 'Informações do comprador',
    shopperIp: 'Endereço de IP do comprador',
    'show-accessible-stores': 'Mostrar lojas acessíveis',
    'show-all': 'Mostrar Tudo',
    'hide-all': 'Esconder Tudo',
    'show-details': 'Mostrar detalhes',
    'signed-up-on': 'Cadastrado em $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Espanhol',
    'start-date': 'Data início',
    'start-time': 'Hora de início',
    'statistics-title': 'Estatísticas',
    status: 'Estado',
    stock: 'Estoque',
    'stock-quantity': 'Quantidade de stock',
    store: 'Loja',
    stores: 'Lojas',
    'store-name': 'Nome da loja',
    storeId: 'Loja',
    success: 'Successo',
    'system-language': 'Idioma do Sistema',
    'system-timezone': 'Timezone do sistema',
    'team-users': 'Usuários do sistema',
    terminalPassword: 'Palavra-Passe do Terminal',
    'new-password': 'Nova Palavra-Passe',
    'confirm-new-password': 'Confirme a Palavra-Passe',
    'save-password': 'Salvar Palavra-Passe',
    'changing-password': 'Alterando Palavra-Passe...',
    'confirm-change-password-message': 'Confirma a alteração da Palavra-Passe do Terminal?',
    'passwords-do-not-match-message': 'As Palavras-Passe não coincidem!',
    'change-terminal-password': 'Alterar a Palavra-Passe do Terminal',
    'password-must-have-six-numbers': 'A Palavra-Passe deve ter seis números!',
    'password-changed-successfully': 'Palavra-passe alterada com sucesso!',
    test: 'Teste',
    'test-api-key': 'API Key de teste',
    'this-month': 'Este mês',
    'this-week': 'Esta semana',
    title: 'Título',
    today: 'Hoje',
    total: 'Total',
    'total-amount': 'Valor total',
    'total-revenue': 'Receita total',
    totals: 'Totais',
    'totals-per': 'Totais por $1',
    'transaction-details': 'Detalhes das transações',
    'transaction-type': 'Tipo de Transação',
    transactionId: 'Código de pagamento',
    transactions: 'Transações',
    'transactions-count': 'Número de Transações',
    'transactions-title': 'Transações',
    'transactions-volume': 'Volume de Transações',
    'transactions-multiple-currencies-found': 'Quando várias moedas são selecionadas, o total da receita/montante pode não ser exibido.',
    type: 'Tipo',
    unit: 'Loja',
    units: 'Lojas',
    user: 'Usuário',
    'user-action-title': 'Você tem certeza?',
    'user-action-password-reset-confirmation': 'Você tem certeza de que deseja redefinir a senha do usuário?',
    'user-action-password-reset-success': 'E-mail de redefinição de senha enviado com sucesso!',
    'user-action-activate-user-confirmation': 'Você tem certeza de que deseja ativar o usuário?',
    'user-action-activate-user-success': 'Usuário ativado com sucesso!',
    'user-action-deactivate-user-confirmation': 'Você tem certeza de que deseja desativar o usuário?',
    'user-action-deactivate-user-success': 'Usuário desativado com sucesso!',
    'user-blocked': 'Bloqueado',
    'user-details': 'Detalhes do usuário',
    'user-profile-title': 'Perfil do Usuário',
    'user-profile-subtitle': 'Gerencie suas configurações de conta e preferências',
    'appearance-settings': 'Aparência',
    'appearance-settings-description': 'Personalize o tema visual e preferências de exibição',
    'language-settings': 'Idioma e Região',
    'language-settings-description': 'Defina seu idioma preferido e configurações regionais',
    'timezone-settings': 'Data e Hora',
    'timezone-settings-description': 'Configure seu fuso horário e preferências de formato de data',
    'theme-mode': 'Modo do Tema',
    'theme-mode-description': 'Escolha entre tema claro e escuro',
    'light-mode': 'Claro',
    'dark-mode': 'Escuro',
    'system-language-description': 'Selecione seu idioma preferido para a interface',
    'system-timezone-description': 'Escolha seu fuso horário para exibição precisa de data e hora',
    'connected-stores': 'Lojas Conectadas',
    'dashboard-user': 'Usuário do Dashboard',
    'validation-max-chars': 'O comprimento máximo deste campo é de $1 caracteres',
    'view-by': 'Visualizar por $1',
    'view-details': 'Visualizar detalhes',
    'view-less': 'Ver menos',
    'view-more': '+$1 mais',
    'view-transaction-details-hint': 'Clique para visualizar os detalhes da transação.',
    'visible-columns': 'Colunas Visíveis',
    'hidden-columns': 'Colunas Ocultas',
    'manage-columns': 'Gerenciar Colunas',
    'search-columns': 'Pesquisar colunas...',
    'reset-default': 'Restaurar padrão',
    'no-columns-found': 'Nenhuma coluna encontrada com sua pesquisa',
    volume: 'Volume',
    webhooks: 'Webhooks',
    week: 'Semana',
    weeks: 'Semanas',
    won: 'Ganha',
    year: 'Ano',
    years: 'Anos',
    yes: 'Sim',
    yesterday: 'Ontem',

    // AI Assistant
    ai_smart_assistant_title: 'Assistente IA',
    ai_smart_assistant_smart_suggestions: 'Sugestões Inteligentes',
    ai_smart_assistant_smart_suggestions_description: 'Prompts pré-configurados para operações comerciais comuns. Preencha os detalhes e execute instantaneamente.',
    ai_smart_assistant_your_question: 'Sua Pergunta',
    ai_smart_assistant_selected_request: 'Solicitação Selecionada',
    ai_smart_assistant_ai_response: 'Resposta da IA',
    ai_smart_assistant_ready_help: 'Pronto para ajudar!',
    ai_smart_assistant_ready_help_description: 'Faça sua pergunta ou experimente uma das sugestões inteligentes.',
    ai_smart_assistant_processing: 'Processando sua solicitação...',
    ai_smart_assistant_placeholder_confirm: 'Por favor, confirme ou cancele a ação acima antes de enviar uma nova mensagem...',
    ai_smart_assistant_placeholder_completed: "Solicitação concluída. Clique em 'Nova Solicitação' para iniciar uma nova conversa...",
    ai_smart_assistant_placeholder_default: 'Pergunte-me qualquer coisa sobre os dados da sua loja ou experimente as sugestões inteligentes...',
    ai_smart_assistant_new_request: 'Nova Solicitação',
    ai_smart_assistant_send: 'Enviar',
    ai_smart_assistant_request_canceled: 'A solicitação foi cancelada pelo usuário.',
    ai_smart_assistant_processing_button: 'Processando...',
    ai_smart_assistant_characters: 'caracteres',
    ai_smart_assistant_tip:
      '💡 Dica: Use Ctrl+Enter para enviar • Experimente as sugestões inteligentes para ações rápidas • Pedirei confirmação antes de realizar operações sensíveis',
    ai_smart_assistant_confirmation_required: 'Confirmação Necessária',
    ai_smart_assistant_confirmation_description: 'Por favor, revise a resposta abaixo e confirme se deseja prosseguir.',
    ai_smart_assistant_confirm: 'Confirmar',
    ai_smart_assistant_cancel: 'Cancelar',
    ai_smart_assistant_store_selection: 'Seleção de Loja',
    ai_smart_assistant_search_stores: 'Digite para pesquisar lojas...',
    ai_smart_assistant_configure_api_key: 'Configurar Chave API',
    ai_smart_assistant_help: 'Ajuda',
    ai_smart_assistant_help_tooltip: 'Ver documentação do Assistente Inteligente IA',

    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Exportar Pedidos',
    ai_smart_suggestion_export_orders_description: 'Exportar todos os pedidos pagos de ontem',
    ai_smart_suggestion_create_payment_link: 'Criar Link de Pagamento',
    ai_smart_suggestion_create_payment_link_description: 'Gerar um link de pagamento com detalhes personalizados',
    ai_smart_suggestion_create_payment_link_template: 'Criar link de pagamento com referência {orderRef} de {amount} {currency} e enviar para {email}',
    ai_smart_suggestion_refund_transaction: 'Reembolsar Transação',
    ai_smart_suggestion_refund_transaction_description: 'Processar um reembolso para uma transação específica',
    ai_smart_suggestion_refund_transaction_template: 'Reembolsar transação {transactionId} por {amount} {currency}',
    ai_smart_suggestion_order_reference: 'Referência do Pedido',
    ai_smart_suggestion_order_reference_placeholder: 'ex., PED-001',
    ai_smart_suggestion_amount: 'Valor',
    ai_smart_suggestion_amount_placeholder: 'ex., 50,00',
    ai_smart_suggestion_currency: 'Moeda',
    ai_smart_suggestion_currency_placeholder: 'Selecionar moeda',
    ai_smart_suggestion_customer_email: 'Email do Cliente',
    ai_smart_suggestion_customer_email_placeholder: 'cliente@exemplo.com',
    ai_smart_suggestion_execute: 'Executar',
    ai_smart_suggestion_missing_fields: 'Por favor, preencha todos os campos obrigatórios:',
    ai_smart_suggestion_retrieve_transaction: 'Buscar Detalhes da Transação',
    ai_smart_suggestion_retrieve_transaction_description: 'Obter informações detalhadas sobre uma transação específica',
    ai_smart_suggestion_retrieve_transaction_template: 'Por favor, busque os detalhes para a transação ID {transactionId}',
    ai_smart_suggestion_transaction_id: 'ID da Transação',
    ai_smart_suggestion_transaction_id_placeholder: 'ex: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: 'Formato de Exportação',
    ai_smart_suggestion_export_format_placeholder: 'Selecionar formato',
    ai_smart_suggestion_export_orders_template_with_format: 'Por favor, exporte todos os pedidos pagos de ontem no formato {format} e envie para meu email',
    ai_smart_suggestion_find_order: 'Buscar Pedido por ID',
    ai_smart_suggestion_find_order_description: 'Obter informações detalhadas sobre um pedido específico',
    ai_smart_suggestion_find_order_template: 'Por favor, busque o pedido com ID {orderId}',
    ai_smart_suggestion_order_id: 'ID do Pedido',
    ai_smart_suggestion_order_id_placeholder: 'ex: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Pesquisar Pedidos por Referência',
    ai_smart_suggestion_search_orders_by_ref_description: 'Buscar pedidos recentes por referência (7 dias)',
    ai_smart_suggestion_search_orders_by_ref_template: 'Pesquisar pedidos com referência {orderRef} dos últimos 7 dias',

    // History
    ai_smart_assistant_request_history: 'Histórico de Solicitações',
    ai_smart_assistant_clear_all: 'Limpar Tudo',
    ai_smart_assistant_no_history: 'Ainda sem histórico',
    ai_smart_assistant_no_history_description: 'Suas solicitações de IA serão salvas aqui para fácil acesso.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: 'Desculpe, encontrei um erro ao processar sua confirmação.',
    ai_smart_assistant_error_request: 'Desculpe, encontrei um erro ao processar sua solicitação.',
    ai_smart_assistant_error_api_key: 'Chave API é necessária. Por favor, configure-a primeiro.',
    ai_smart_assistant_error_invalid_api_key: 'Chave API inválida. Por favor, verifique sua configuração.',
    ai_smart_assistant_error_auth: 'Problema de autenticação. Por favor, tente fazer login novamente.',
    // user roles
    'user-role': 'Função',
    'user-role-admin': 'Administrador',
    'user-role-manager': 'Gerente',
    'user-role-developer': 'Desenvolvedor',
    'user-role-finance': 'Financeiro',
    'user-role-operator': 'Operador',
    'user-role-user': 'Usuário',

    // Getting Started
    welcome: 'Bem-vindo',
    'welcome-back': 'Bem-vindo de volta',
    'try-paybyrd': 'Experimente a Paybyrd',
    'try-paybyrd-description':
      'Conecte a Paybyrd ao seu site ou plataforma usando nossa chave de API de teste para explorar o processo de integração. Assim que sua conta for aprovada, você receberá sua chave de API real para começar a aceitar pagamentos.',
    'try-paybyrd-cta': 'API de Teste',
    'resume-registration': 'Retomar Cadastro',
    'resume-registration-description': 'Ainda precisamos de algumas informações e documentos seus. Retome o processo de cadastro para completá-lo — você continuará de onde parou.',
    'resume-registration-help': 'Precisa de ajuda? Acesse nosso artigo ou fale conosco via chat. ',
    'resume-registration-link': 'Cadastro com a Paybyrd',
    'resume-registration-cta': 'Retomar processo',
    'init-registration': 'Comece com a Paybyrd',
    'init-registration-description':
      'Para começar a aceitar pagamentos, você precisa concluir o processo de integração legal. Tenha os seguintes documentos e informações prontos — você pode pausar e continuar quando quiser.',
    'company-details': 'Dados da empresa',
    'shareholder-information': 'Informações dos sócios',
    'bank-account-details': 'Dados bancários',
    'business-activity-overview': 'Resumo da atividade empresarial',
    'init-registration-help': '👉 Precisa de mais detalhes? Confira nosso artigo de ajuda: ',
    'init-registration-link': 'Cadastro com a Paybyrd',
    'start-registration-cta': 'Iniciar cadastro',
    'submitted-registration': 'Cadastro enviado!',
    'submitted-registration-description':
      'Nossa equipe está analisando seu cadastro. Vamos te atualizar por e-mail em até cinco dias úteis, conforme finalizamos a configuração. Se precisar cadastrar mais estabelecimentos, enviaremos um link de convite separadamente.',
    'submitted-registration-help': 'Tem dúvidas? Acesse nosso Centro de Ajuda ou fale conosco pelo chat.',
    'submitted-registration-cta': 'Ir para o Centro de Ajuda',
    'go-to-dashboard-cta': 'Ir para o Painel',
    'start-next-onboarding-cta': 'Iniciar próximo Onboarding',
    processingData: 'Processamento de Dados',
    'parent-payment-id': 'ID do Pagamento Principal',
    acquirerId: 'ID do Adquirente',
    'shift-code': 'Código de Turno',
    'providing-access-to': 'A fornecer acesso a $1',
    'provide-access': 'Conceder acesso',
    'select-units-type-to-add': 'Selecione o tipo de unidade a adicionar',
    'access-updated': 'Acesso atualizado!',
    'add-new-access-units': 'Adicionar nova unidade de acesso',
    'confirm-updating-access': 'Confirmar atualização de acesso',
    'select-group-add': 'Selecione o grupo a adicionar',
    'select-merchant-add': 'Selecione o comerciante a adicionar',
    'select-store-add': 'Selecione a loja a adicionar',
    'all-merchants': 'Todos os comerciantes',
    'all-stores': 'Todas as lojas',
    'no-units-selected': 'Nenhuma unidade selecionada',
    'remove-access': 'Remover acesso',
    'are-you-sure-remove-group': 'Tem a certeza de que pretende remover o grupo?',
    'are-you-sure-remove-merchant': 'Tem a certeza de que pretende remover o comerciante?',
    'are-you-sure-remove-store': 'Tem a certeza de que pretende remover a loja?',
    next: 'Seguinte',
    'success-remove-unit': 'Unidade removida com sucesso',
    'selected-items': '$1 $2 selecionados',
    item: 'item',
    items: 'itens',
    'no-unit-selected-label': 'Se nenhuma unidade for selecionada, todas as unidades disponíveis serão adicionadas ao utilizador',
    'paybyrd-user': 'Utilizador da Paybyrd com acesso a todos os comerciantes',
    'no-groups': 'Não conseguimos encontrar grupos para o utilizador selecionado',
    'no-groups-subtitle': 'Pode adicionar novas unidades de acesso usando o botão acima',
    'no-merchants': 'Não conseguimos encontrar comerciantes para o utilizador selecionado',
    'no-merchants-subtitle': 'Pode adicionar novas unidades de acesso usando o botão acima',
    'no-stores': 'Não conseguimos encontrar lojas para o utilizador selecionado',
    'no-stores-subtitle': 'Pode adicionar novas unidades de acesso usando o botão acima',
    'invite-new-users': 'Convidar novos utilizadores',
    'add-emails': 'Adicionar e-mails',
    'enter-valid-email': 'Por favor, introduza um e-mail válido.',
    'invite-new-user': 'Convidar novo utilizador',
    invite: 'Convidar',
    close: 'Fechar',
    'feature-access': 'Acesso a funcionalidades',
    'view-feature-access': 'Ver lista de funcionalidades de acesso',
    'paybylink-description': 'Permite criar e gerir links de pagamento.',
    'shifts-description': 'Permite a criação de turnos.',
    'successfull-invite': 'Convite enviado com sucesso!',
    'manage-role': 'Gerir função e acesso',
    'changing-user-roles': 'A alterar a função do utilizador',
    'role-operator': 'Permite a ação selecionada nas áreas acessíveis.',
    'role-observer': 'Permite a ação selecionada nas áreas acessíveis.',
    'role-admin': 'Permite controlo total nas áreas acessíveis.',
    current: 'Atual',
    save: 'Guardar',
    transactionPayout: 'Pagamento da Transação',
    paymentReference: 'Referência de Pagamento',
    threeDSecure: '3D Secure',
    installments: 'Parcelas',
    installmentAmount: 'Valor da Parcela',
    cardIssuerCountry: 'País do Emissor do Cartão',
    authorizationCode: 'Código de Autorização',
    LiabilityShift: 'Transferência de Responsabilidade',
    version: 'Versão',
    transStatus: 'Estado da Transação 3DS',
    authorizationStatus: 'Estado da Autorização 3DS',
    challengeOptions: 'Opções de Desafio 3DS',
    protocolVersion: 'Versão do Protocolo',
    'settlement-status': 'Liquidação',
    eci: 'ECI',
    done: 'Concluído',
    inProgress: 'Em andamento',
  },
  es: {
    'enter-exact-amount': 'Introduzca el importe exacto',
    'select-currency': 'Seleccione la moneda',
    summary: 'Resumen',
    ai_chat_title: 'Asistente de Chat IA',
    ai_chat_beta: 'BETA',
    ai_chat_greeting:
      '¡Hola! Soy tu asistente de IA de Paybyrd. ¿Cómo puedo ayudarte hoy? Puedo asistirte con procesamiento de pagos, consultas de transacciones, reembolsos y más.',
    ai_chat_placeholder: 'Escribe tu mensaje aquí...',
    ai_chat_send: 'Enviar mensaje',
    ai_chat_close: 'Cerrar chat',
    ai_chat_loading: 'Pensando...',
    ai_chat_error: 'Lo siento, ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.',
    ai_chat_footer: 'El asistente de IA está en beta. Para problemas críticos, contacta con soporte.',
    ai_chat_store_selection: 'Selecciona una tienda para contexto',
    ai_chat_select_store_warning: 'Para ayuda más específica, selecciona una tienda primero.',
    ai_chat_api_key_required: 'Se requiere clave API',
    ai_chat_api_key_invalid: 'Clave API inválida. Por favor verifica e intenta de nuevo.',
    ai_chat_api_key_missing: 'Clave API no configurada. Configura tu clave API para usar el asistente de IA.',
    ai_chat_api_key_configure: 'Configurar',
    ai_chat_api_key_clear: 'Borrar Clave',
    ai_chat_api_key: 'Clave API',
    ai_chat_api_key_privacy: 'Tu clave API se almacena de forma segura en el almacenamiento local de tu navegador y solo se utiliza para comunicarse con el servicio de IA.',
    ai_chat_api_config: 'Configuración de IA',
    ai_chat_clear_chat: 'Limpiar Chat',
    ai_chat_settings: 'Ajustes',
    ai_chat_choose_provider: 'Elige Proveedor de IA',
    ai_chat_openai_info: 'Introduce tu clave API de OpenAI para usar modelos GPT',
    ai_chat_anthropic_info: 'Introduce tu clave API de Anthropic para usar modelos Claude',
    ai_chat_openai_info_tooltip: 'Puedes obtener una clave API en platform.openai.com',
    ai_chat_anthropic_info_tooltip: 'Puedes obtener una clave API en console.anthropic.com',
    ai_chat_cancel: 'Cancelar',
    ai_chat_save: 'Guardar',
    ai_chat_provider: 'Proveedor de IA',
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'Configurar Clave API',
    ai_chat_try_asking: 'Intenta preguntar sobre:',
    ai_chat_suggestions_tooltip: 'Sugerencias',
    ai_chat_suggestion_1: '¿Cómo puedo crear un enlace de pago?',
    ai_chat_suggestion_2: 'Reembolsar el monto total del pago {paymentid}',
    ai_chat_suggestion_3: '¿Cuál es el estado de mi último enlace de pago?',
    ai_chat_suggestion_4: '¿Ya se pagó el pedido {order_id}?',
    ai_chat_suggestion_5: 'Crear un enlace de pago por {amount} {currency} con referencia {reference} y enviar a {email}',
    ai_chat_suggestion_6: 'Buscar pedidos con referencia {order_ref} creados ayer',
    ai_chat_confirm_clear: '¿Estás seguro de que deseas borrar todos los mensajes del chat?',
    ai_chat_confirm_yes: 'Sí',
    ai_chat_confirm_no: 'No',
    'accessible-merchants': 'Comerciantes accesibles',
    'accessible-stores': 'Tiendas accesibles',
    'accessible-units': 'Unidades accesibles',
    accept: 'Aceptar',
    accepted: 'Aceptado',
    acquirer: 'Adquirente',
    'acquirer-response': 'Respuesta del adquirente',
    'acquirer-response-code': 'Código de respuesta del adquirente',
    'acquirer-response-message': 'Mensaje de respuesta del adquirente',
    acquirerfailed: 'Falló',
    acquirerReferenceNumber: 'Número de referencia del adquirente (ARN)',
    acquirerResponseCode: 'Código de respuesta del adquirente',
    acquirerResponseMessage: 'Mensaje de respuesta del adquirente',
    acquirersuccess: 'Éxito',
    actions: 'Acciones/Opciones',
    add: 'Crear',
    'add-filter': 'Añadir filtro',
    'administration-title': 'Administración',
    all: 'Todo',
    amount: 'Cantidad',
    'amount-greater-than-limit': 'El monto es mayor que el monto de la transacción',
    'analytics-title': 'Analítica',
    'api-key-not-created': 'API Key no ha sido creada',
    'api-key-copied': 'API Key copiada al portapapeles',
    'no-api-keys-title': 'No se encontraron API Keys',
    'no-api-keys-description': 'Crea API keys para comenzar a integrar con nuestra plataforma',
    'copy-to-clipboard': 'Copiar al portapapeles',
    'api-keys': 'API Keys',
    channel: 'Canal',
    apply: 'Aplicar',
    'apply-filters': 'Aplicar filtros',
    'applied-filters': 'El filtro se aplicará a tu tablero',
    'aquirer-authorization-code': 'Código de autorización del adquirente',
    aquirerAuthorizationCode: 'Código de autorización del adquirente',
    'attachment-not-found-error': 'No se encontró el archivo',
    attempt: 'Intento',
    back: 'Regresar',
    'back-to-payouts': 'Volver a los pagos',
    'batch-id': 'Identificador de lote',
    brand: 'Marca',
    cardScheme: 'Card Scheme',
    wallet: 'Digital Wallet',
    businessName: 'Nombre comercial',
    cancel: 'Cancelar',
    canceled: 'Cancelado',
    capture: 'Capturar',
    'capture-create-success': 'Captura creada con éxito',
    'capture-transaction': 'Captura de transacciones',
    captured: 'Capturado',
    capturing: 'Capturando...',
    'card-holder-name': 'Titular de la tarjeta',
    'card-number': 'Número de tarjeta',
    cardHolderName: 'Titular de la tarjeta',
    cardNumber: 'Número de tarjeta',
    category: 'Categoría',
    'custom-filters': 'Filtros personalizados',
    modes: 'Modos',
    chargeback: 'Contracargo',
    'chargeback-chat': 'Comunicación del proceso de Contracargo',
    'chargeback-create-success': 'Contracargo creado con éxito',
    'chargeback-confirm-attachment-delete': '¿Eliminar archivo?',
    'chargeback-files': 'Ficheros del proceso de Contracargo',
    'chargeback-information': 'Informaciones generales',
    'chargeback-order-creationReason': 'Creación del motivo de Contracargo',
    'chargeback-order-information': 'Información de pedido',
    'chargeback-ref': 'Referencia',
    'chargeback-store-information': 'Información de la tienda',
    'chargeback-store-name': 'Nombre de la tienda',
    'chargeback-title': 'Contracargos',
    'chargeback-title-add': 'Iniciar el proceso de Contracargo',
    'chargeback-transaction-information': 'Información sobre la transación',
    chargebackRef: 'Referencia del Contracargo',
    chargebacks: 'Contracargos',
    'choose-file-type': 'Elija el tipo de archivo',
    clear: 'Limpiar',
    'click-to-upload': 'Haga clic aquí para cargarlo',
    'client-frequent-flyer-number': 'Número de Viajero Frecuente',
    clientFrequentFlyerNumber: 'Número de Viajero Frecuente',
    clientFrequentFlightNumber: 'Número de Viajero Frecuente',
    closed: 'Terminado',
    code: 'Código',
    'collect-shipping-data': 'Recopilar datos de envío',
    content: 'Contenido',
    'copied-link': '¡Enlace {1} copiado al área de transferencia!',
    costs: 'Costes',
    country: 'País',
    'country-code': 'Código postal',
    'create-chargeback-from-transaction': 'Crear Contracargo',
    'create-checkout': 'Crear pago',
    created: 'Creado',
    'created-date': 'Fecha de creación',
    creating: 'Creando...',
    currency: 'Moneda',
    'current-balance': 'Saldo actual',
    'dashboard-title': 'Panel de Control',
    date: 'Fecha',
    day: 'Dia',
    days: 'Dias',
    dccAmount: 'Monto de DCC',
    'activate-user': 'Activar usuario',
    'deactivate-user': 'Desactivar usuario',
    declined: 'Rechazado',
    deductions: 'Deducciones',
    'delete-attachment-forbidden-error': 'No se puede eliminar el archivo',
    denied: 'Denegado',
    description: 'Descripción',
    details: 'Detalles',
    'developers-description': 'Por favor, manténgalos en privado en la medida de lo posible.',
    'developers-link': 'Más información sobre cómo integrar la API',
    'developers-subtitle': 'Utilizar la API Key de prueba para probar su integración, y la Live API Key en vivo para crear pagos reales.',
    'developers-title': 'Desarrolladores',
    disputing: 'En Disputa',
    'drag-drop-file-here': 'Arrastre el archivo aquí',
    download: 'Descargar',
    downloading: 'Descargando...',
    doYouWannaFullChargeback: '¿Quieres hacer un reembolso parcial o completo?',
    doYouWannaFullRefund: '¿Quieres hacer un reembolso parcial o total?',
    dutch: 'Holandés',
    ecommerce: 'E-commerce',
    'edit-checkout': 'Editar pago',
    'edit-checkout-success': 'Social Payment editado con éxito',
    'edit-data': 'Editar Datos',
    editing: 'Edición...',
    email: 'E-mail',
    'end-date': 'Fecha de cierre',
    'end-time': 'Hora de finalización',
    english: 'Inglés',
    environment: 'Ambiente',
    'environment-hint': 'Seleccione esta opción para ver sólo las transacciones de producción. Desmarque esta opción para ver sólo las transacciones de prueba',
    error: 'Error',
    'event-type': 'Tipo de Evento',
    'expire-at': 'Caduca a las',
    expired: 'Expirado',
    export: ' Exportar $1',
    'export-details': 'Exportación',
    'export-details-help':
      'Cuando inicia la exportación de su archivo, nuestro sistema procesará su solicitud. Al finalizar el proceso, enviaremos el archivo exportado directamente al correo asociado a su cuenta ($1).',
    'export-details-alert': 'Atención',
    externalTransactionId: 'ID de Transacción Externa',
    externalCustomId: 'Identificación del adquirente',
    'extra-filters-title': 'Filtros personalizados',
    failed: 'Falló',
    fees: 'Tasas',
    'file-sent': '$1 fue enviado.',
    'file-upload-helper': 'Para cargar un archivo, haga clic en la etiqueta de la entrada',
    'filter-by': 'Filtrar por $1',
    'filter-by-enter': 'Filtrar por $1 (Presione Enter para Buscar)',
    firstname: 'Nombre',
    'forgot-password': '¿Ha olvidado su contraseña?',
    french: 'Francés',
    fulfilled: 'Realizado',
    'full-chargeback': 'Reembolso completo',
    'full-refund': 'Reembolso total',
    'full-capture': 'Captura completa',
    german: 'Alemán',
    'getting-started-title': 'Inicio',
    'go-to': 'Ir para $1',
    group: 'Grupo',
    groups: 'Grupos',
    'group-id': 'Identificación del grupo',
    groupId: 'Grupo',
    hasChargeback: 'Contracargos asociados',
    'hide-all': 'Ocultar Todo',
    'manage-columns': 'Gestionar Columnas',
    'search-columns': 'Buscar columnas...',
    'reset-default': 'Restaurar por defecto',
    'hidden-columns': 'Columnas Ocultas',
    'no-columns-found': 'No se encontraron columnas que coincidan con su búsqueda',
    hour: 'Hora',
    hours: 'Horas',
    'transaction-history': 'Historial de Transacciones',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'en $1 transacciones',
    initiatedFrom: 'Iniciado desde',
    'international-shipping-amount': 'Importe del envío internacional',
    'international-urgent-shipping-amount': 'Importe del envío urgente internacional',
    'invite-error': 'Hubo un error al enviar la invitación.',
    'invite-merchants': 'Invitar Comerciantes',
    'invite-sent': 'La invitación fue enviada a $1. Onboarding generado: $2',
    invoice: 'Factura',
    invoices: 'Facturas',
    'is-one-click-payment': 'Is one click',
    isoAmount: 'Monto',
    isOneClickPayment: 'Is one click',
    'item-service-amount': 'Importe del artículo/servicio',
    'item-service-description': 'Descripción del Artículo/Servicio',
    'item-service-image': 'Cargar imagen de artículo/servicio',
    'item-service-name': 'Nombre del produto/servicio',
    language: 'Idioma',
    'last-month': 'El mes pasado',
    'last-refunds': 'Último $1 de devoluciones',
    'last-revenue': 'Último $1 de ingresos',
    'last-week': 'La semana pasada',
    lastFourCardNumber: 'Últimos Cuatro Dígitos de la Tarjeta',
    lastname: 'Apellido',
    'latest-payments': 'Últimos pagos (sólo producción)',
    'link-validity': 'Vigencia del Link',
    'live-api-key': 'Live API Key',
    loading: 'Cargando...',
    'loading-order': 'Cargando Datos del Pedido',
    'loading-ref-transactions': 'Cargando Transacciones Relacionadas',
    'loading-transaction': 'Cargando Transacción',
    'loading-webhook-attempts': 'Cargando intentos de webhook',
    'log-into-paybyrd': 'Login para Paybyrd',
    login: 'Iniciar sesión',
    logout: 'Terminar sesión',
    lost: 'Perdido',
    'management-title': 'Gestión',
    'manage-user': 'Administrar usuario',
    market: 'Mercado',
    maskedCardNumber: 'Masked Card Number',
    merchant: 'Comerciante',
    merchants: 'Comerciante',
    'merchant-id': 'Identificación del comerciante',
    'merchant-information': 'Información del Comerciante',
    merchantId: 'Comerciante',
    'message-label': 'Mensaje',
    mode: 'Modo',
    month: 'Mês',
    'monthly-revenue': 'Ingresos mensuales (sólo producción)',
    months: 'Meses',
    name: 'Nombre',
    'national-shipping-amount': 'Importe del envío nacional',
    'national-urgent-shipping-amount': 'Importe del envío urgente nacional',
    no: 'No',
    'no-balance': 'No pudimos encontrar el saldo para los filtros seleccionados,',
    'no-balance-description': 'Intente cambiar el filtro',
    'no-chargebacks': 'No hemos podido encontrar Contracargos para los filtros seleccionados',
    'no-chargebacks-subtitle': 'Intente cambiar el filtro',
    'no-info': 'Sin información',
    'no-invoices': 'Parece que no hay facturas para el periodo seleccionado',
    'no-invoices-description': 'Intente seleccionar otro año',
    'no-onboardings': 'No pudimos encontrar procesos de onboarding para los filtros actuales,',
    'no-onboardings-subtitle': 'Pruebe otra combinación de filtros',
    'no-options': 'Sin opciones',
    'no-orders': 'No hemos podido encontrar transacciones para los filtros seleccionados',
    'no-orders-subtitle': 'Pruebe a seleccionar otra franja horaria, unidad, estado o canales anteriores',
    'no-payments': 'No hay registro de transacciones recientes',
    'no-payments-subtitle': 'Pruebe en actualizar la tabla para comprobar si hay nuevas transacciones',
    'no-ref-transactions': 'No hemos podido encontrar transacciones para los filtros seleccionados',
    'no-ref-transactions-subtitle': 'Pruebe en actualizar la tabla para comprobar si hay nuevas transacciones',
    'no-results': 'No hay resultados',
    'no-settlements': 'No se encontraron liquidaciones en el periodo seleccionado',
    'no-settlements-description': 'Intenta seleccionar otro mes',
    'no-payouts': 'No se encontraron liquidaciones en el periodo seleccionado',
    'no-shifts': 'No hemos podido encontrar transacciones para los filtros seleccionados',
    'no-shifts-subtitle': 'Pruebe a seleccionar otra franja horaria, unidad, estado o canales anteriores',
    'no-statistics': 'No hemos podido encontrar estadísticas para los filtros seleccionados',
    'no-statistics-subtitle': 'Intenta seleccionar otro periodo o unidades arriba',
    'no-totals': 'No hemos podido encontrar estadísticas para el mes actual,',
    'no-totals-subtitle': 'Consulte las páginas de estadísticas de otros periodos',
    'no-transactions': 'No hemos podido encontrar transacciones para los filtros seleccionados',
    'no-transactions-subtitle': 'Pruebe a seleccionar otra franja horaria, unidad, estado o canales anteriores',
    'no-users': 'No hemos podido encontrar usuarios para los filtros seleccionados',
    'no-users-subtitle': 'Pruebe a seleccionar otro filtro o las unidades anteriores',
    'no-webhooks': 'No hemos podido encontrar webhooks para los filtros seleccionados',
    none: 'None',
    'not-confirmed': 'No confirmado',
    'not-confirmed-message': 'Pago realizado directamente por el adquirente.',
    'not-visible-columns': 'Columnas ocultas',
    now: 'Ahora',
    onboarding: 'Onboarding',
    'onboarding-details': 'Detalles del Onboarding',
    onboardings: 'Onboardings',
    opened: 'Abierto',
    'order-amount': 'Cantidad solicitada',
    'order-date': 'Fecha de la solicitud',
    'order-ref': 'Referencia de la solicitud',
    'order-reference': 'Referencia de la solicitud',
    order: 'Solicitud',
    orderCreated: 'Pedido Creado',
    noOrderInfo: 'Sin Información del Pedido',
    'order-details': 'Detalles del Pedido',
    orderId: 'Id de la solicitud',
    orderRef: 'Referencia de la solicitud',
    orderref: 'Referencia de la solicitud',
    orders: 'Solicitudes',
    'orders-title': 'Solicitudes',
    paid: 'Pago',
    'partially captured': 'Capturado parcialmente',
    'partially refunded': 'Reembolsado parcialmente',
    'partial-chargeback': 'Reembolso parcial',
    'partial-refund': 'Reembolso parcial',
    'partial-capture': 'Captura parcial',
    password: 'Contraseña',
    'pay-by-link-create': 'Crear un nuevo link de pago',
    'pay-by-link-description': 'Crear, enviar links de pago y recibir en línea',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Link de Pago',
    'pay-links': 'link de pago',
    paymentDetails: 'Detalles del Pago',
    recipientInformation: 'Información del Destinatario',
    configuration: 'Configuración',
    payment: 'Pago',
    'payment-amount': 'Importe del pago',
    'payment-batch-not-found': 'Lote de pagos no encontrado',
    'payment-link-error': 'Se ha producido un error al enviar los links',
    'payment-link-success': 'El link de pago se ha enviado con éxito.',
    'payment-method': 'Métodos de pago',
    paymentId: 'ID de Transacción',
    paymentInformation: 'Información de pago',
    paymentMethod: 'Métodos de pago',
    payments: 'Pagos',
    'payment-reference': 'Referencia del Pago',
    'payments-title': 'Pagos',
    'payouts-title': 'Liquidaciones',
    'payout-information': 'Información sobre pagos',
    'payout-title': 'Detalhe $1',
    'payouts-warning-message':
      'Esta función no está disponible temporalmente. Estamos realizando mejoras en nuestro sistema para servirle aún mejor. Le pedimos disculpas por las molestias causadas y nos apresuraremos a restablecer esta funcionalidad. Para cualquier aclaración, puede ponerse en contacto con nosotros a través de los canales habituales.',
    'payout-paid-message': 'Payout ya procesado',
    'payout-pending-message': 'Payout aún no ejecutado',
    'payout-no-info-message': 'Payout procesado directamente por el adquirente',
    pending: 'Pendiente',
    pendingaction: 'Acción Pendiente',
    pendingmerchantaction: 'Acción comercial pendiente',
    period: 'Período',
    'phone-number': 'Número de Teléfono',
    phoneNumber: 'Número de Teléfono',
    pnr: 'PNR',
    portuguese: 'Portugués',
    pos: 'TPV Físico',
    'pre-auth': 'Pre-Autorizaciones',
    preauth: 'PreAuth',
    'predictions-dispute': 'Quiero abrir una disputa',
    'preferred-payment-methods': 'Métodos de pago preferentes',
    'previous-revenue': ' Ingresos anteriores',
    processing: 'Procesando',
    prod: 'Producción',
    quarter: 'Trimestre',
    quarters: 'Trimestres',
    range: 'Calendario',
    reason: 'Motivo para iniciar un Contracargo',
    'recipient-email': 'Email del destinatario',
    'recipient-name': 'Nombre del Destinatario',
    'recipient-number': 'Contacto del destinatario',
    'recover-paybyrd-password': 'Recuperar Contraseña',
    'recovery-password-success': 'Le enviamos un correo electrónico para restablecer su contraseña.',
    reference: 'Referencia',
    'reference-ids': 'IDs de referencia',
    refresh: 'Actualizar',
    refund: 'Devoluciones',
    'refund-amount': 'Importe de devolución',
    'refund-confirm-message': '¿Realmente deseas reembolsar esta transacción por un monto de $1?',
    'refund-transaction': 'Transacción de devolución',
    refunded: 'Reembolsado',
    refunding: 'Reembolsando...',
    refunds: 'Devoluciones',
    'refund-create-success': 'Reembolso creado con éxito',
    'register-now': 'Regístrate ahora',
    'related-operation-status': 'Estado de la operación relacionada',
    'related-transactions': 'Transacciones Relacionadas',
    relatedOperationStatus: 'Estado de la Operación Relacionada',
    release: 'Cancelar la autorización',
    releasing: 'Cancelando la autorización...',
    remark: 'Comentario',
    'request-info': 'Solicitar información',
    'required-field': 'Este campo es obligatorio',
    resend: 'Reenviar',
    'resend-error': "Hubo un error al reenviar el webhook '$1'.",
    'resend-success': "El webhook '$1' se reenvió con éxito.",
    resending: 'Reenviando...',
    response: 'Respuesta',
    revenue: 'Ingresos',
    'reverse-confirmation': '¿Estás seguro de que deseas liberar la transacción con el id $1?',
    'reverse-create-success': 'Reversión creada con éxito',
    role: 'Papel',
    search: 'Buscar',
    'search-filters': 'Buscar filtros',
    'select-all': 'Seleccionar todos',
    'deselect-all': 'Deseleccionar todos',
    'select-filter': 'Seleccionar filtro',
    selected: 'seleccionado',
    'selected-s': '$1 $2 seleccionado(s)',
    'send-invite': 'Enviar invitación',
    'send-link': 'Enviar Link',
    'send-links': 'Enviar Links',
    'send-message': 'Enviar mensaje',
    'send-message-and-dispute': 'Enviar mensaje y abrir Disputa',
    'send-password-reset': 'Enviar restablecimiento de contraseña',
    'send-recover-email': 'Enviar email',
    sending: 'Enviando...',
    'sent-at': 'Enviado el',
    'settings-title': 'Definiciones',
    'settlement-date': 'Fecha de Liquidación',
    'settlement-details': 'Detalles del Acuerdo',
    settlements: 'Liquidaciones',
    settled: 'Liquidado',
    shift: 'Turno $1',
    'shift-id': 'Id do turno',
    'shift-details': 'Detalles del turno',
    'shifts-title': 'Turnos',
    'shopper-ip-address': 'Dirección IP del comprador',
    shopperEmail: 'Correo electrónico del comprador',
    shopperInformation: 'Información del comprador',
    shopperIp: 'Dirección IP del comprador',
    'show-accessible-stores': 'Muestra tiendas accesibles',
    'show-all': 'Mostrar Todo',
    'show-details': 'Mostrar detalles',
    'signed-up-on': 'Registrado el $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Español',
    'start-date': 'Fecha de inicio',
    'start-time': 'Hora de inicio',
    'statistics-title': 'Estadísticas',
    status: 'Estado',
    stock: 'Cantidad',
    'stock-quantity': 'Cantidad de stock',
    store: 'Tienda',
    stores: 'Tiendas',
    'store-name': 'Nombre de la tienda',
    storeId: 'tienda',
    success: 'Éxito',
    'system-language': 'Idioma del sistema',
    'system-timezone': 'Timezone del sistema',
    'team-users': 'Usuarios del equipo',
    terminalPassword: 'Contraseña del Terminal',
    'new-password': 'Nueva contraseña',
    'confirm-new-password': 'Confirmar nueva contraseña',
    'save-password': 'Guardar Contraseña',
    'changing-password': 'Cambiar Contraseña...',
    'confirm-change-password-message': '¿Confirmar cambio de contraseña del Terminal?',
    'passwords-do-not-match-message': '¡Las contraseñas no coinciden!',
    'change-terminal-password': 'Cambiar la contraseña del Terminal',
    'password-must-have-six-numbers': '¡La contraseña debe tener seis números!',
    'password-changed-successfully': '¡Contraseña cambiada con éxito!',
    test: 'Test',
    'test-api-key': 'API Keys de prueba',
    'this-month': 'Este mes',
    'this-week': 'Esta semana',
    title: 'Título',
    today: 'Hoy dia',
    total: 'Total',
    'total-amount': 'Importe total',
    'total-revenue': 'Ingresos Totales',
    totals: 'Totales',
    'totals-per': 'Totales por $1',
    'transaction-details': 'Detalles de la transacción',
    'transaction-type': 'Tipo de Transacción',
    transactionId: 'ID de Transacción',
    transactions: 'transacciones',
    'transactions-count': 'Recuento de transacciones',
    'transactions-title': 'Transacciones',
    'transactions-volume': 'Volumen de transacciones',
    'transactions-multiple-currencies-found': 'Cuando se seleccionan varias monedas, el total de ingresos/monto puede no mostrarse.',
    type: 'Tipo',
    unit: 'Tienda',
    units: 'Tiendas',
    user: 'Usuario',
    'user-action-title': '¿Estás seguro?',
    'user-action-password-reset-confirmation': '¿Estás seguro de que quieres restablecer la contraseña del usuario?',
    'user-action-password-reset-success': '¡Correo de restablecimiento de contraseña enviado con éxito!',
    'user-action-activate-user-confirmation': '¿Estás seguro de que quieres activar al usuario?',
    'user-action-activate-user-success': '¡Usuario activado con éxito!',
    'user-action-deactivate-user-confirmation': '¿Estás seguro de que quieres desactivar al usuario?',
    'user-action-deactivate-user-success': '¡Usuario desactivado con éxito!',
    'user-blocked': 'Bloqueado',
    'user-details': 'Detalles del usuario',
    'user-profile-title': 'Perfil de Usuario',
    'user-profile-subtitle': 'Gestiona la configuración de tu cuenta y preferencias',
    'appearance-settings': 'Apariencia',
    'appearance-settings-description': 'Personaliza el tema visual y preferencias de visualización',
    'language-settings': 'Idioma y Región',
    'language-settings-description': 'Establece tu idioma preferido y configuración regional',
    'timezone-settings': 'Fecha y Hora',
    'timezone-settings-description': 'Configura tu zona horaria y preferencias de formato de fecha',
    'theme-mode': 'Modo de Tema',
    'theme-mode-description': 'Elige entre tema claro y oscuro',
    'light-mode': 'Claro',
    'dark-mode': 'Oscuro',
    'system-language-description': 'Selecciona tu idioma preferido para la interfaz',
    'system-timezone-description': 'Elige tu zona horaria para mostrar fecha y hora precisas',
    'connected-stores': 'Tiendas Conectadas',
    'dashboard-user': 'Usuario del Panel',
    'validation-max-chars': 'La longitud máxima de este campo es de $1 carácteres',
    'view-by': 'Consulte por $1',
    'view-details': 'Ver detalles',
    'view-less': 'Ver menos',
    'view-more': '+$1 más',
    'view-transaction-details-hint': 'Pulse para ver los detalles de la transacción',
    'visible-columns': 'Columnas visibles',
    volume: 'Volumen',
    webhooks: 'Webhooks',
    week: 'Semana',
    weeks: 'Semanas',
    won: 'Ganado',
    year: 'Año',
    years: 'Años',
    yes: 'Sí',
    yesterday: 'Ayer',

    // AI Assistant
    ai_smart_assistant_title: 'Asistente IA',
    ai_smart_assistant_smart_suggestions: 'Sugerencias Inteligentes',
    ai_smart_assistant_smart_suggestions_description: 'Prompts preconfigurados para operaciones comerciales comunes. Complete los detalles y ejecute instantáneamente.',
    ai_smart_assistant_your_question: 'Su Pregunta',
    ai_smart_assistant_selected_request: 'Solicitud Seleccionada',
    ai_smart_assistant_ai_response: 'Respuesta de IA',
    ai_smart_assistant_ready_help: '¡Listo para ayudar!',
    ai_smart_assistant_ready_help_description: 'Haga su pregunta o pruebe una de las sugerencias inteligentes.',
    ai_smart_assistant_processing: 'Procesando su solicitud...',
    ai_smart_assistant_placeholder_confirm: 'Por favor, confirme o cancele la acción anterior antes de enviar un nuevo mensaje...',
    ai_smart_assistant_placeholder_completed: "Solicitud completada. Haga clic en 'Nueva Solicitud' para iniciar una nueva conversación...",
    ai_smart_assistant_placeholder_default: 'Pregúnteme cualquier cosa sobre los datos de su tienda o pruebe las sugerencias inteligentes...',
    ai_smart_assistant_new_request: 'Nueva Solicitud',
    ai_smart_assistant_send: 'Enviar',
    ai_smart_assistant_request_canceled: 'La solicitud ha sido cancelada por el usuario.',
    ai_smart_assistant_processing_button: 'Procesando...',
    ai_smart_assistant_characters: 'caracteres',
    ai_smart_assistant_tip:
      '💡 Consejo: Use Ctrl+Enter para enviar • Pruebe las sugerencias inteligentes para acciones rápidas • Pediré confirmación antes de realizar operaciones sensibles',
    ai_smart_assistant_confirmation_required: 'Confirmación Requerida',
    ai_smart_assistant_confirmation_description: 'Por favor, revise la respuesta a continuación y confirme si desea continuar.',
    ai_smart_assistant_confirm: 'Confirmar',
    ai_smart_assistant_cancel: 'Cancelar',
    ai_smart_assistant_store_selection: 'Selección de Tienda',
    ai_smart_assistant_search_stores: 'Escriba para buscar tiendas...',
    ai_smart_assistant_configure_api_key: 'Configurar Clave API',
    ai_smart_assistant_help: 'Ayuda',
    ai_smart_assistant_help_tooltip: 'Ver documentación del Asistente Inteligente IA',

    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Exportar Pedidos',
    ai_smart_suggestion_export_orders_description: 'Exportar todos los pedidos pagados de ayer',
    ai_smart_suggestion_create_payment_link: 'Crear Enlace de Pago',
    ai_smart_suggestion_create_payment_link_description: 'Generar un enlace de pago con detalles personalizados',
    ai_smart_suggestion_create_payment_link_template: 'Crear enlace de pago con referencia {orderRef} de {amount} {currency} y enviar a {email}',
    ai_smart_suggestion_refund_transaction: 'Reembolsar Transacción',
    ai_smart_suggestion_refund_transaction_description: 'Procesar un reembolso para una transacción específica',
    ai_smart_suggestion_refund_transaction_template: 'Reembolsar transacción {transactionId} por {amount} {currency}',
    ai_smart_suggestion_order_reference: 'Referencia del Pedido',
    ai_smart_suggestion_order_reference_placeholder: 'ej., PED-001',
    ai_smart_suggestion_amount: 'Importe',
    ai_smart_suggestion_amount_placeholder: 'ej., 50,00',
    ai_smart_suggestion_currency: 'Moneda',
    ai_smart_suggestion_currency_placeholder: 'Seleccionar moneda',
    ai_smart_suggestion_customer_email: 'Email del Cliente',
    ai_smart_suggestion_customer_email_placeholder: 'cliente@ejemplo.com',
    ai_smart_suggestion_execute: 'Ejecutar',
    ai_smart_suggestion_missing_fields: 'Por favor, complete todos los campos requeridos:',
    ai_smart_suggestion_retrieve_transaction: 'Recuperar Detalles de Transacción',
    ai_smart_suggestion_retrieve_transaction_description: 'Obtener información detallada sobre una transacción específica',
    ai_smart_suggestion_retrieve_transaction_template: 'Por favor, recupere los detalles para la transacción ID {transactionId}',
    ai_smart_suggestion_transaction_id: 'ID de Transacción',
    ai_smart_suggestion_transaction_id_placeholder: 'ej: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: 'Formato de Exportación',
    ai_smart_suggestion_export_format_placeholder: 'Seleccionar formato',
    ai_smart_suggestion_export_orders_template_with_format: 'Por favor, exporte todos los pedidos pagados de ayer en formato {format} y envíelos a mi correo',
    ai_smart_suggestion_find_order: 'Buscar Pedido por ID',
    ai_smart_suggestion_find_order_description: 'Obtener información detallada sobre un pedido específico',
    ai_smart_suggestion_find_order_template: 'Por favor, busque el pedido con ID {orderId}',
    ai_smart_suggestion_order_id: 'ID del Pedido',
    ai_smart_suggestion_order_id_placeholder: 'ej: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Buscar Pedidos por Referencia',
    ai_smart_suggestion_search_orders_by_ref_description: 'Buscar pedidos recientes por referencia (7 días)',
    ai_smart_suggestion_search_orders_by_ref_template: 'Buscar pedidos con referencia {orderRef} de los últimos 7 días',

    // History
    ai_smart_assistant_request_history: 'Historial de Solicitudes',
    ai_smart_assistant_clear_all: 'Limpiar Todo',
    ai_smart_assistant_no_history: 'Aún no hay historial',
    ai_smart_assistant_no_history_description: 'Sus solicitudes de IA se guardarán aquí para fácil acceso.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: 'Lo siento, encontré un error al procesar su confirmación.',
    ai_smart_assistant_error_request: 'Lo siento, encontré un error al procesar su solicitud.',
    ai_smart_assistant_error_api_key: 'Se requiere clave API. Por favor, configúrela primero.',
    ai_smart_assistant_error_invalid_api_key: 'Clave API inválida. Por favor, verifique su configuración.',
    ai_smart_assistant_error_auth: 'Problema de autenticación. Por favor, intente iniciar sesión nuevamente.',

    // user roles
    'user-role': 'Rol',
    'user-role-admin': 'Administrador',
    'user-role-manager': 'Gerente',
    'user-role-developer': 'Desarrollador',
    'user-role-finance': 'Finanzas',
    'user-role-operator': 'Operador',
    'user-role-user': 'Usuario',

    // Getting Started
    welcome: 'Bienvenido',
    'welcome-back': 'Bienvenido de nuevo',
    'try-paybyrd': 'Probar Paybyrd',
    'try-paybyrd-description':
      'Conecta Paybyrd a tu sitio web o plataforma usando nuestra clave API de prueba para explorar el proceso de integración. Una vez que tu cuenta sea aprobada, recibirás tu clave API en vivo para comenzar a aceptar pagos reales.',
    'try-paybyrd-cta': 'API de prueba',
    'resume-registration': 'Reanudar registro',
    'resume-registration-description': 'Todavía necesitamos algunos datos y documentos tuyos. Reanuda el proceso para completarlo — continuarás donde lo dejaste.',
    'resume-registration-help': '¿Necesitas ayuda? Consulta nuestro artículo o contáctanos por chat. ',
    'resume-registration-link': 'Registro con Paybyrd',
    'resume-registration-cta': 'Reanudar proceso',
    'init-registration': 'Comienza con Paybyrd',
    'init-registration-description':
      'Para empezar a aceptar pagos, primero debes completar el proceso legal de incorporación. Ten listos los siguientes documentos e información — puedes pausar y reanudar cuando quieras.',
    'company-details': 'Datos de la empresa',
    'shareholder-information': 'Información de los socios',
    'bank-account-details': 'Datos bancarios',
    'business-activity-overview': 'Resumen de la actividad comercial',
    'init-registration-help': '👉 ¿Necesitas más detalles? Consulta nuestro artículo de ayuda: ',
    'init-registration-link': 'Registro con Paybyrd',
    'start-registration-cta': 'Comenzar registro',
    'submitted-registration': '¡Registro enviado!',
    'submitted-registration-description':
      'Nuestro equipo está revisando tu solicitud. Te enviaremos una actualización por correo electrónico dentro de cinco días hábiles. Si necesitas registrar más comercios, te enviaremos un enlace de invitación por separado.',
    'submitted-registration-help': '¿Tienes preguntas? Consulta nuestro Centro de Ayuda o contáctanos por chat.',
    'submitted-registration-cta': 'Ir al Centro de Ayuda',
    'go-to-dashboard-cta': 'Ir al Panel',
    'start-next-onboarding-cta': 'Iniciar la siguiente incorporación',
    processingData: 'Procesando datos',
    'parent-payment-id': 'ID de pago principal',
    acquirerId: 'ID del adquirente',
    'shift-code': 'Código de turno',
    'providing-access-to': 'Proporcionando acceso a $1',
    'provide-access': 'Proporcionar acceso',
    'select-units-type-to-add': 'Seleccione el tipo de unidade para agregar',
    'access-updated': '¡Acceso actualizado!',
    'add-new-access-units': 'Agregar nueva unidad de acceso',
    'confirm-updating-access': 'Confirmar actualización de acceso',
    'select-group-add': 'Seleccione el grupo para agregar',
    'select-merchant-add': 'Seleccione el comerciante para agregar',
    'select-store-add': 'Seleccione la tienda para agregar',
    'all-merchants': 'Todos los comerciantes',
    'all-stores': 'Todas las tiendas',
    'no-units-selected': 'No se seleccionaron unidades',
    'remove-access': 'Eliminar acceso',
    'are-you-sure-remove-group': '¿Está seguro de que desea eliminar el grupo?',
    'are-you-sure-remove-merchant': '¿Está seguro de que desea eliminar el comerciante?',
    'are-you-sure-remove-store': '¿Está seguro de que desea eliminar la tienda?',
    next: 'Siguiente',
    'success-remove-unit': 'Unidad eliminada con éxito',
    'selected-items': '$1 $2 seleccionados',
    item: 'elemento',
    items: 'elementos',
    'no-unit-selected-label': 'Si no se selecciona ninguna unidad, todas las unidades disponibles se añadirán al usuario',
    'paybyrd-user': 'Usuario de Paybyrd con acceso a todos los comerciantes',
    'no-groups': 'No pudimos encontrar grupos para el usuario seleccionado',
    'no-groups-subtitle': 'Puede agregar nuevas unidades de acceso usando el botón de arriba',
    'no-merchants': 'No pudimos encontrar comerciantes para el usuario seleccionado',
    'no-merchants-subtitle': 'Puede agregar nuevas unidades de acceso usando el botón de arriba',
    'no-stores': 'No pudimos encontrar tiendas para el usuario seleccionado',
    'no-stores-subtitle': 'Puede agregar nuevas unidades de acceso usando el botón de arriba',
    'invite-new-users': 'Invitar nuevos usuarios',
    'add-emails': 'Agregar correos electrónicos',
    'enter-valid-email': 'Por favor, introduce un correo electrónico válido.',
    'invite-new-user': 'Invitar nuevo usuario',
    invite: 'Invitar',
    close: 'Cerrar',
    'feature-access': 'Acceso a funciones',
    'view-feature-access': 'Ver lista de funciones de acceso',
    'paybylink-description': 'Permitir crear y gestionar enlaces de pago.',
    'shifts-description': 'Permitir la creación de turnos.',
    'successfull-invite': '¡Invitación enviada con éxito!',
    'manage-role': 'Gestionar rol y acceso',
    'changing-user-roles': 'Cambiando el rol del usuario',
    'role-operator': 'Permite la acción seleccionada en las áreas accesibles.',
    'role-observer': 'Permite la acción seleccionada en las áreas accesibles.',
    'role-admin': 'Permite un control total en las áreas accesibles.',
    current: 'Actual',
    save: 'Guardar',
    transactionPayout: 'Pago de la Transacción',
    paymentReference: 'Referencia de Pago',
    threeDSecure: '3D Secure',
    installments: 'Cuotas',
    installmentAmount: 'Importe de la Cuota',
    cardIssuerCountry: 'País Emisor de la Tarjeta',
    authorizationCode: 'Código de Autorización',
    LiabilityShift: 'Transferencia de Responsabilidad',
    version: 'Versión',
    transStatus: 'Estado de la Transacción 3DS',
    authorizationStatus: 'Estado de Autorización 3DS',
    challengeOptions: 'Opciones de Desafío 3DS',
    protocolVersion: 'Versión del Protocolo',
    'settlement-status': 'Liquidación',
    eci: 'ECI',
    done: 'Completado',
    inProgress: 'En progreso',
  },
  fr: {
    'enter-exact-amount': 'Saisissez le montant exact',
    'select-currency': 'Sélectionnez la devise',
    summary: 'Résumé',
    ai_chat_title: 'Assistant de Chat IA',
    ai_chat_beta: 'BÊTA',
    ai_chat_greeting:
      "Bonjour ! Je suis votre assistant IA Paybyrd. Comment puis-je vous aider aujourd'hui ? Je peux vous aider avec le traitement des paiements, les demandes de transactions, les remboursements, et plus encore.",
    ai_chat_placeholder: 'Tapez votre message ici...',
    ai_chat_send: 'Envoyer message',
    ai_chat_close: 'Fermer le chat',
    ai_chat_loading: 'Réflexion...',
    ai_chat_error: "Désolé, une erreur s'est produite. Veuillez réessayer plus tard.",
    ai_chat_footer: "L'assistant IA est en version bêta. Pour les problèmes critiques, veuillez contacter le support.",
    ai_chat_store_selection: 'Sélectionnez un magasin pour le contexte',
    ai_chat_select_store_warning: "Pour une aide plus spécifique, veuillez d'abord sélectionner un magasin.",
    ai_chat_api_key_required: 'Clé API requise',
    ai_chat_api_key_invalid: 'Clé API invalide. Veuillez vérifier et réessayer.',
    ai_chat_api_key_missing: "Clé API non configurée. Veuillez configurer votre clé API pour utiliser l'assistant IA.",
    ai_chat_api_key_configure: 'Configurer',
    ai_chat_api_key_clear: 'Effacer la Clé',
    ai_chat_api_key: 'Clé API',
    ai_chat_api_key_privacy:
      'Votre clé API est stockée en toute sécurité dans le stockage local de votre navigateur et est uniquement utilisée pour communiquer avec le service IA.',
    ai_chat_api_config: 'Configuration IA',
    ai_chat_clear_chat: 'Effacer le Chat',
    ai_chat_settings: 'Paramètres',
    ai_chat_choose_provider: 'Choisir le Fournisseur IA',
    ai_chat_openai_info: 'Entrez votre clé API OpenAI pour utiliser les modèles GPT',
    ai_chat_anthropic_info: 'Entrez votre clé API Anthropic pour utiliser les modèles Claude',
    ai_chat_openai_info_tooltip: 'Vous pouvez obtenir une clé API sur platform.openai.com',
    ai_chat_anthropic_info_tooltip: 'Vous pouvez obtenir une clé API sur console.anthropic.com',
    ai_chat_cancel: 'Annuler',
    ai_chat_save: 'Sauvegarder',
    ai_chat_provider: "Fournisseur d'IA",
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'Configurer la Clé API',
    ai_chat_try_asking: 'Essayez de demander à propos de:',
    ai_chat_suggestions_tooltip: 'Suggestions',
    ai_chat_suggestion_1: 'Comment puis-je créer un lien de paiement?',
    ai_chat_suggestion_2: 'Rembourser le montant total du paiement {paymentid}',
    ai_chat_suggestion_3: 'Quel est le statut de mon dernier lien de paiement?',
    ai_chat_suggestion_4: 'La commande {order_id} a-t-elle déjà été payée?',
    ai_chat_suggestion_5: 'Créer un lien de paiement de {amount} {currency} avec référence {reference} et envoyer à {email}',
    ai_chat_suggestion_6: 'Rechercher des commandes avec référence {order_ref} créées hier',
    ai_chat_confirm_clear: 'Êtes-vous sûr de vouloir effacer tous les messages du chat?',
    ai_chat_confirm_yes: 'Oui',
    ai_chat_confirm_no: 'Non',
    'accessible-merchants': 'Commerçants accessibles',
    'accessible-stores': 'Magasins accessibles',
    'accessible-units': 'Unités accessibles',
    accept: 'Accept',
    accepted: 'Accepted',
    acquirer: 'Acquirer',
    'acquirer-response': "Réponse de l'Acquéreur",
    'acquirer-response-code': "Code de Réponse de l'Acquéreur",
    'acquirer-response-message': "Message de Réponse de l'Acquéreur",
    acquirerfailed: 'Échoué',
    acquirerReferenceNumber: "Numéro de Référence de l'Acquéreur (ARN)",
    acquirerResponseCode: "Code de Réponse de l'Acquéreur",
    acquirerResponseMessage: "Message de Réponse de l'Acquéreur",
    acquirersuccess: 'Succès',
    actions: 'Actions/Options',
    add: 'Create',
    'add-filter': 'Ajouter un Filtre',
    'administration-title': 'Administration',
    all: 'Tous',
    amount: 'Montant',
    'amount-greater-than-limit': 'Le montant est supérieur au montant de la transaction',
    'analytics-title': 'Analytique',
    'api-key-not-created': "API Key n'a pas été créée",
    'api-key-copied': 'Clé API copiée dans le presse-papiers',
    'no-api-keys-title': 'Aucune clé API trouvée',
    'no-api-keys-description': 'Créez des clés API pour commencer à intégrer avec notre plateforme',
    'copy-to-clipboard': 'Copier dans le presse-papiers',
    'api-keys': 'API Keys',
    channel: 'Canal',
    apply: 'Appliquer',
    'apply-filters': 'Appliquer les Filtres',
    'applied-filters': 'Le filtre sera appliqué à votre tableau de bord',
    'aquirer-authorization-code': "Code d'Autorisation de l'Acquéreur",
    aquirerAuthorizationCode: "Code d'Autorisation de l'Acquéreur",
    'attachment-not-found-error': 'Pièce jointe non trouvée',
    attempt: 'Tentative',
    back: 'Retour à la page',
    'back-to-payouts': 'Retour aux paiements',
    'batch-id': 'Identifiant de lot',
    brand: 'Marque',
    cardScheme: 'Card Scheme',
    wallet: 'Digital Wallet',
    businessName: 'Business Name',
    cancel: 'Annuler',
    canceled: 'Annulé',
    capture: 'Capture',
    'capture-create-success': 'Capture créée avec succès',
    'capture-transaction': 'Capture des transactions',
    captured: 'Captured',
    capturing: 'Capturer...',
    'card-holder-name': 'Nom du Titulaire de la Carte',
    'card-number': 'Numéro de Carte',
    cardHolderName: 'Nom du Titulaire de la Carte',
    cardNumber: 'Numéro de Carte',
    category: 'Category',
    'custom-filters': 'Filtres personnalisés',
    modes: 'Modes',
    chargeback: 'Chargeback',
    'chargeback-chat': 'Chargeback process comunitaction',
    'chargeback-create-success': 'Chargeback successfully created',
    'chargeback-confirm-attachment-delete': 'Supprimer la pièce jointe?',
    'chargeback-files': 'Chargeback process files',
    'chargeback-information': 'General Information',
    'chargeback-order-creationReason': 'Chargeback creation Reason',
    'chargeback-order-information': 'Order Information',
    'chargeback-ref': 'Référence de Rétrofacturation',
    'chargeback-store-information': 'Store Information',
    'chargeback-store-name': 'Nom du magasin',
    'chargeback-title': 'Rétrofacturation',
    'chargeback-title-add': 'Iniciar processo de Disputa',
    'chargeback-transaction-information': 'Transation Information',
    chargebackRef: 'Chargebacks-Référence',
    chargebacks: 'Chargebacks',
    'choose-file-type': 'Choisir le type de fichier',
    clear: 'Effacer',
    'click-to-upload': 'Cliquez ici pour télécharger',
    'client-frequent-flyer-number': 'Numéro de Voyageur Fréquent',
    clientFrequentFlyerNumber: 'Numéro de Voyageur Fréquent',
    clientFrequentFlightNumber: 'Numéro de Voyageur Fréquent',
    closed: 'Complété',
    code: 'Code',
    'collect-shipping-data': "Recueillir des données d'expédition",
    content: 'Contenu',
    'copied-link': 'Lien {1} copié dans la zone de transfert !',
    costs: 'Coûts',
    country: 'Pays',
    'country-code': 'Code postal',
    'create-chargeback-from-transaction': 'Create Chargeback',
    'create-checkout': 'Créer un paiement',
    created: 'Créé',
    'created-date': 'Date de création',
    creating: 'Créer...',
    currency: 'Devise',
    'current-balance': 'Solde actuel',
    'dashboard-title': 'Dashboard',
    date: 'Date',
    day: 'Jour',
    days: 'Jours',
    dccAmount: 'DCC Amount',
    'activate-user': `Activer l'utilisateur`,
    'deactivate-user': `Désactiver l'utilisateur`,
    declined: 'Rejeté',
    deductions: 'Déductions',
    'delete-attachment-forbidden-error': 'Vous ne pouvez pas supprimer cette pièce jointe',
    denied: 'Refusé',
    description: 'Description',
    details: 'Détails',
    'developers-description': "En savoir plus sur la façon d'intégrer l'API",
    'developers-link': 'Read more about integrating our API',
    'developers-subtitle': 'Utilisez la test clé API de pour tester votre intégration, et la live clé API en direct pour effectuer de vrais paiements.',
    'developers-title': 'Développeurs',
    disputing: 'Disputing',
    'drag-drop-file-here': 'Drop your file here',
    download: 'Télécharger',
    downloading: 'Téléchargement...',
    doYouWannaFullChargeback: 'Voulez-vous effectuer une rétrofacturation partielle ou complète ?',
    doYouWannaFullRefund: 'Voulez-vous effectuer un remboursement partiel ou total ?',
    dutch: 'Hollandais',
    ecommerce: 'Ecommerce',
    'edit-checkout': 'Modifier le paiement',
    'edit-checkout-success': 'Social Payment erfolgreich bearbeitet',
    'edit-data': 'Modifier les données',
    editing: 'Modification...',
    email: 'Email',
    'end-date': 'Date de fermeture',
    'end-time': 'Heure de fin',
    english: 'Anglais',
    environment: 'Environnement',
    'environment-hint': 'Check to see Production transactions only. Uncheck to see Test transactions only',
    error: 'Erreur',
    'event-type': "Type d'événement",
    'expire-at': 'Ablaufen am',
    expired: 'Expiré',
    export: 'Exporter $1',
    'export-details': 'Exporter',
    'export-details-help':
      "Lorsque vous commencez à exporter votre fichier, notre système traite votre demande. Une fois le traitement terminé, nous enverrons le fichier exporté directement à l'adresse électronique associée à votre compte ($1).",
    'export-details-alert': 'Attention',
    externalTransactionId: 'ID de Transaction Externe',
    externalCustomId: `Identifiant de l'acquéreur`,
    'extra-filters-title': 'Filtrage Personnalisé',
    failed: 'Échoué',
    fees: 'Taux',
    'file-sent': '$1 was sent.',
    'file-upload-helper': "Pour télécharger un fichier, cliquez sur le libellé de l'entrée",
    'filter-by': 'Filtrer par $1',
    'filter-by-enter': 'Filtrer par $1 (Appuyez sur Entrée pour Rechercher)',
    firstname: 'Prénom',
    'forgot-password': 'Vous avez oublié votre mot de passe?',
    french: 'Français',
    fulfilled: 'Complété',
    'full-chargeback': 'Rétrofacturation complète',
    'full-refund': 'Remboursement complet',
    'full-capture': 'Capture complète',
    german: 'Allemand',
    'getting-started-title': 'Commencer',
    'go-to': 'Accéder à $1',
    group: 'Groupe',
    groups: 'Groupes',
    'group-id': 'ID de groupe',
    groupId: 'Groupe',
    hasChargeback: 'Chargeback Associée',
    'hide-all': 'Tout Masquer',
    'manage-columns': 'Gérer les Colonnes',
    'search-columns': 'Rechercher des colonnes...',
    'reset-default': 'Réinitialiser par défaut',
    'hidden-columns': 'Colonnes Masquées',
    'no-columns-found': 'Aucune colonne trouvée correspondant à votre recherche',
    hour: 'Heure',
    hours: 'Heures',
    'transaction-history': 'Historique des Transactions',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'en $1 transactions',
    initiatedFrom: 'Initiated From',
    'international-shipping-amount': "Montant de l'expédition internationale",
    'international-urgent-shipping-amount': "Montant de l'expédition urgent internationale",
    'invite-error': "Il y a eu une erreur dans l'envoi de l'invitation.",
    'invite-merchants': 'Inviter les marchands',
    'invite-sent': "L'invitation a été envoyée à $1. Onboarding a été généré à: $2",
    invoice: 'Facture',
    invoices: 'Factures',
    'is-one-click-payment': 'Is one click',
    isoAmount: 'Amount',
    isOneClickPayment: 'Is one click',
    'item-service-amount': "Montant de l'article/du service",
    'item-service-description': "Description de l'article/du service",
    'item-service-image': "Télécharger l'image de l'article/du service",
    'item-service-name': "Nom de l'article/du service",
    language: 'Langue',
    'last-month': 'Le mois dernier',
    'last-refunds': 'Dernier $1 de remboursements',
    'last-revenue': 'Dernier $1 de revenu',
    'last-week': 'La semaine dernière',
    lastFourCardNumber: 'les Quatre derniers chiffres de la carte',
    lastname: 'Nom de Famille',
    'latest-payments': 'Derniers paiements (production uniquement)',
    'link-validity': 'Validité du lien',
    'live-api-key': 'Live API Key',
    loading: 'Loading...',
    'loading-order': "Chargement des données de l'ordre",
    'loading-ref-transactions': 'Loadinf related Transactions',
    'loading-transaction': 'Loading Transaction',
    'loading-webhook-attempts': 'Chargement des tentatives de webhook',
    'log-into-paybyrd': 'Connecter à Paybyrd',
    login: 'Login',
    logout: 'Déconnexion',
    lost: 'Lost',
    'management-title': 'Gestion',
    'manage-user': `Gérer l'utilisateur`,
    market: 'Marché',
    maskedCardNumber: 'Masked Card Number',
    merchant: 'Marchand',
    merchants: 'Commerçants',
    'merchant-id': 'ID marchand',
    'merchant-information': 'Informations sur le Marchand',
    merchantId: 'Marchand',
    'message-label': 'Message',
    mode: 'Mode',
    month: 'Mois',
    'monthly-revenue': 'Revenu mensuel (production uniquement)',
    months: 'Mois',
    name: 'Nom',
    'national-shipping-amount': "Montant d'expédition national",
    'national-urgent-shipping-amount': "Montant d'expédition urgent national",
    no: 'Non',
    'no-balance': "Nous n'avons pas pu trouver l'équilibre pour les filtres sélectionnés",
    'no-balance-description': 'Essayez de sélectionner un autre mois, ou les unités précédentes.',
    'no-chargebacks': "Nous n'avons pas trouvé de Rétrofacturation pour les filtres sélectionnés",
    'no-chargebacks-subtitle': 'Essayez de sélectionner un autre mois, ou les unités précédentes.',
    'no-info': 'Aucune information',
    'no-invoices': 'Il ne semble pas y avoir de factures pour la période sélectionnée',
    'no-invoices-description': 'Essayez de choisir une autre année',
    'no-onboardings': "Nous n'avons pas pu trouver de procédures d'onboarding pour les filtres actuels,",
    'no-onboardings-subtitle': 'Essayez une autre combinaison de filtres',
    'no-options': 'No Options',
    'no-orders': "Nous n'avons pas pu trouver de transactions pour les filtres sélectionnés",
    'no-orders-subtitle': 'Essayez de sélectionner un autre tranche horaire, une autre unité, un autre état ou des chaînes précédentes.',
    'no-payments': 'Aucun enregistrement des transactions récentes',
    'no-payments-subtitle': "Actualisez le tableau pour vérifier s'il y a de nouvelles transactions.",
    'no-ref-transactions': "Nous n'avons pas pu trouver de transactions pour les filtres sélectionnés",
    'no-ref-transactions-subtitle': 'Essayez de rafraîchir la table pour vérifier les nouvelles transactions.',
    'no-results': 'Aucun résultat trouvé',
    'no-settlements': "Aucune liquidation n'a été trouvé dans la période sélectionnée",
    'no-settlements-description': 'Essayez de sélectionner un autre mois',
    'no-payouts': "Aucune liquidation n'a été trouvé dans la période sélectionnée",
    'no-shifts': "Nous n'avons pas pu trouver de transactions pour les filtres sélectionnés",
    'no-shifts-subtitle': 'Essayez de sélectionner une autre tranche horaire, une autre unité, un autre état ou des canaux précédents.',
    'no-statistics': "Nous n'avons pas pu trouver de statistiques pour les filtres sélectionnés,",
    'no-statistics-subtitle': "Essayez de sélectionner une autre période ou d'autres unités ci-dessus",
    'no-totals': "Nous n'avons pas pu trouver de statistiques pour le mois en cours",
    'no-totals-subtitle': 'Consulter les pages de statistiques pour les autres périodes',
    'no-transactions': "Nous n'avons pas pu trouver de transactions pour les filtres sélectionnés",
    'no-transactions-subtitle': 'Essayez de sélectionner une autre tranche horaire, une autre unité, un autre état ou des canaux précédents.',
    'no-users': "Nous n'avons pas trouvé de transactions pour les filtres sélectionnés",
    'no-users-subtitle': `Essayez de sélectionner un autre filtre ou d'autres unités ci-dessus`,
    'no-webhooks': "Nous n'avons pas pu trouver de webhooks pour les filtres sélectionnés",
    none: 'None',
    'not-confirmed': 'Non confirmé',
    'not-confirmed-message': 'Paiement effectué directement par l’acquéreur.',
    'not-visible-columns': 'Colonnes Masquées',
    now: 'Maintenant',
    onboarding: 'Onboarding',
    'onboarding-details': 'Détails du Onboarding',
    onboardings: 'Onboardings',
    opened: 'Ouvert',
    'order-amount': 'Quantité demandée',
    'order-date': 'Order Date',
    'order-ref': 'Demande Ref',
    'order-reference': 'Référence de la demande',
    order: 'Commande',
    orderCreated: 'Commande Créée',
    noOrderInfo: 'Aucune Information sur la Commande',
    'order-details': 'Détails de la Commande',
    orderId: 'Id de commande',
    orderRef: 'Réf commande',
    orderref: 'Réf commande',
    orders: 'Ordres',
    'orders-title': 'Demandes',
    paid: 'Paiement',
    'partially captured': 'Partially captured',
    'partially refunded': 'Partially refunded',
    'partial-chargeback': 'Rétrofacturation partielle',
    'partial-refund': 'Remboursement partiel',
    'partial-capture': 'Capture partielle',
    password: 'Mot de passe',
    'pay-by-link-create': 'Créer un nouveau lien de paiement',
    'pay-by-link-description': 'Créer, envoyer et recevoir des liens de paiement en ligne',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Lien de paiement',
    'pay-links': 'Payer par lien',
    payment: 'Paiement',
    'payment-amount': 'Montant du paiement',
    'payment-batch-not-found': 'Lot de paiements introuvable',
    'payment-link-error': "Une erreur s'est produite lors de l'envoi des liens.",
    'payment-link-success': 'Le lien de paiement a été envoyé avec succès.',
    'payment-method': 'Méthodes de paiement',
    paymentDetails: 'Détails du Paiement',
    recipientInformation: 'Informations du Destinataire',
    configuration: 'Configuration',
    paymentId: 'Transaction Id',
    paymentInformation: 'Payment Information',
    paymentMethod: 'Payment Method',
    payments: 'Paiements',
    'payment-reference': 'Référence du paiement',
    'payments-title': 'Paiements',
    'payouts-title': 'Paiements',
    'payout-information': 'Informations sur les paiements',
    'payout-title': 'Détail $1',
    'payouts-warning-message':
      'Cette fonction est temporairement indisponible. Nous apportons des améliorations à notre système afin de mieux vous servir. Nous nous excusons pour la gêne occasionnée et nous nous empresserons de rétablir cette fonctionnalité. Pour toute clarification supplémentaire, vous pouvez nous contacter par les canaux habituels.',
    'payout-paid-message': 'Payout déjà traité',
    'payout-pending-message': 'Payout pas encore exécuté',
    'payout-no-info-message': 'Payout traité directement par l\'acquéreur',
    pending: 'En attente',
    pendingaction: 'Pending Action',
    pendingmerchantaction: 'Action du marchand en attente',
    period: 'Période',
    'phone-number': 'Numéro de Téléphone',
    phoneNumber: 'Numéro de Téléphone',
    pnr: 'PNR',
    portuguese: 'Portugais',
    pos: 'Point de vente physique',
    'pre-auth': 'Pré-autorisations',
    preauth: 'PreAuth',
    'predictions-dispute': 'I want to dispute',
    'preferred-payment-methods': 'Méthodes de paiement préférées',
    'previous-revenue': 'Revenus antérieurs',
    processing: 'En traitement',
    prod: 'Production',
    quarter: 'Trimestre',
    quarters: 'Trimestres',
    range: 'Varier',
    reason: 'Reason for initiating Chargeback',
    'recipient-email': 'Courriel du destinataire',
    'recipient-name': 'Nom du bénéficiaire',
    'recipient-number': 'Contact du destinataire',
    'recover-paybyrd-password': 'Récupérer le mot de passe',
    'recovery-password-success': 'Nous vous avons envoyé un e-mail pour réinitialiser votre mot de passe.',
    reference: 'Référence',
    'reference-ids': 'Identifiants de référence',
    refresh: 'Actualiser',
    refund: 'Remboursement',
    'refund-amount': 'Montant du remboursement',
    'refund-confirm-message': 'Do you really want to refund this transaction in the amount of $1?',
    'refund-transaction': 'Remboursement de la transaction',
    refunded: 'Remboursé',
    refunding: 'Rembourser...',
    refunds: 'Remboursements',
    'refund-create-success': 'Remboursement créé avec succès',
    'register-now': 'Inscrivez-vous maintenant',
    'related-operation-status': "Statut d'opération connexe",
    'related-transactions': 'Transactions Associées',
    relatedOperationStatus: 'Related Operation Status',
    release: "Annuler l'autorisation",
    releasing: "Annulation de l'autorisation...",
    remark: 'Remark',
    'request-info': 'Request Info',
    'required-field': 'Ce champ est requis',
    resend: 'Renvoyer',
    'resend-error': "Une erreur s'est produite lors de la tentative de renvoi du webhook '$1'.",
    'resend-success': "Le webhook '$1' a été renvoyé avec succès.",
    resending: 'Renvoi en cours...',
    response: 'Réponse',
    revenue: 'Revenu',
    'reverse-confirmation': "Êtes-vous sûr de vouloir libérer la transaction avec l'id $1?",
    'reverse-create-success': 'Annulation créée avec succès',
    role: 'Rôle',
    search: 'Rechercher',
    'search-filters': 'Rechercher des filtres',
    'select-all': 'Sélectionner tout',
    'deselect-all': 'Désélectionner tous',
    'select-filter': 'Sélectionner le Filtre',
    selected: 'sélectionné',
    'selected-s': '$1 $2 sélectionné(s)',
    'send-invite': 'Envoyer une invitation',
    'send-link': 'Envoyer le lien',
    'send-links': 'Envoyer des liens',
    'send-message': 'Send Message',
    'send-message-and-dispute': 'Send message and open Dispute',
    'send-password-reset': 'Envoyer la réinitialisation du mot de passe',
    'send-recover-email': 'Envoyer un e-mail',
    sending: 'Envoyer...',
    'sent-at': 'Envoyé à',
    'settings-title': 'Définitions',
    'settlement-date': 'Date du règlement',
    'settlement-details': 'Détails du règlement',
    settlements: 'Liquidations',
    settled: 'Soldé',
    shift: 'Poste $1',
    'shift-id': 'Poste Id',
    'shift-details': 'Détails de horaires',
    'shifts-title': 'Horaires',
    'shopper-ip-address': "Adresse IP de l'acheteur",
    shopperEmail: "Adresse e-mail de l'acheteur",
    shopperInformation: "Informations sur l'acheteur",
    shopperIp: "Adresse IP de l'acheteur",
    'show-accessible-stores': 'Affiche les magasins accessibles',
    'show-all': 'Tout Afficher',
    'show-details': 'Afficher les détails',
    'signed-up-on': 'Inscrit le $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Espagnol',
    'start-date': 'Date de départ',
    'start-time': 'Heure de début',
    'statistics-title': 'Statistiques',
    status: 'Status',
    stock: 'Quantité',
    'stock-quantity': 'Bestandsmenge',
    store: 'Magasin',
    stores: 'Magasins',
    'store-name': 'Nom du magasin',
    storeId: 'Magasin',
    success: 'Succès',
    'system-language': 'Langue du système',
    'system-timezone': 'Fuseau horaire du système',
    'team-users': `Utilisateurs de l'équipe`,
    terminalPassword: 'Mot de passe du Terminal',
    'nouveau-mot-de-passe': 'Nouveau mot de passe',
    'confirm-new-password': 'Confirmer le nouveau mot de passe',
    'save-password': 'Enregistrer le mot de passe',
    'changing-password': 'Changer le mot de passe...',
    'confirm-change-password-message': 'Confirmation du changement de mot de passe du Terminal ?',
    'passwords-do-not-match-message': 'Les mots de passe ne correspondent pas !',
    'change-terminal-password': 'Modifier le mot de passe du Terminal',
    'password-must-have-six-numbers': 'Le mot de passe doit comporter six chiffres !',
    'password-changed-successfully': 'Le mot de passe a été modifié avec succès !',
    test: 'Test',
    'test-api-key': 'Test des API Key',
    'this-month': 'Ce mois-ci',
    'this-week': 'Cette semaine',
    title: 'Titel',
    today: 'Aujourd hui',
    total: 'Total',
    'total-amount': 'Montant total',
    'total-revenue': 'Total des revenus',
    totals: 'Totaux',
    'totals-per': 'Totaux pour $1',
    'transaction-details': 'Détails de la transaction',
    'transaction-type': 'Type de transaction',
    transactionId: 'Transaction Id',
    transactions: 'transactions',
    'transactions-count': 'Nombre de transactions',
    'transactions-title': 'Transactions',
    'transactions-volume': 'Volume des transactions',
    'transactions-multiple-currencies-found': 'Lorsque plusieurs devises sont sélectionnées, le montant total/les revenus peuvent ne pas être affichés.',
    type: 'Type',
    unit: 'Magasin',
    units: 'Magasins',
    user: 'Utilisateur',
    'user-action-title': 'Êtes-vous sûr ?',
    'user-action-password-reset-confirmation': `Êtes-vous sûr de vouloir réinitialiser le mot de passe de l'utilisateur ?`,
    'user-action-password-reset-success': 'E-mail de réinitialisation du mot de passe envoyé avec succès !',
    'user-action-activate-user-confirmation': `Êtes-vous sûr de vouloir activer l'utilisateur ?`,
    'user-action-activate-user-success': 'Utilisateur activé avec succès !',
    'user-action-deactivate-user-confirmation': `Êtes-vous sûr de vouloir désactiver l'utilisateur ?`,
    'user-action-deactivate-user-success': 'Utilisateur désactivé avec succès !',
    'user-blocked': 'Bloqué',
    'user-details': `Détails de l'utilisateur`,
    'user-profile-title': 'Profil Utilisateur',
    'user-profile-subtitle': 'Gérez les paramètres de votre compte et vos préférences',
    'appearance-settings': 'Apparence',
    'appearance-settings-description': "Personnalisez le thème visuel et les préférences d'affichage",
    'language-settings': 'Langue et Région',
    'language-settings-description': 'Définissez votre langue préférée et les paramètres régionaux',
    'timezone-settings': 'Date et Heure',
    'timezone-settings-description': 'Configurez votre fuseau horaire et les préférences de format de date',
    'theme-mode': 'Mode de Thème',
    'theme-mode-description': 'Choisissez entre thème clair et sombre',
    'light-mode': 'Clair',
    'dark-mode': 'Sombre',
    'system-language-description': "Sélectionnez votre langue préférée pour l'interface",
    'system-timezone-description': "Choisissez votre fuseau horaire pour un affichage précis de la date et de l'heure",
    'connected-stores': 'Magasins Connectés',
    'dashboard-user': 'Utilisateur du Tableau de Bord',
    'validation-max-chars': 'La longueur maximale de ce champ est de $1 caractères',
    'view-by': 'Consulter pour $1',
    'view-details': 'Voir les détails',
    'view-less': 'Voir moins',
    'view-more': '+$1 de plus',
    'view-transaction-details-hint': 'Cliquez pour voir les détails de la transaction',
    'visible-columns': 'Colonnes Visibles',
    volume: 'Volume',
    webhooks: 'Webhooks',
    week: 'Semaine',
    weeks: 'Semaines',
    won: 'Won',
    year: 'Année',
    years: 'Années',
    yes: 'Oui',
    yesterday: 'Hier',

    // AI Assistant
    ai_smart_assistant_title: 'Assistant IA',
    ai_smart_assistant_smart_suggestions: 'Suggestions Intelligentes',
    ai_smart_assistant_smart_suggestions_description: 'Invites préconfigurées pour les opérations commerciales courantes. Remplissez les détails et exécutez instantanément.',
    ai_smart_assistant_your_question: 'Votre Question',
    ai_smart_assistant_selected_request: 'Demande Sélectionnée',
    ai_smart_assistant_ai_response: 'Réponse IA',
    ai_smart_assistant_ready_help: 'Prêt à aider !',
    ai_smart_assistant_ready_help_description: 'Posez votre question ou essayez une des suggestions intelligentes.',
    ai_smart_assistant_processing: 'Traitement de votre demande...',
    ai_smart_assistant_placeholder_confirm: "Veuillez confirmer ou annuler l'action ci-dessus avant d'envoyer un nouveau message...",
    ai_smart_assistant_placeholder_completed: "Demande terminée. Cliquez sur 'Nouvelle Demande' pour commencer une nouvelle conversation...",
    ai_smart_assistant_placeholder_default: 'Demandez-moi tout sur les données de votre magasin ou essayez les suggestions intelligentes...',
    ai_smart_assistant_new_request: 'Nouvelle Demande',
    ai_smart_assistant_send: 'Envoyer',
    ai_smart_assistant_request_canceled: "La demande a été annulée par l'utilisateur.",
    ai_smart_assistant_processing_button: 'Traitement...',
    ai_smart_assistant_characters: 'caractères',
    ai_smart_assistant_tip:
      "💡 Astuce : Utilisez Ctrl+Entrée pour envoyer • Essayez les suggestions intelligentes pour des actions rapides • Je demanderai confirmation avant d'effectuer des opérations sensibles",
    ai_smart_assistant_confirmation_required: 'Confirmation Requise',
    ai_smart_assistant_confirmation_description: 'Veuillez examiner la réponse ci-dessous et confirmer si vous souhaitez continuer.',
    ai_smart_assistant_confirm: 'Confirmer',
    ai_smart_assistant_cancel: 'Annuler',
    ai_smart_assistant_store_selection: 'Sélection de Magasin',
    ai_smart_assistant_search_stores: 'Tapez pour rechercher des magasins...',
    ai_smart_assistant_configure_api_key: 'Configurer la Clé API',
    ai_smart_assistant_help: 'Aide',
    ai_smart_assistant_help_tooltip: "Voir la documentation de l'Assistant Intelligent IA",

    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Exporter les Commandes',
    ai_smart_suggestion_export_orders_description: "Exporter toutes les commandes payées d'hier",
    ai_smart_suggestion_create_payment_link: 'Créer un Lien de Paiement',
    ai_smart_suggestion_create_payment_link_description: 'Générer un lien de paiement avec des détails personnalisés',
    ai_smart_suggestion_create_payment_link_template: 'Créer un lien de paiement avec la référence {orderRef} de {amount} {currency} et envoyer à {email}',
    ai_smart_suggestion_refund_transaction: 'Rembourser la Transaction',
    ai_smart_suggestion_refund_transaction_description: 'Traiter un remboursement pour une transaction spécifique',
    ai_smart_suggestion_refund_transaction_template: 'Rembourser la transaction {transactionId} pour {amount} {currency}',
    ai_smart_suggestion_order_reference: 'Référence de Commande',
    ai_smart_suggestion_order_reference_placeholder: 'ex., CMD-001',
    ai_smart_suggestion_amount: 'Montant',
    ai_smart_suggestion_amount_placeholder: 'ex., 50,00',
    ai_smart_suggestion_currency: 'Devise',
    ai_smart_suggestion_currency_placeholder: 'Sélectionner la devise',
    ai_smart_suggestion_customer_email: 'Email du Client',
    ai_smart_suggestion_customer_email_placeholder: 'client@exemple.com',
    ai_smart_suggestion_execute: 'Exécuter',
    ai_smart_suggestion_missing_fields: 'Veuillez remplir tous les champs requis :',
    ai_smart_suggestion_retrieve_transaction: 'Récupérer les Détails de Transaction',
    ai_smart_suggestion_retrieve_transaction_description: 'Obtenir des informations détaillées sur une transaction spécifique',
    ai_smart_suggestion_retrieve_transaction_template: 'Veuillez récupérer les détails pour la transaction ID {transactionId}',
    ai_smart_suggestion_transaction_id: 'ID de Transaction',
    ai_smart_suggestion_transaction_id_placeholder: 'ex: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: "Format d'Export",
    ai_smart_suggestion_export_format_placeholder: 'Sélectionner le format',
    ai_smart_suggestion_export_orders_template_with_format: "Veuillez exporter toutes les commandes payées d'hier au format {format} et les envoyer à mon email",
    ai_smart_suggestion_find_order: 'Rechercher une Commande par ID',
    ai_smart_suggestion_find_order_description: 'Obtenir des informations détaillées sur une commande spécifique',
    ai_smart_suggestion_find_order_template: "Veuillez rechercher la commande avec l'ID {orderId}",
    ai_smart_suggestion_order_id: 'ID de Commande',
    ai_smart_suggestion_order_id_placeholder: 'ex: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Rechercher des Commandes par Référence',
    ai_smart_suggestion_search_orders_by_ref_description: 'Trouver des commandes récentes par référence (7 jours)',
    ai_smart_suggestion_search_orders_by_ref_template: 'Rechercher des commandes avec la référence {orderRef} des 7 derniers jours',

    // History
    ai_smart_assistant_request_history: 'Historique des Demandes',
    ai_smart_assistant_clear_all: 'Tout Effacer',
    ai_smart_assistant_no_history: "Pas encore d'historique",
    ai_smart_assistant_no_history_description: 'Vos demandes IA seront sauvegardées ici pour un accès facile.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: "Désolé, j'ai rencontré une erreur lors du traitement de votre confirmation.",
    ai_smart_assistant_error_request: "Désolé, j'ai rencontré une erreur lors du traitement de votre demande.",
    ai_smart_assistant_error_api_key: "Clé API requise. Veuillez la configurer d'abord.",
    ai_smart_assistant_error_invalid_api_key: 'Clé API invalide. Veuillez vérifier votre configuration.',
    ai_smart_assistant_error_auth: "Problème d'authentification. Veuillez essayer de vous connecter à nouveau.",

    // user roles
    'user-role': 'Rôle',
    'user-role-admin': 'Administrateur',
    'user-role-manager': 'Manager',
    'user-role-developer': 'Développeur',
    'user-role-finance': 'Finance',
    'user-role-operator': 'Opérateur',
    'user-role-user': 'Utilisateur',

    // Getting Started
    welcome: 'Bienvenue',
    'welcome-back': 'Bon retour',
    'try-paybyrd': 'Essayer Paybyrd',
    'try-paybyrd-description':
      "Connectez Paybyrd à votre site web ou plateforme en utilisant notre clé API de test pour explorer le processus d'intégration. Une fois votre compte approuvé, vous recevrez votre clé API en direct pour commencer à accepter les paiements réels.",
    'try-paybyrd-cta': 'API de test',
    'resume-registration': "Reprendre l'inscription",
    'resume-registration-description':
      "Il nous manque encore certaines informations et documents de votre part. Reprenez le processus d'inscription pour le compléter — vous reprendrez là où vous vous étiez arrêté.",
    'resume-registration-help': "Besoin d'aide ? Consultez notre article ou contactez-nous via le chat. ",
    'resume-registration-link': 'Inscription avec Paybyrd',
    'resume-registration-cta': 'Reprendre le processus',
    'init-registration': 'Commencer avec Paybyrd',
    'init-registration-description':
      "Pour commencer à accepter les paiements, vous devez d'abord compléter le processus d'intégration légale. Préparez les documents et informations suivants — vous pouvez faire une pause et reprendre à tout moment.",
    'company-details': "Informations sur l'entreprise",
    'shareholder-information': 'Informations sur les actionnaires',
    'bank-account-details': 'Coordonnées bancaires',
    'business-activity-overview': "Aperçu de l'activité commerciale",
    'init-registration-help': "👉 Besoin de plus de détails? Consultez notre article d'aide: ",
    'init-registration-link': 'Inscription avec Paybyrd',
    'start-registration-cta': "Commencer l'inscription",
    'submitted-registration': 'Inscription envoyée !',
    'submitted-registration-description':
      "Notre équipe examine votre demande. Vous recevrez une mise à jour par e-mail dans un délai de cinq jours ouvrables. Si vous avez besoin d'ajouter d'autres commerçants, un lien d'invitation vous sera envoyé séparément.",
    'submitted-registration-help': "Des questions ? Consultez notre Centre d'aide ou contactez-nous via le chat.",
    'submitted-registration-cta': "Aller au Centre d'aide",
    'go-to-dashboard-cta': 'Aller au tableau de bord',
    'start-next-onboarding-cta': 'Commencer l’intégration suivante',
    processingData: 'Traitement des données',
    'parent-payment-id': 'ID du paiement principal',
    acquirerId: "ID de l'acquéreur",
    'shift-code': 'Code de quart',
    'providing-access-to': "Fourniture d'accès à $1",
    'provide-access': "Fournir l'accès",
    'select-units-type-to-add': "Sélectionnez le type d'unités à ajouter",
    'access-updated': 'Accès mis à jour !',
    'add-new-access-units': "Ajouter une nouvelle unité d'accès",
    'confirm-updating-access': "Confirmer la mise à jour de l'accès",
    'select-group-add': 'Sélectionnez le groupe à ajouter',
    'select-merchant-add': 'Sélectionnez le commerçant à ajouter',
    'select-store-add': 'Sélectionnez le magasin à ajouter',
    'all-merchants': 'Tous les commerçants',
    'all-stores': 'Tous les magasins',
    'no-units-selected': 'Aucune unité sélectionnée',
    'remove-access': "Supprimer l'accès",
    'are-you-sure-remove-group': 'Êtes-vous sûr de vouloir supprimer le groupe ?',
    'are-you-sure-remove-merchant': 'Êtes-vous sûr de vouloir supprimer le commerçant ?',
    'are-you-sure-remove-store': 'Êtes-vous sûr de vouloir supprimer le magasin ?',
    next: 'Suivant',
    'success-remove-unit': 'Unité supprimée avec succès',
    'selected-items': '$1 $2 sélectionnés',
    item: 'élément',
    items: 'éléments',
    'no-unit-selected-label': "Si aucune unité n'est sélectionnée, toutes les unités disponibles seront ajoutées à l'utilisateur",
    'paybyrd-user': 'Utilisateur Paybyrd avec accès à tous les commerçants',
    'no-groups': "Nous n'avons pas trouvé de groupes pour l'utilisateur sélectionné",
    'no-groups-subtitle': "Vous pouvez ajouter de nouvelles unités d'accès en utilisant le bouton ci-dessus",
    'no-merchants': "Nous n'avons pas trouvé de commerçants pour l'utilisateur sélectionné",
    'no-merchants-subtitle': "Vous pouvez ajouter de nouvelles unités d'accès en utilisant le bouton ci-dessus",
    'no-stores': "Nous n'avons pas trouvé de magasins pour l'utilisateur sélectionné",
    'no-stores-subtitle': "Vous pouvez ajouter de nouvelles unités d'accès en utilisant le bouton ci-dessus",
    'invite-new-users': 'Inviter de nouveaux utilisateurs',
    'add-emails': 'Ajouter des e-mails',
    'enter-valid-email': 'Veuillez saisir une adresse e-mail valide.',
    'invite-new-user': 'Inviter un nouvel utilisateur',
    invite: 'Inviter',
    close: 'Fermer',
    'feature-access': 'Accès aux fonctionnalités',
    'view-feature-access': "Voir la liste des fonctionnalités d'accès",
    'paybylink-description': 'Permet de créer et de gérer des liens de paiement.',
    'shifts-description': 'Permet la création de quarts de travail.',
    'successfull-invite': 'Invitation envoyée avec succès !',
    'manage-role': "Gérer le rôle et l'accès",
    'changing-user-roles': "Changement du rôle de l'utilisateur",
    'role-operator': "Autoriser l'action sélectionnée dans les zones accessibles.",
    'role-observer': "Autoriser l'action sélectionnée dans les zones accessibles.",
    'role-admin': 'Autoriser un contrôle total dans les zones accessibles.',
    current: 'Actuel',
    save: 'Enregistrer',
    transactionPayout: 'Paiement de la Transaction',
    paymentReference: 'Référence de Paiement',
    threeDSecure: '3D Secure',
    installments: 'Paiements échelonnés',
    installmentAmount: `Montant de l'Échéance`,
    cardIssuerCountry: `Pays de l'Émetteur de la Carte`,
    authorizationCode: `Code d'Autorisation`,
    LiabilityShift: 'Transfert de Responsabilité',
    version: 'Version',
    transStatus: 'Statut de la Transaction 3DS',
    authorizationStatus: `Statut d'Autorisation 3DS`,
    challengeOptions: 'Options de Challenge 3DS',
    protocolVersion: 'Version du Protocole',
    'settlement-status': 'Règlement',
    eci: 'ECI',
    done: 'Terminé',
    inProgress: 'En cours',
  },
  de: {
    'enter-exact-amount': 'Geben Sie den genauen Betrag ein',
    'select-currency': 'Währung auswählen',
    summary: 'Zusammenfassung',
    ai_chat_title: 'KI-Chat-Assistent',
    ai_chat_beta: 'BETA',
    ai_chat_greeting:
      'Hallo! Ich bin Ihr Paybyrd KI-Assistent. Wie kann ich Ihnen heute helfen? Ich kann bei der Zahlungsabwicklung, Transaktionsanfragen, Rückerstattungen und mehr helfen.',
    ai_chat_placeholder: 'Geben Sie Ihre Nachricht hier ein...',
    ai_chat_send: 'Nachricht senden',
    ai_chat_close: 'Chat schließen',
    ai_chat_loading: 'Denke nach...',
    ai_chat_error: 'Entschuldigung, ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    ai_chat_footer: 'Der KI-Assistent befindet sich in der Beta-Phase. Bei kritischen Problemen wenden Sie sich bitte an den Support.',
    ai_chat_store_selection: 'Wählen Sie einen Shop für den Kontext',
    ai_chat_select_store_warning: 'Für spezifischere Hilfe wählen Sie bitte zuerst einen Shop aus.',
    ai_chat_api_key_required: 'API-Schlüssel ist erforderlich',
    ai_chat_api_key_invalid: 'Ungültiger API-Schlüssel. Bitte überprüfen Sie und versuchen Sie es erneut.',
    ai_chat_api_key_missing: 'API-Schlüssel nicht konfiguriert. Bitte richten Sie Ihren API-Schlüssel ein, um den KI-Assistenten zu nutzen.',
    ai_chat_api_key_configure: 'Konfigurieren',
    ai_chat_api_key_clear: 'Schlüssel löschen',
    ai_chat_api_key: 'API-Schlüssel',
    ai_chat_api_key_privacy: 'Ihr API-Schlüssel wird sicher im lokalen Speicher Ihres Browsers gespeichert und nur für die Kommunikation mit dem KI-Dienst verwendet.',
    ai_chat_api_config: 'KI-Konfiguration',
    ai_chat_clear_chat: 'Chat löschen',
    ai_chat_settings: 'Einstellungen',
    ai_chat_choose_provider: 'KI-Anbieter wählen',
    ai_chat_openai_info: 'Geben Sie Ihren OpenAI-API-Schlüssel ein, um GPT-Modelle zu verwenden',
    ai_chat_anthropic_info: 'Geben Sie Ihren Anthropic-API-Schlüssel ein, um Claude-Modelle zu verwenden',
    ai_chat_openai_info_tooltip: 'Sie können einen API-Schlüssel von platform.openai.com erhalten',
    ai_chat_anthropic_info_tooltip: 'Sie können einen API-Schlüssel von console.anthropic.com erhalten',
    ai_chat_cancel: 'Abbrechen',
    ai_chat_save: 'Speichern',
    ai_chat_provider: 'KI-Anbieter',
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'API-Schlüssel konfigurieren',
    ai_chat_try_asking: 'Versuchen Sie zu fragen zu:',
    ai_chat_suggestions_tooltip: 'Vorschläge',
    ai_chat_suggestion_1: 'Wie kann ich einen Zahlungslink erstellen?',
    ai_chat_suggestion_2: 'Erstatten Sie den Gesamtbetrag der Zahlung {paymentid}',
    ai_chat_suggestion_3: 'Was ist der Status meines letzten Zahlungslinks?',
    ai_chat_suggestion_4: 'Wurde die Bestellung {order_id} bereits bezahlt?',
    ai_chat_suggestion_5: 'Zahlungslink für {amount} {currency} mit Referenz {reference} erstellen und an {email} senden',
    ai_chat_suggestion_6: 'Suche nach Bestellungen mit Referenz {order_ref}, die gestern erstellt wurden',
    ai_chat_confirm_clear: 'Sind Sie sicher, dass Sie alle Chat-Nachrichten löschen möchten?',
    ai_chat_confirm_yes: 'Ja',
    ai_chat_confirm_no: 'Nein',
    'accessible-merchants': 'Zugängliche Händler',
    'accessible-stores': 'Zugängliche Geschäfte',
    'accessible-units': 'Zugängliche Einheiten',
    accept: 'Accept',
    accepted: 'Accepted',
    acquirer: 'Akquirierer',
    'acquirer-response': 'Antwort des Akquirierers',
    'acquirer-response-code': 'Akquirierer-Antwortcode',
    'acquirer-response-message': 'Akquirierer-Antwortnachricht',
    acquirerfailed: 'Gescheitert',
    acquirerReferenceNumber: 'Akquirierer-Referenznummer (ARN)',
    acquirerResponseCode: 'Akquirierer-Antwortcode',
    acquirerResponseMessage: 'Akquirierer-Antwortnachricht',
    acquirersuccess: 'Erfolg',
    actions: 'Aktionen',
    add: 'Create',
    'add-filter': 'Filter hinzufügen',
    'administration-title': 'Verwaltung',
    all: 'Alle',
    amount: 'Betrag',
    'amount-greater-than-limit': 'Der Betrag ist größer als der Transaktionsbetrag',
    'analytics-title': 'Analytiks',
    'api-key-not-created': 'API-Schlüssel nicht erstellt',
    'api-key-copied': 'API-Schlüssel in die Zwischenablage kopiert',
    'no-api-keys-title': 'Keine API-Schlüssel gefunden',
    'no-api-keys-description': 'Erstellen Sie API-Schlüssel, um mit der Integration in unsere Plattform zu beginnen',
    'copy-to-clipboard': 'In die Zwischenablage kopieren',
    'api-keys': 'API-Schlüssel',
    channel: 'Kanal',
    apply: 'Anwenden',
    'apply-filters': 'Filter anwenden',
    'applied-filters': 'Der Filter wird auf Ihr Dashboard angewendet',
    'aquirer-authorization-code': 'Autorisierungscode des Akquirierers',
    aquirerAuthorizationCode: 'Autorisierungscode des Akquirierers',
    'attachment-not-found-error': 'Anhang nicht gefunden',
    attempt: 'Versuch',
    back: 'Zurück',
    'back-to-payouts': 'Zurück zu Auszahlungen',
    'batch-id': 'Stapel-Identifikator',
    brand: 'Marke',
    cardScheme: 'Card Scheme',
    wallet: 'Digital Wallet',
    businessName: 'Business Name',
    cancel: 'Abbrechen',
    canceled: 'Abgesagt',
    capture: 'Buchen',
    'capture-create-success': 'Erfassung erfolgreich erstellt',
    'capture-transaction': 'Transaktion buchen',
    captured: 'Captured',
    capturing: 'Erfassen der Buchung...',
    'card-holder-name': 'Name des Karteninhabers',
    'card-number': 'Kartennummer',
    cardHolderName: 'Name des Karteninhabers',
    cardNumber: 'Kartennummer',
    category: 'Category',
    'custom-filters': 'Benutzerdefinierte Filter',
    modes: 'Modes',
    chargeback: 'Chargeback',
    'chargeback-chat': 'Chargeback process comunitaction',
    'chargeback-create-success': 'Chargeback successfully created',
    'chargeback-confirm-attachment-delete': 'Anhang löschen?',
    'chargeback-files': 'Chargeback process files',
    'chargeback-information': 'General Information',
    'chargeback-order-creationReason': 'Chargeback creation Reason',
    'chargeback-order-information': 'Order Information',
    'chargeback-ref': 'Referenz',
    'chargeback-store-information': 'Store Information',
    'chargeback-store-name': 'Geschäftsname',
    'chargeback-title': 'Chargebacks',
    'chargeback-title-add': 'Iniciar processo de Disputa',
    'chargeback-transaction-information': 'Transation Information',
    chargebackRef: 'Chargeback-Referenz',
    chargebacks: 'Chargebacks',
    'choose-file-type': 'Dateityp auswählen',
    clear: 'Löschen',
    'click-to-upload': 'Klicken Sie hier zum Hochladen',
    'client-frequent-flyer-number': 'Vielfliegernummer',
    clientFrequentFlyerNumber: 'Vielfliegernummer',
    clientFrequentFlightNumber: 'Vielfliegernummer',
    closed: 'Abgeschlossen',
    code: 'Code',
    'collect-shipping-data': 'Versanddaten',
    content: 'Inhalt',
    'copied-link': 'Link {1} in den Transferbereich kopiert!',
    costs: 'Kosten',
    country: 'Land',
    'country-code': 'Landesvorwahl',
    'create-chargeback-from-transaction': 'Create Chargeback',
    'create-checkout': 'Kasse erstellen',
    created: 'Erstellt',
    'created-date': 'Erstellungsdatum',
    creating: 'Erstellen...',
    currency: 'Währung',
    'current-balance': 'Aktueller Kontostand',
    'dashboard-title': 'Dashboard',
    date: 'Datum',
    day: 'Tag',
    days: 'Tage',
    dccAmount: 'DCC Amount',
    'activate-user': 'Benutzer aktivieren',
    'deactivate-user': 'Benutzer deaktivieren',
    declined: 'Abgelehnt',
    deductions: 'Abzüge',
    'delete-attachment-forbidden-error': 'Sie können diesen Anhang nicht löschen',
    denied: 'Bestritten',
    description: 'Beschreibung',
    details: 'Detail',
    'developers-description': 'Bitte halten Sie die Daten so privat wie möglich.',
    'developers-link': 'Lesen Sie mehr über die Integration unserer APIs',
    'developers-subtitle': 'Verwenden Sie den Test-API-Schlüssel, um Ihre Integration zu testen, und den Live-API-Schlüssel, um echte Zahlungen zu erstellen.',
    'developers-title': 'Developers',
    disputing: 'Disputing',
    'drag-drop-file-here': 'Drop your file here',
    download: 'Herunterladen',
    downloading: 'Heruntergeladen...',
    doYouWannaFullChargeback: 'Möchten Sie eine teilweise oder vollständige Rückbuchung vornehmen?',
    doYouWannaFullRefund: 'Möchten Sie eine teilweise oder vollständige Rückerstattung vornehmen?',
    dutch: 'Niederländisch',
    ecommerce: 'Ecommerce',
    'edit-checkout': 'Kasse bearbeiten',
    'edit-checkout-success': 'Social Payment erfolgreich bearbeitet',
    'edit-data': 'Daten bearbeiten',
    editing: 'Bearbeitung...',
    email: 'Email',
    'end-date': 'Enddatum',
    'end-time': 'Endzeit',
    english: 'Englisch',
    environment: 'Umgebung',
    'environment-hint': 'Check to see Production transactions only. Uncheck to see Test transactions only',
    error: 'Fehler',
    'event-type': 'Ereignistyp',
    'expire-at': 'Ablaufen am',
    expired: 'Abgelaufen',
    export: 'Exportieren $1',
    'export-details': 'Exportieren',
    'export-details-help':
      'Bevor Sie das Dateiexportieren starten, unser System verarbeitet Ihre Anfrage. Nach dem Abschluss der Bearbeitung, sendet uns das exportierte Datei direkt an die angegebene E-Mail-Adresse ($1).',
    'export-details-alert': 'Achtung',
    externalTransactionId: 'Externe Transaktions-ID',
    externalCustomId: 'Akquirierer-Id',
    'extra-filters-title': 'Individuelle Filterung',
    failed: 'Gescheitert',
    fees: 'Gebühren',
    'file-sent': '$1 was sent.',
    'file-upload-helper': 'Um eine Datei hochzuladen, klicken Sie auf die Bezeichnung der Eingabe',
    'filter-by': 'Filtern nach $1',
    'filter-by-enter': 'Filtern nach $1 (Drücken Sie Enter, um zu suchen)',
    firstname: 'Vorname',
    'forgot-password': 'Passwort vergessen?',
    french: 'Französisch',
    fulfilled: 'Erfüllt',
    'full-chargeback': 'Vollständige Rückbuchung',
    'full-refund': 'Vollständige Rückerstattung',
    'full-capture': 'Volle Erfassung',
    german: 'Deutsch',
    'getting-started-title': 'Erste Schritte',
    'go-to': 'Gehe zu $1',
    group: 'Gruppen',
    groups: 'Gruppen',
    'group-id': 'Gruppen-ID',
    groupId: 'Gruppe',
    hasChargeback: 'Chargeback zugeordnet',
    'hide-all': 'Alle Ausblenden',
    'manage-columns': 'Spalten Verwalten',
    'search-columns': 'Spalten suchen...',
    'reset-default': 'Auf Standard zurücksetzen',
    'hidden-columns': 'Ausgeblendete Spalten',
    'no-columns-found': 'Keine Spalten gefunden, die Ihrer Suche entsprechen',
    hour: 'Stunde',
    hours: 'Std',
    'transaction-history': 'Transaktionsverlauf',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'in $1 transaktionen',
    initiatedFrom: 'Initiated From',
    'international-shipping-amount': 'Internationaler Versandbetrag',
    'international-urgent-shipping-amount': 'Betrag für internationalen dringenden Versand',
    'invite-error': 'Es ist ein Fehler beim versenden der Einkladung aufgetreten',
    'invite-merchants': 'Händler einladen',
    'invite-sent': 'Die Einladung wurde an $1 versendet. Onboarding-Formular generiert in: $2',
    invoice: 'Rechnungen',
    invoices: 'Rechnungen',
    'is-one-click-payment': 'Is one click',
    isoAmount: 'Amount',
    isOneClickPayment: 'Is one click',
    'item-service-amount': 'Artikel-/Servicebetrag',
    'item-service-description': 'Produkt-/Dienstleistungsbeschreibung',
    'item-service-image': 'Produkt-/Servicebild hochladen',
    'item-service-name': 'Produkt-/Servicename',
    language: 'Sprache',
    'last-month': 'Letzten Monat',
    'last-refunds': 'Letzte $1 rückerstattung',
    'last-revenue': 'Letzter $1 umsatz',
    'last-week': 'Letzte Woche',
    lastFourCardNumber: 'Letzte vier Ziffern der Kartennummer',
    lastname: 'Nachname',
    'latest-payments': 'Letzte Zahlungen (nur Produktion)',
    'link-validity': 'Linkgültigkeit',
    'live-api-key': 'Live-API-Schlüssel',
    loading: 'Loading...',
    'loading-order': 'Loading Order Data',
    'loading-ref-transactions': 'Loadinf related Transactions',
    'loading-transaction': 'Loading Transaction',
    'loading-webhook-attempts': 'Lade Webhook-Versuche',
    'log-into-paybyrd': 'Melden Sie sich bei Paybyrd an',
    login: 'Anmelden',
    logout: 'Ausloggen',
    lost: 'Lost',
    'management-title': 'Verwaltung',
    'manage-user': 'Benutzer verwalten',
    market: 'Markt',
    maskedCardNumber: 'Masked Card Number',
    merchant: 'Händler',
    merchants: 'Händler',
    'merchant-id': 'Händler-ID',
    'merchant-information': 'Händlerinformationen',
    merchantId: 'Händler',
    'message-label': 'Message',
    mode: 'Modus',
    month: 'Monat',
    'monthly-revenue': 'Monatlicher Umsatz (nur Produktion)',
    months: 'Monate',
    name: 'Name',
    'national-shipping-amount': 'Nationaler Versandbetrag',
    'national-urgent-shipping-amount': 'Nationaler Betrag für dringende Sendungen',
    no: 'Nein',
    'no-balance': 'Es gibt kein Saldo für die ausgewählten Filter',
    'no-balance-description': 'Wählen Sie, einen anderen Monat oder eine andere Einheiten',
    'no-chargebacks': 'Für die ausgewählten Filter konnten wir keine Rückbuchung finden',
    'no-chargebacks-subtitle': 'Versuchen Sie es mit einer anderen Filter combination.',
    'no-info': 'Keine Informationen vorhanden',
    'no-invoices': 'Für den ausgewählten Zeitraum liegen keine Rechnungen vor',
    'no-invoices-description': 'Versuchen Sie, ein anderes Jahr auszuwählen',
    'no-onboardings': 'Wir konnten keine Onboarding-Prozesse für die aktuellen Filter finden',
    'no-onboardings-subtitle': 'Versuchen Sie es mit einer anderen Filter combination',
    'no-options': 'No Options',
    'no-orders': 'Es wurden keine Transaktionen für die ausgewählten Filter gefunden',
    'no-orders-subtitle': 'Wählen Sie  einen anderen Zeitschlitz, eine andere Einheit, einen anderen Status oder andere Kanäle aus',
    'no-payments': 'Es gibt keine kürylich erfolgte Transaktionen',
    'no-payments-subtitle': 'Aktualisieren Sie die Daten, um neue Transaktionen zu finden',
    'no-ref-transactions': 'Es gab keine Ergebnisse im Zusammenhang mit dieser Anfrage',
    'no-ref-transactions-subtitle': "'Auf Aktualisieren drücken, um neue Transaktionen zu prüfen'",
    'no-results': 'Keine Ergebnisse',
    'no-settlements': 'Es gibt keine Abrechnungen für den ausgewählten Zeitraum',
    'no-settlements-description': 'Versuchen Sie, einen anderen Monat auszuwählen',
    'no-payouts': 'Es gibt keine Abrechnungen für den ausgewählten Zeitraum',
    'no-shifts': 'Es wurden keine Transaktionen für die ausgewählten Filter gefunden',
    'no-shifts-subtitle': 'Wählen Sie  einen anderen Zeitschlitz, eine andere Einheit, einen anderen Status oder andere Kanäle aus',
    'no-statistics': 'Es gibt keine statistischen Daten für die auswählten Filter',
    'no-statistics-subtitle': 'Wählen Sie einen anderen Zeitraum oder Einheiten aus',
    'no-totals': 'Es sind keine Statistiks für den aktuellen Monat vorhanden',
    'no-totals-subtitle': 'Es sind keine Statistiks für den gewahlten Monat vorhanden',
    'no-transactions': 'Es wurden keine Transaktionen für die ausgewählten Filter gefunden',
    'no-transactions-subtitle': 'Wählen Sie  einen anderen Zeitschlitz, eine andere Einheit, einen anderen Status oder andere Kanäle aus',
    'no-webhooks': 'Es wurden keine Webhooks für die ausgewählten Filter gefunden',
    'no-users': 'Wir konnten keine Transaktionen für die ausgewählten Filter finden',
    'no-users-subtitle': 'Versuchen Sie, einen anderen Filter oder Einheiten oben auszuwählen',
    none: 'None',
    'not-confirmed': 'Nicht bestätigt',
    'not-confirmed-message': 'Auszahlung direkt durch den Acquirer durchgeführt.',
    'not-visible-columns': 'Versteckte Spalten',
    now: 'Jetzt',
    onboarding: 'Benutzer',
    'onboarding-details': 'Onboarding-Details',
    onboardings: 'Onboardings',
    opened: 'Geöffnet',
    'order-amount': 'Auftragsbetrag',
    'order-date': 'Bestelldatum',
    'order-ref': 'Anfragenummer',
    'order-reference': 'Anfragenummer',
    order: 'Anfrage',
    orderCreated: 'Bestellung Erstellt',
    noOrderInfo: 'Keine Bestellinformationen',
    'order-details': 'Bestelldetails',
    orderId: 'Anfrage id',
    orderRef: 'Anfragenummer',
    orderref: 'Anfragenummer',
    orders: 'Aufträge',
    'orders-title': 'Anfrage',
    paid: 'Bezahlt',
    'partially captured': 'Teilweise erfasst',
    'partially refunded': 'Teilweise zurückerstattet',
    'partial-chargeback': 'Teilweise Rückbuchung',
    'partial-refund': 'Teilweise Rückerstattung',
    'partial-capture': 'Teilweise Erfassung',
    password: 'Passwort',
    'pay-by-link-create': 'Neuen Bezahllink erstellen',
    'pay-by-link-description': 'Erstellen, senden Sie Bezahllinks und lassen Sie sich online bezahlen',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Bezahllink',
    'pay-links': 'Bezahllinks',
    payment: 'Zahlung',
    'payment-amount': 'Zahlungsbetrag',
    'payment-batch-not-found': 'Zahlungsbatch nicht gefunden',
    'payment-link-error': 'Es ist ein Fehler beim versenden der Links aufgetreten',
    'payment-link-success': 'Der Zahlungslink wurde erfolgreich versendet.',
    'payment-method': 'Bezahlverfahren',
    paymentDetails: 'Zahlungsdetails',
    recipientInformation: 'Empfängerinformationen',
    configuration: 'Konfiguration',
    paymentId: 'Transaction Id',
    paymentInformation: 'Zahlungsinformation',
    paymentMethod: 'Bezahlverfahren',
    payments: 'Zahlungen',
    'payment-reference': 'Zahlungsreferenz',
    'payments-title': 'Zahlungen',
    'payouts-title': 'Payouts',
    'payout-information': 'Auszahlungsinformationen',
    'payout-title': 'Einzelheiten $1',
    'payouts-warning-message':
      'Diese Funktion ist vorübergehend nicht verfügbar. Wir sind dabei, unser System zu verbessern, um Sie noch besser bedienen zu können. Wir entschuldigen uns für die entstandenen Unannehmlichkeiten und werden uns bemühen, diese Funktion schnellstmöglich wiederherzustellen. Wenn Sie weitere Fragen haben, können Sie uns über die üblichen Kanäle kontaktieren.',
    'payout-paid-message': 'Auszahlung bereits bearbeitet',
    'payout-pending-message': 'Auszahlung noch nicht ausgeführt',
    'payout-no-info-message': 'Auszahlung direkt vom Acquirer bearbeitet',
    pending: 'Ausstehend',
    pendingaction: 'Pending Action',
    pendingmerchantaction: 'Ausstehende Händleraktion',
    period: 'Zeitraum',
    'phone-number': 'Telefonnummer',
    phoneNumber: 'Telefonnummer',
    pnr: 'PNR',
    portuguese: 'Portugiesisch',
    pos: 'POS',
    'pre-auth': 'Pre-Authorization',
    preauth: 'PreAuth',
    'predictions-dispute': 'I want to dispute',
    'preferred-payment-methods': 'Bevorzugte Zahlungsmethoden',
    'previous-revenue': 'Vorheriger Umsatz',
    processing: 'In Bearbeitung',
    prod: 'Produktion',
    quarter: 'Quartal',
    quarters: 'Quartale',
    range: 'Bereich',
    reason: 'Reason for initiating Chargeback',
    'recipient-email': 'Empfänger E-Mail',
    'recipient-name': 'Empfängername',
    'recipient-number': 'Telefonnummer des Empfängers',
    'recover-paybyrd-password': 'Passwort wiederherstellen',
    'recovery-password-success': 'Es wurde einen E-Mail versendet, um Ihr Passwort zurückzusetzen.',
    reference: 'Referenz',
    'reference-ids': 'Referenz-IDs',
    refresh: 'Aktualisierung',
    refund: 'Rückerstattung',
    'refund-amount': 'Rückerstattungsbetrag',
    'refund-confirm-message': 'Do you really want to refund this transaction in the amount of $1?',
    'refund-transaction': 'Rückerstattungstransaktion',
    refunded: 'Zurückerstattet',
    refunding: 'Rückerstattung...',
    refunds: 'Rückerstattungen',
    'refund-create-success': 'Rückerstattung erfolgreich erstellt',
    'register-now': 'Jetzt registrieren',
    'related-operation-status': 'Zugehöriger Vorgangsstatus',
    'related-transactions': 'Zugehörige Transaktionen',
    relatedOperationStatus: 'Related Operation Status',
    release: 'Release',
    releasing: 'Releasing…',
    remark: 'Remark',
    'request-info': 'Request Info',
    'required-field': 'Dieses Feld ist erforderlich',
    resend: 'Erneut senden',
    'resend-error': 'Es gab einen Fehler beim erneuten Senden des Webhooks ${1}.',
    'resend-success': "Der Webhook '$1' wurde erfolgreich erneut gesendet.",
    resending: 'Erneutes Senden...',
    response: 'Antwort',
    revenue: 'Umsatz',
    'reverse-confirmation': 'Sind Sie sicher, dass Sie die Transaktion mit der ID $1 freigeben möchten?',
    'reverse-create-success': 'Rückbuchung erfolgreich erstellt',
    role: 'Rolle',
    search: 'Suche',
    'search-filters': 'Filter suchen',
    'select-all': 'Wählen Sie Alle',
    'deselect-all': 'Alle abwählen',
    'select-filter': 'Filter auswählen',
    selected: 'ausgewählt',
    'selected-s': '$1 $2 ausgewählt',
    'send-invite': 'Einladungversendet',
    'send-link': 'Link versenden',
    'send-links': 'Links versenden',
    'send-message': 'Send Message',
    'send-message-and-dispute': 'Send message and open Dispute',
    'send-recover-email': 'Wiederherstellungs-E-Mail versenden',
    'send-password-reset': 'Passwort zurücksetzen senden',
    sending: 'Versenden...',
    'sent-at': 'Gesendet am',
    'settings-title': 'Einstellungen',
    'settlement-date': 'Abrechnungsdatum',
    'settlement-details': 'Abrechnungsdetail',
    settlements: 'Abgleich',
    settled: 'Abgerechnet',
    shift: 'Schicht $1',
    'shift-id': 'Schicht Id',
    'shift-details': 'Schichtdetails',
    'shifts-title': 'Schichten',
    'shopper-ip-address': 'IP-Adresse des Käufers',
    shopperEmail: 'E-Mail des Käufers',
    shopperInformation: 'Käuferinformationen',
    shopperIp: 'IP-Adresse des Käufers',
    'show-accessible-stores': 'Zeigt zugängliche Geschäfte',
    'show-all': 'Alle Anzeigen',
    'show-details': 'Details zeigen',
    'signed-up-on': 'Registriert am $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Spanisch',
    'start-date': 'Startdatum',
    'start-time': 'Startzeit',
    'statistics-title': 'Statistiken',
    status: 'Stand',
    stock: 'Menge',
    'stock-quantity': 'Bestandsmenge',
    store: 'Geschäft',
    stores: 'Geschäfte',
    'store-name': 'Geschäftsname',
    storeId: 'Geschäft',
    success: 'Erfolg',
    'system-language': 'Systemsprache',
    'system-timezone': 'Systemzeitzone',
    'team-users': 'Team-Benutzer',
    terminalPassword: 'Neues Passwort',
    'new-password': 'New Password',
    'confirm-new-password': 'Neues Kennwort bestätigen',
    'save-password': 'Passwort Speichern',
    'changing-password': 'Passwort ändern...',
    'confirm-change-password-message': 'Bestätigen Sie die Änderung des Terminal-Passworts?',
    'passwords-do-not-match-message': 'Die Passwörter stimmen nicht überein!',
    'change-terminal-password': 'Terminal-Passwort ändern',
    'password-must-have-six-numbers': 'Das Passwort muss sechs Ziffern enthalten!',
    'password-changed-successfully': 'Passwort erfolgreich geändert!',
    test: 'Test',
    'test-api-key': 'API-Schlüssel testen',
    'this-month': 'Diesen Monat',
    'this-week': 'Diese Woche',
    title: 'Titel',
    today: 'Heute',
    total: 'Gesamt',
    'total-amount': 'Gesamtsumme',
    'total-revenue': 'Gesamtumsatz',
    totals: 'Gesamt',
    'totals-per': 'Summen pro $1',
    'transaction-details': 'Einzelheiten der Transaktion',
    'transaction-type': 'Art der Transaktion',
    transactionId: 'Transaction Id',
    transactions: 'transaktionen',
    'transactions-count': 'Anzahl von Transaktionen',
    'transactions-title': 'Transaktionen',
    'transactions-volume': 'Transaktionsvolumen',
    'transactions-multiple-currencies-found': 'Wenn mehrere Währungen ausgewählt sind, wird der Gesamtumsatz/Betrag möglicherweise nicht angezeigt.',
    type: 'Typ',
    unit: 'Laden Sie',
    units: 'Läden',
    user: 'Benutzer',
    'user-action-title': 'Bist du sicher?',
    'user-action-password-reset-confirmation': 'Sind Sie sicher, dass Sie das Benutzerpasswort zurücksetzen möchten?',
    'user-action-password-reset-success': 'E-Mail zum Zurücksetzen des Passworts erfolgreich gesendet!',
    'user-action-activate-user-confirmation': 'Sind Sie sicher, dass Sie den Benutzer aktivieren möchten?',
    'user-action-activate-user-success': 'Benutzer erfolgreich aktiviert!',
    'user-action-deactivate-user-confirmation': 'Sind Sie sicher, dass Sie den Benutzer deaktivieren möchten?',
    'user-action-deactivate-user-success': 'Benutzer erfolgreich deaktiviert!',
    'user-blocked': 'Blockiert',
    'user-details': 'Benutzerdetails',
    'user-profile-title': 'Benutzerprofil',
    'user-profile-subtitle': 'Verwalten Sie Ihre Kontoeinstellungen und Präferenzen',
    'appearance-settings': 'Erscheinungsbild',
    'appearance-settings-description': 'Passen Sie das visuelle Theme und die Anzeigeeinstellungen an',
    'language-settings': 'Sprache & Region',
    'language-settings-description': 'Stellen Sie Ihre bevorzugte Sprache und regionale Einstellungen ein',
    'timezone-settings': 'Datum & Zeit',
    'timezone-settings-description': 'Konfigurieren Sie Ihre Zeitzone und Datumsformat-Präferenzen',
    'theme-mode': 'Theme-Modus',
    'theme-mode-description': 'Wählen Sie zwischen hellem und dunklem Theme',
    'light-mode': 'Hell',
    'dark-mode': 'Dunkel',
    'system-language-description': 'Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche',
    'system-timezone-description': 'Wählen Sie Ihre Zeitzone für genaue Datum- und Zeitanzeige',
    'connected-stores': 'Verbundene Geschäfte',
    'dashboard-user': 'Dashboard-Benutzer',
    'validation-max-chars': 'Die maximale Länge für dieses Feld beträgt $1 Zeichen',
    'view-by': 'Ansicht pro $1',
    'view-details': 'Details anzeigen',
    'view-less': 'Weniger Anzeigen',
    'view-more': '+$1 mehr',
    'view-transaction-details-hint': 'Klicken Sie hier, um Details zur Transaktion anzuzeigen',
    'visible-columns': 'Sichtbare Spalten',
    volume: 'Volumen',
    webhooks: 'Webhooks',
    week: 'Woche',
    weeks: 'Wochen',
    won: 'Won',
    year: 'Jahr',
    years: 'Jahre',
    yes: 'Ja',
    yesterday: 'Gestern',

    // AI Assistant
    ai_smart_assistant_title: 'KI Assistent',
    ai_smart_assistant_smart_suggestions: 'Intelligente Vorschläge',
    ai_smart_assistant_smart_suggestions_description: 'Vorkonfigurierte Eingabeaufforderungen für gängige Geschäftsvorgänge. Füllen Sie die Details aus und führen Sie sofort aus.',
    ai_smart_assistant_your_question: 'Ihre Frage',
    ai_smart_assistant_selected_request: 'Ausgewählte Anfrage',
    ai_smart_assistant_ai_response: 'KI-Antwort',
    ai_smart_assistant_ready_help: 'Bereit zu helfen!',
    ai_smart_assistant_ready_help_description: 'Stellen Sie Ihre Frage oder probieren Sie einen der intelligenten Vorschläge aus.',
    ai_smart_assistant_processing: 'Ihre Anfrage wird bearbeitet...',
    ai_smart_assistant_placeholder_confirm: 'Bitte bestätigen oder stornieren Sie die obige Aktion, bevor Sie eine neue Nachricht senden...',
    ai_smart_assistant_placeholder_completed: "Anfrage abgeschlossen. Klicken Sie auf 'Neue Anfrage', um eine neue Unterhaltung zu beginnen...",
    ai_smart_assistant_placeholder_default: 'Fragen Sie mich alles über Ihre Shop-Daten oder probieren Sie die intelligenten Vorschläge aus...',
    ai_smart_assistant_new_request: 'Neue Anfrage',
    ai_smart_assistant_send: 'Senden',
    ai_smart_assistant_request_canceled: 'Die Anfrage wurde vom Benutzer abgebrochen.',
    ai_smart_assistant_processing_button: 'Verarbeitung...',
    ai_smart_assistant_characters: 'Zeichen',
    ai_smart_assistant_tip:
      '💡 Tipp: Verwenden Sie Strg+Enter zum Senden • Probieren Sie die intelligenten Vorschläge für schnelle Aktionen • Ich werde vor sensiblen Vorgängen um Bestätigung bitten',
    ai_smart_assistant_confirmation_required: 'Bestätigung Erforderlich',
    ai_smart_assistant_confirmation_description: 'Bitte überprüfen Sie die Antwort unten und bestätigen Sie, ob Sie fortfahren möchten.',
    ai_smart_assistant_confirm: 'Bestätigen',
    ai_smart_assistant_cancel: 'Abbrechen',
    ai_smart_assistant_store_selection: 'Shop-Auswahl',
    ai_smart_assistant_search_stores: 'Tippen Sie, um Shops zu suchen...',
    ai_smart_assistant_configure_api_key: 'API-Schlüssel Konfigurieren',
    ai_smart_assistant_help: 'Hilfe',
    ai_smart_assistant_help_tooltip: 'Dokumentation für KI-Smart-Assistent anzeigen',

    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Bestellungen Exportieren',
    ai_smart_suggestion_export_orders_description: 'Alle bezahlten Bestellungen von gestern exportieren',
    ai_smart_suggestion_create_payment_link: 'Zahlungslink Erstellen',
    ai_smart_suggestion_create_payment_link_description: 'Einen Zahlungslink mit benutzerdefinierten Details generieren',
    ai_smart_suggestion_create_payment_link_template: 'Zahlungslink mit Referenz {orderRef} von {amount} {currency} erstellen und an {email} senden',
    ai_smart_suggestion_refund_transaction: 'Transaktion Erstatten',
    ai_smart_suggestion_refund_transaction_description: 'Eine Erstattung für eine bestimmte Transaktion verarbeiten',
    ai_smart_suggestion_refund_transaction_template: 'Transaktion {transactionId} für {amount} {currency} erstatten',
    ai_smart_suggestion_order_reference: 'Bestellreferenz',
    ai_smart_suggestion_order_reference_placeholder: 'z.B., BST-001',
    ai_smart_suggestion_amount: 'Betrag',
    ai_smart_suggestion_amount_placeholder: 'z.B., 50,00',
    ai_smart_suggestion_currency: 'Währung',
    ai_smart_suggestion_currency_placeholder: 'Währung auswählen',
    ai_smart_suggestion_customer_email: 'Kunden-E-Mail',
    ai_smart_suggestion_customer_email_placeholder: 'kunde@beispiel.com',
    ai_smart_suggestion_execute: 'Ausführen',
    ai_smart_suggestion_missing_fields: 'Bitte füllen Sie alle erforderlichen Felder aus:',
    ai_smart_suggestion_retrieve_transaction: 'Transaktionsdetails Abrufen',
    ai_smart_suggestion_retrieve_transaction_description: 'Detaillierte Informationen über eine bestimmte Transaktion erhalten',
    ai_smart_suggestion_retrieve_transaction_template: 'Bitte rufen Sie die Details für Transaktions-ID {transactionId} ab',
    ai_smart_suggestion_transaction_id: 'Transaktions-ID',
    ai_smart_suggestion_transaction_id_placeholder: 'z.B.: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: 'Export-Format',
    ai_smart_suggestion_export_format_placeholder: 'Format auswählen',
    ai_smart_suggestion_export_orders_template_with_format: 'Bitte exportieren Sie alle bezahlten Bestellungen von gestern im {format}-Format und senden Sie sie an meine E-Mail',
    ai_smart_suggestion_find_order: 'Bestellung nach ID Suchen',
    ai_smart_suggestion_find_order_description: 'Detaillierte Informationen über eine bestimmte Bestellung erhalten',
    ai_smart_suggestion_find_order_template: 'Bitte suchen Sie die Bestellung mit der ID {orderId}',
    ai_smart_suggestion_order_id: 'Bestell-ID',
    ai_smart_suggestion_order_id_placeholder: 'z.B.: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Bestellungen nach Referenz Suchen',
    ai_smart_suggestion_search_orders_by_ref_description: 'Bestellungen der letzten 7 Tage nach Referenz suchen',
    ai_smart_suggestion_search_orders_by_ref_template: 'Bestellungen mit Referenz {orderRef} der letzten 7 Tage suchen',

    // History
    ai_smart_assistant_request_history: 'Anfragehistorie',
    ai_smart_assistant_clear_all: 'Alle Löschen',
    ai_smart_assistant_no_history: 'Noch keine Historie',
    ai_smart_assistant_no_history_description: 'Ihre KI-Anfragen werden hier für einfachen Zugriff gespeichert.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: 'Entschuldigung, beim Verarbeiten Ihrer Bestätigung ist ein Fehler aufgetreten.',
    ai_smart_assistant_error_request: 'Entschuldigung, beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten.',
    ai_smart_assistant_error_api_key: 'API-Schlüssel erforderlich. Bitte konfigurieren Sie ihn zuerst.',
    ai_smart_assistant_error_invalid_api_key: 'Ungültiger API-Schlüssel. Bitte überprüfen Sie Ihre Konfiguration.',
    ai_smart_assistant_error_auth: 'Authentifizierungsproblem. Bitte versuchen Sie sich erneut anzumelden.',

    // user roles
    'user-role': 'Rolle',
    'user-role-admin': 'Administrator',
    'user-role-manager': 'Manager',
    'user-role-developer': 'Entwickler',
    'user-role-finance': 'Finanzen',
    'user-role-operator': 'Operator',
    'user-role-user': 'Benutzer',

    // Getting Started
    welcome: 'Willkommen',
    'welcome-back': 'Willkommen zurück',
    'try-paybyrd': 'Paybyrd ausprobieren',
    'try-paybyrd-description':
      'Verbinden Sie Paybyrd mit Ihrer Website oder Plattform mithilfe unseres Test-API-Schlüssels, um den Integrationsprozess zu erkunden. Nach der Genehmigung Ihres Kontos erhalten Sie Ihren Live-API-Schlüssel, um echte Zahlungen zu akzeptieren.',
    'try-paybyrd-cta': 'Test-API',
    'resume-registration': 'Registrierung fortsetzen',
    'resume-registration-description':
      'Wir benötigen noch einige Informationen und Dokumente von Ihnen. Setzen Sie den Registrierungsprozess fort — Sie machen genau dort weiter, wo Sie aufgehört haben.',
    'resume-registration-help': 'Brauchen Sie Hilfe? Lesen Sie unseren Artikel oder kontaktieren Sie uns im Chat. ',
    'resume-registration-link': 'Registrierung bei Paybyrd',
    'resume-registration-cta': 'Prozess fortsetzen',
    'init-registration': 'Mit Paybyrd starten',
    'init-registration-description':
      'Um Zahlungen zu akzeptieren, müssen Sie zunächst den rechtlichen Onboarding-Prozess abschließen. Halten Sie die folgenden Dokumente und Informationen bereit — Sie können jederzeit pausieren und fortsetzen.',
    'company-details': 'Unternehmensdetails',
    'shareholder-information': 'Informationen zu Gesellschaftern',
    'bank-account-details': 'Bankverbindungsdaten',
    'business-activity-overview': 'Überblick über die Geschäftstätigkeit',
    'init-registration-help': '👉 Mehr Informationen? Lesen Sie unseren Hilfeartikel: ',
    'init-registration-link': 'Registrierung bei Paybyrd',
    'start-registration-cta': 'Registrierung starten',
    'submitted-registration': 'Registrierung eingereicht!',
    'submitted-registration-description':
      'Unser Team prüft Ihre Registrierung. Innerhalb von fünf Werktagen erhalten Sie ein Update per E-Mail. Falls Sie weitere Händler hinzufügen möchten, senden wir Ihnen einen separaten Einladungslink.',
    'submitted-registration-help': 'Fragen? Besuchen Sie unser Hilfe-Center oder schreiben Sie uns im Chat.',
    'submitted-registration-cta': 'Zum Hilfe-Center',
    'go-to-dashboard-cta': 'Zum Dashboard',
    'start-next-onboarding-cta': 'Nächstes Onboarding starten',
    processingData: 'Daten werden verarbeitet',
    'parent-payment-id': 'Haupt-Zahlungs-ID',
    acquirerId: 'Erwerber-ID',
    'shift-code': 'Schichtcode',
    'providing-access-to': 'Zugriff auf $1 wird gewährt',
    'provide-access': 'Zugriff gewähren',
    'select-units-type-to-add': 'Wählen Sie den Einheitstyp zum Hinzufügen aus',
    'access-updated': 'Zugriff aktualisiert!',
    'add-new-access-units': 'Neue Zugriffseinheit hinzufügen',
    'confirm-updating-access': 'Aktualisierung des Zugriffs bestätigen',
    'select-group-add': 'Wählen Sie die hinzuzufügende Gruppe aus',
    'select-merchant-add': 'Wählen Sie den hinzuzufügenden Händler aus',
    'select-store-add': 'Wählen Sie das hinzuzufügende Geschäft aus',
    'all-merchants': 'Alle Händler',
    'all-stores': 'Alle Geschäfte',
    'no-units-selected': 'Keine Einheiten ausgewählt',
    'remove-access': 'Zugriff entfernen',
    'are-you-sure-remove-group': 'Möchten Sie die Gruppe wirklich entfernen?',
    'are-you-sure-remove-merchant': 'Möchten Sie den Händler wirklich entfernen?',
    'are-you-sure-remove-store': 'Möchten Sie das Geschäft wirklich entfernen?',
    next: 'Weiter',
    'success-remove-unit': 'Einheit erfolgreich entfernt',
    'selected-items': '$1 $2 ausgewählt',
    item: 'Element',
    items: 'Elemente',
    'no-unit-selected-label': 'Wenn keine Einheit ausgewählt ist, werden alle verfügbaren Einheiten dem Benutzer hinzugefügt',
    'paybyrd-user': 'Paybyrd-Benutzer mit Zugriff auf alle Händler',
    'no-groups': 'Wir konnten keine Gruppen für den ausgewählten Benutzer finden',
    'no-groups-subtitle': 'Sie können über die obige Schaltfläche neue Zugriffseinheiten hinzufügen',
    'no-merchants': 'Wir konnten keine Händler für den ausgewählten Benutzer finden',
    'no-merchants-subtitle': 'Sie können über die obige Schaltfläche neue Zugriffseinheiten hinzufügen',
    'no-stores': 'Wir konnten keine Geschäfte für den ausgewählten Benutzer finden',
    'no-stores-subtitle': 'Sie können über die obige Schaltfläche neue Zugriffseinheiten hinzufügen',
    'invite-new-users': 'Neue Benutzer einladen',
    'add-emails': 'E-Mails hinzufügen',
    'enter-valid-email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    'invite-new-user': 'Neuen Benutzer einladen',
    invite: 'Einladen',
    close: 'Schließen',
    'feature-access': 'Funktionszugriff',
    'view-feature-access': 'Liste der Zugriffs­funktionen anzeigen',
    'paybylink-description': 'Ermöglicht das Erstellen und Verwalten von Zahlungslinks.',
    'shifts-description': 'Ermöglicht die Erstellung von Schichten.',
    'successfull-invite': 'Einladung erfolgreich gesendet!',
    'manage-role': 'Rolle und Zugriff verwalten',
    'changing-user-roles': 'Benutzerrolle ändern',
    'role-operator': 'Erlaubt die ausgewählte Aktion in den zugänglichen Bereichen.',
    'role-observer': 'Erlaubt die ausgewählte Aktion in den zugänglichen Bereichen.',
    'role-admin': 'Erlaubt volle Kontrolle innerhalb der zugänglichen Bereiche.',
    current: 'Aktuell',
    save: 'Speichern',
    transactionPayout: 'Transaktionsauszahlung',
    paymentReference: 'Zahlungsreferenz',
    threeDSecure: '3D Secure',
    installments: 'Ratenzahlungen',
    installmentAmount: 'Ratenbetrag',
    cardIssuerCountry: 'Ausgabeland der Karte',
    authorizationCode: 'Autorisierungscode',
    LiabilityShift: 'Haftungsübertragung',
    version: 'Version',
    transStatus: '3DS-Transaktionsstatus',
    authorizationStatus: '3DS-Autorisierungsstatus',
    challengeOptions: '3DS-Challenge-Optionen',
    protocolVersion: 'Protokollversion',
    'settlement-status': 'Abrechnung',
    eci: 'ECI',
    done: 'Abgeschlossen',
    inProgress: 'In Bearbeitung',
  },
  nl: {
    'enter-exact-amount': 'Voer het exacte bedrag in',
    'select-currency': 'Selecteer valuta',
    summary: 'Samenvatting',
    ai_chat_title: 'AI-Chatassistent',
    ai_chat_beta: 'BETA',
    ai_chat_greeting: 'Hallo! Ik ben je Paybyrd AI-assistent. Hoe kan ik je vandaag helpen? Ik kan helpen bij betalingsverwerking, transactieaanvragen, terugbetalingen en meer.',
    ai_chat_placeholder: 'Typ je bericht hier...',
    ai_chat_send: 'Bericht versturen',
    ai_chat_close: 'Chat sluiten',
    ai_chat_loading: 'Denken...',
    ai_chat_error: 'Sorry, er is een fout opgetreden. Probeer het later opnieuw.',
    ai_chat_footer: 'AI-assistent is in bèta. Voor kritieke problemen, neem contact op met ondersteuning.',
    ai_chat_store_selection: 'Selecteer een winkel voor context',
    ai_chat_select_store_warning: 'Voor specifiekere hulp, selecteer eerst een winkel.',
    ai_chat_api_key_required: 'API-sleutel is vereist',
    ai_chat_api_key_invalid: 'Ongeldige API-sleutel. Controleer en probeer opnieuw.',
    ai_chat_api_key_missing: 'API-sleutel niet geconfigureerd. Stel je API-sleutel in om de AI-assistent te gebruiken.',
    ai_chat_api_key_configure: 'Configureren',
    ai_chat_api_key_clear: 'Sleutel wissen',
    ai_chat_api_key: 'API-Sleutel',
    ai_chat_api_key_privacy: 'Je API-sleutel wordt veilig opgeslagen in de lokale opslag van je browser en wordt alleen gebruikt voor communicatie met de AI-service.',
    ai_chat_api_config: 'AI-configuratie',
    ai_chat_clear_chat: 'Chat wissen',
    ai_chat_settings: 'Instellingen',
    ai_chat_choose_provider: 'Kies AI-provider',
    ai_chat_openai_info: 'Voer je OpenAI API-sleutel in om GPT-modellen te gebruiken',
    ai_chat_anthropic_info: 'Voer je Anthropic API-sleutel in om Claude-modellen te gebruiken',
    ai_chat_openai_info_tooltip: 'Je kunt een API-sleutel krijgen van platform.openai.com',
    ai_chat_anthropic_info_tooltip: 'Je kunt een API-sleutel krijgen van console.anthropic.com',
    ai_chat_cancel: 'Annuleren',
    ai_chat_save: 'Opslaan',
    ai_chat_provider: 'AI-provider',
    ai_chat_provider_chatgpt: 'ChatGPT',
    ai_chat_provider_claude: 'Claude',
    ai_chat_configure_api_key: 'API-sleutel configureren',
    ai_chat_try_asking: 'Probeer te vragen naar:',
    ai_chat_suggestions_tooltip: 'Suggesties',
    ai_chat_suggestion_1: 'Hoe kan ik een betalingslink maken?',
    ai_chat_suggestion_2: 'Het volledige bedrag van de betaling {paymentid} terugbetalen',
    ai_chat_suggestion_3: 'Wat is de status van mijn laatste betalingslink?',
    ai_chat_suggestion_4: 'Is de bestelling {order_id} al betaald?',
    ai_chat_suggestion_5: 'Maak een betalingslink aan voor {amount} {currency} met referentie {reference} en stuur naar {email}',
    ai_chat_suggestion_6: 'Zoek bestellingen met referentie {order_ref} die gisteren zijn aangemaakt',
    ai_chat_confirm_clear: 'Weet u zeker dat u alle chatberichten wilt wissen?',
    ai_chat_confirm_yes: 'Ja',
    ai_chat_confirm_no: 'Nee',
    'accessible-merchants': 'Toegankelijke handelaren',
    'accessible-stores': 'Toegankelijke winkels',
    'accessible-units': 'Toegankelijke eenheden',
    accept: 'Accept',
    accepted: 'Accepted',
    acquirer: 'Acquirer',
    'acquirer-response': 'Antwoord van de Acquirer',
    'acquirer-response-code': 'Acquirer-Reactiecode',
    'acquirer-response-message': 'Acquirer-reactiebericht',
    acquirerfailed: 'Mislukt',
    acquirerReferenceNumber: 'Acquirer Referentienummer (ARN)',
    acquirerResponseCode: 'Acquirer-Reactiecode',
    acquirerResponseMessage: 'Acquirer-reactiebericht',
    acquirersuccess: 'Succes',
    actions: 'Acties',
    add: 'Create',
    'add-filter': 'Filter toevoegen',
    'administration-title': 'Administratie',
    all: 'Allen',
    amount: 'Aantal',
    'amount-greater-than-limit': 'Het bedrag is groter dan het transactiebedrag',
    'analytics-title': 'Analytics',
    'api-key-not-created': 'API Key niet aangemaakt',
    'api-key-copied': 'API Key gekopieerd naar klembord',
    'no-api-keys-title': 'Geen API Keys gevonden',
    'no-api-keys-description': 'Maak API keys aan om te beginnen met integreren met ons platform',
    'copy-to-clipboard': 'Kopieer naar klembord',
    'api-keys': 'API Keys',
    channel: 'Kanaal',
    apply: 'Toepassen',
    'apply-filters': 'Filters toepassen',
    'applied-filters': 'Het filter wordt op uw dashboard toegepast',
    'aquirer-authorization-code': 'Acquirer-autorisatiecode',
    aquirerAuthorizationCode: 'Acquirer-autorisatiecode',
    'attachment-not-found-error': 'Bijlage niet gevonden',
    attempt: 'Poging',
    back: 'Terug',
    'back-to-payouts': 'Terug naar uitbetalingen',
    'batch-id': 'Batch-identificatiecode',
    brand: 'Merk',
    cardScheme: 'Card Scheme',
    wallet: 'Digital Wallet',
    businessName: 'Business Name',
    cancel: 'Annuleer',
    canceled: 'Geannuleerd',
    capture: 'Capture',
    'capture-create-success': 'Inning succesvol aangemaakt',
    'capture-transaction': 'Capture transactie',
    captured: 'Captured',
    capturing: 'Capturing...',
    'card-holder-name': 'Naam kaarthouder',
    'card-number': 'Kaartnummer',
    cardHolderName: 'Naam kaarthouder',
    cardNumber: 'Kaartnummer',
    category: 'Category',
    'custom-filters': 'Aangepaste filters',
    modes: 'Modes',
    chargeback: 'Chargeback',
    'chargeback-chat': 'Chargeback process comunitaction',
    'chargeback-create-success': 'Chargeback successfully created',
    'chargeback-confirm-attachment-delete': 'Bijlage verwijderen?',
    'chargeback-files': 'Chargeback process files',
    'chargeback-information': 'General Information',
    'chargeback-order-creationReason': 'Chargeback creation Reason',
    'chargeback-order-information': 'Order Information',
    'chargeback-ref': 'Referentie',
    'chargeback-store-information': 'Store Information',
    'chargeback-store-name': 'Winkel naam',
    'chargeback-title': 'Chargebacks',
    'chargeback-title-add': 'Iniciar processo de Disputa',
    'chargeback-transaction-information': 'Transation Information',
    chargebackRef: 'Chargeback-referentie',
    chargebacks: 'Terugboekingen',
    'choose-file-type': 'Kies het bestandstype',
    clear: 'Opschonen',
    'click-to-upload': 'Klik hier om te uploaden',
    'client-frequent-flyer-number': 'Frequent Flyer Nummer',
    clientFrequentFlyerNumber: 'Frequent Flyer Nummer',
    clientFrequentFlightNumber: 'Frequent Flyer Nummer',
    closed: 'Afgesloten',
    code: 'Code',
    'collect-shipping-data': 'Verzendgegevens verzamelen',
    content: 'Inhoud',
    'copied-link': 'Link {1} gekopieerd naar het overdrachtsgebied!',
    costs: 'Kosten',
    country: 'Land',
    'country-code': 'Landcode',
    'create-chargeback-from-transaction': 'Create Chargeback',
    'create-checkout': 'Betaling opmaken',
    created: 'Gecreerd',
    'created-date': 'Aanmaak Datum',
    creating: 'Creëren...',
    currency: 'Valuta',
    'current-balance': 'Huidige Saldo',
    'dashboard-title': 'Dashboard',
    date: 'Datum',
    day: 'Dag',
    days: 'Dagen',
    dccAmount: 'DCC Amount',
    'activate-user': 'Gebruiker activeren',
    'deactivate-user': 'Gebruiker deactiveren',
    declined: 'Afgewezen',
    deductions: 'Inhoudingen',
    'delete-attachment-forbidden-error': 'U kunt deze bijlage niet verwijderen',
    denied: 'Afgewezen',
    description: 'Beschrijving',
    details: 'Details',
    'developers-description': 'Houdt deze privé zover als mogelijk.',
    'developers-link': 'Lees meer over de API integratie',
    'developers-subtitle': 'Gebruik de Test API Key om de integratie te testen, and the Live API Key voor de daadwerkelijke betalingen.',
    'developers-title': 'Developers',
    disputing: 'Disputing',
    'drag-drop-file-here': 'Drop your file here',
    download: 'Download',
    downloading: 'Downloading...',
    doYouWannaFullChargeback: 'Wilt u een gedeeltelijke of volledige terugboeking doen?',
    doYouWannaFullRefund: 'Wilt u een gedeeltelijke of volledige terugbetaling doen?',
    dutch: 'Nederlands',
    ecommerce: 'Ecommerce',
    'edit-checkout': 'Betaling bewerken',
    'edit-checkout-success': 'Social Payment succesvol bewerkt',
    'edit-data': 'Gegevens bewerken',
    editing: 'Bewerken...',
    email: 'Email',
    'end-date': 'Einddatum',
    'end-time': 'Eindtijd',
    english: 'Engels',
    environment: 'Omgeving',
    'environment-hint': 'Check to see Production transactions only. Uncheck to see Test transactions only',
    error: 'Fout',
    'event-type': 'Gebeurtenistype',
    'expire-at': 'Verlopen op',
    expired: 'Verlopen',
    export: 'Export $1',
    'export-details': 'Export',
    'export-details-help':
      'Wanneer je begint met het exporteren van je bestand, zal ons systeem je verzoek verwerken. Zodra de verwerking is voltooid, sturen we het geëxporteerde bestand rechtstreeks naar het e-mailadres dat aan je account is gekoppeld ($1).',
    'export-details-alert': 'Attentie',
    externalTransactionId: 'Extern Transactie-ID',
    externalCustomId: 'Acquirer-Id',
    'extra-filters-title': 'Aangepaste Filtering',
    failed: 'Mislukt',
    fees: 'Tarieven',
    'file-sent': '$1 was sent.',
    'file-upload-helper': 'Om een bestand te uploaden, klik in het label van de invoer',
    'filter-by': 'Filter met $1',
    'filter-by-enter': 'Filteren op $1 (Druk op Enter om te zoeken)',
    firstname: 'Voornaam',
    'forgot-password': 'Wachtwoord Vergeten?',
    french: 'Frans',
    fulfilled: 'Vervuld',
    'full-chargeback': 'Volledige terugboeking',
    'full-refund': 'Volledige terugbetaling',
    'full-capture': 'Volledige vastlegging',
    german: 'Duits',
    'getting-started-title': 'Aan de Slag',
    'go-to': 'Go to $1',
    group: 'Groeps',
    groups: 'Groepen',
    'group-id': 'Groeps-ID',
    groupId: 'Groep',
    hasChargeback: 'Chargeback Geassocieerd',
    'hide-all': 'Alles Verbergen',
    'manage-columns': 'Kolommen Beheren',
    'search-columns': 'Kolommen zoeken...',
    'reset-default': 'Herstellen naar standaard',
    'hidden-columns': 'Verborgen Kolommen',
    'no-columns-found': 'Geen kolommen gevonden die overeenkomen met uw zoekopdracht',
    hour: 'Uur',
    hours: 'Uren',
    iban: 'IBAN',
    id: 'ID',
    'in-transactions': 'in $1 transacties',
    initiatedFrom: 'Initiated From',
    'international-shipping-amount': 'Verzendkosten internationaal',
    'international-urgent-shipping-amount': 'Prioriteit Verzendkosten internationaal',
    'invite-error': 'Er was een fout bij het verzenden van de uitnodiging.',
    'invite-merchants': 'Uitnodiging Merhants',
    'invite-sent': 'De uitnodiging is verstuurd aan $1. Onboarding formulier genereerd op: $2',
    invoice: 'Facture',
    invoices: 'Facturen',
    'is-one-click-payment': 'Is one click',
    isoAmount: 'Amount',
    isOneClickPayment: 'Is one click',
    'item-service-amount': 'Bedrag artikel/service',
    'item-service-description': 'Artikel-/servicebeschrijving',
    'item-service-image': 'Afbeelding van item/service uploaden',
    'item-service-name': 'Naam item/service',
    language: 'Taal',
    'last-month': 'Vorige maand',
    'last-refunds': 'Laatste $1 terugbetaling',
    'last-revenue': 'Laatste $1 omzet',
    'last-week': 'Vorige week',
    lastFourCardNumber: 'Laatste Vier Cijfers van het Kaartnummer',
    lastname: 'Achternaam',
    'latest-payments': 'Laatste betalingen (alleen productie)',
    'link-validity': 'Link Geldigheid',
    'live-api-key': 'Live API Key',
    loading: 'Loading...',
    'loading-order': 'Loading Order Data',
    'loading-ref-transactions': 'Loadinf related Transactions',
    'loading-transaction': 'Loading Transaction',
    'loading-webhook-attempts': 'Webhook-pogingen laden',
    'log-into-paybyrd': 'Inloggen op Paybyrd',
    login: 'Inloggen',
    logout: 'Uitloggen',
    lost: 'Lost',
    'management-title': 'Management',
    'manage-user': 'Gebruiker beheren',
    market: 'Markt',
    maskedCardNumber: 'Masked Card Number',
    merchant: 'Verkoper',
    merchants: 'Handelaars',
    'merchant-id': 'Verkoper-ID',
    'merchant-information': 'Verkopersinformatie',
    merchantId: 'Verkoper',
    'message-label': 'Message',
    mode: 'Mode',
    month: 'Maand',
    'monthly-revenue': 'Maandelijkse omzet (alleen productie)',
    months: 'Maanden',
    name: 'Naam',
    'national-shipping-amount': 'Verzendkosten nationaal',
    'national-urgent-shipping-amount': 'Prioriteit Verzendkosten nationaal',
    no: 'Nee',
    'no-balance': 'We konden geen saldo vinden met de geselecteerde filters',
    'no-balance-description': 'Selecteer een andere maand of eenheid ',
    'no-chargebacks': 'We konden geen terugboekingen vinden voor de geselecteerde filters',
    'no-chargebacks-subtitle': 'Probeer een andere combinatie',
    'no-info': 'Geen informatie',
    'no-invoices': 'Er zijn geen facturen voor de geselecteerde periode',
    'no-invoices-description': 'Selecteer een ander jaar',
    'no-onboardings': 'Er zijn geen onboarding processen voor de huidig filters',
    'no-onboardings-subtitle': 'Probeer een andere combinatie',
    'no-options': 'No Options',
    'no-orders': 'We krijgen geen transacties gevonden met de gekozen filters',
    'no-orders-subtitle': 'Graag een ander selectie te maken ',
    'no-payments': 'Geen recente transacties',
    'no-payments-subtitle': 'Vernieuw om te zien of nieuwe transacties beschikbaar zijn',
    'no-ref-transactions': 'We zien geen relaterde transacties voor deze order',
    'no-ref-transactions-subtitle': 'Vernieuw om te zien of nieuwe transacties beschikbaar zijn',
    'no-results': 'Geen resultaten',
    'no-payouts': 'Er zijn geen settlements voor de geselecteerde periode',
    'no-settlements': 'Er zijn geen settlements voor de geselecteerde periode',
    'no-settlements-description': 'Selecteer een andere maand',
    'no-shifts': 'We krijgen geen transacties gevonden met de gekozen filters',
    'no-shifts-subtitle': 'Graag een ander selectie te maken ',
    'no-statistics': 'We krijgen geen transacties gevonden met de gekozen filters',
    'no-statistics-subtitle': 'Selecteer een andere periuode of unit ',
    'no-totals': 'Geen statistieken beschikbaar voor de huidige maand',
    'no-totals-subtitle': 'Bekijk statistiek pagina voor andere periodes',
    'no-transactions': 'We krijgen geen transacties gevonden met de geselecteerde filters',
    'no-transactions-subtitle': 'Graag een ander selectie te maken ',
    'no-webhooks': 'We krijgen geen webhooks gevonden met de geselecteerde filters',
    'no-users': 'We konden geen transacties vinden voor de geselecteerde filters',
    'no-users-subtitle': 'Probeer hierboven een andere filter of eenheden te selecteren',
    none: 'None',
    'not-confirmed': 'Niet bevestigd',
    'not-confirmed-message': 'Uitbetaling rechtstreeks uitgevoerd door de acquirer.',
    'not-visible-columns': 'Verborgen Kolommen',
    now: 'Nu',
    onboarding: 'Onboarding',
    'onboarding-details': 'Onboarding details',
    onboardings: 'Onboardings',
    opened: 'Geopend',
    'order-amount': 'Order hoeveelheid',
    'order-date': 'Besteldatum',
    'order-ref': 'Bestelreferentie',
    'order-reference': 'Order Reference',
    order: 'Bestel',
    orderCreated: 'Order Created',
    noOrderInfo: 'No Order Info',
    orderId: 'Bestelnummer',
    orderref: 'Bestelreferentie',
    orderRef: 'Bestelreferentie',
    orders: 'Bestellingen',
    'orders-title': 'Orders',
    paid: 'Betaald',
    'partially captured': 'Partially captured',
    'partially refunded': 'Partially refunded',
    'partial-chargeback': 'Gedeeltelijke terugboeking',
    'partial-refund': 'Gedeeltelijke terugbetaling',
    'partial-capture': 'Gedeeltelijke vastlegging',
    password: 'Wachtwoord',
    'pay-by-link-create': 'Creëer nieuwe betaallink',
    'pay-by-link-description': 'Creëer, verzend betaallinks en wordt online betaald',
    'pay-by-link-title': 'Pay by Link',
    'pay-link': 'Betaallink',
    'pay-links': 'Betaallinks',
    payment: 'Betaling',
    'payment-amount': 'Betaal hoeveelheid',
    'payment-batch-not-found': 'Betalingsbatch niet gevonden',
    'payment-link-error': 'Er is een fout bij het verzenden van de links',
    'payment-link-success': 'Payment link was successvol verzonden.',
    'payment-method': 'Betaalmethode',
    paymentDetails: 'Betalingsgegevens',
    recipientInformation: 'Gegevens Ontvanger',
    configuration: 'Configuratie',
    paymentId: 'Transaction Id',
    paymentInformation: 'Payment Information',
    paymentMethod: 'Payment Method',
    payments: 'Betalingen',
    'payment-reference': 'Betalingsreferentie',
    'payments-title': 'Betalingen',
    'payouts-title': 'Uitbetalingen',
    'payout-information': 'Uitbetalingsinformatie',
    'payout-title': 'Detail $1',
    'payouts-warning-message':
      'Deze functie is tijdelijk niet beschikbaar. We brengen verbeteringen aan in ons systeem om je nog beter van dienst te kunnen zijn. We verontschuldigen ons voor het ongemak en zullen deze functionaliteit zo snel mogelijk herstellen. Voor verdere opheldering kun je contact met ons opnemen via de gebruikelijke kanalen.',
    'payout-paid-message': 'Uitbetaling al verwerkt',
    'payout-pending-message': 'Uitbetaling nog niet uitgevoerd',
    'payout-no-info-message': 'Uitbetaling rechtstreeks verwerkt door de acquirer',
    pending: 'Bezig',
    pendingaction: 'Pending Action',
    pendingmerchantaction: 'Handelaarsactie in behandeling',
    period: 'Periode',
    'phone-number': 'Telefoonnummer',
    phoneNumber: 'Telefoonnummer',
    pnr: 'PNR',
    portuguese: 'Portugees',
    pos: 'POS',
    'pre-auth': 'Pre-Auth',
    preauth: 'PreAuth',
    'predictions-dispute': 'I want to dispute',
    'preferred-payment-methods': 'Voorkeurs Betaalmethode',
    'previous-revenue': 'Previous Revenue',
    processing: 'Verwerken',
    prod: 'Productie',
    quarter: 'Kwartaal',
    quarters: 'Kwartalen',
    range: 'Kalender',
    reason: 'Reason for initiating Chargeback',
    'recipient-email': 'Ontvanger Email',
    'recipient-name': 'Ontvanger Naam',
    'recipient-number': 'Ontvanger Telefoonnummer',
    'recover-paybyrd-password': 'Herstel Wachtwoord',
    'recovery-password-success': 'We hebben je een e-mail gestuurd om je wachtwoord opnieuw in te stellen.',
    reference: 'Referentie',
    'reference-ids': 'Referentie-ids',
    refresh: 'Vernieuw',
    refund: 'Terugbetaling',
    'refund-amount': 'Terugbetaling hoeveelheid',
    'refund-confirm-message': 'Do you really want to refund this transaction in the amount of $1?',
    'refund-transaction': 'Terugstorting van transactie',
    refunded: 'Teruggestort',
    refunding: 'Terugbetaling...',
    refunds: 'Terugbetalingen',
    'refund-create-success': 'Terugbetaling succesvol aangemaakt',
    'register-now': 'Registreer Nu',
    'related-operation-status': 'Gerelateerde bewerkingsstatus',
    'related-transactions': 'Gerelateerde Transacties',
    relatedOperationStatus: 'Related Operation Status',
    release: 'Release',
    releasing: 'Releasing...',
    remark: 'Remark',
    'request-info': 'Request Info',
    'required-field': 'Dit veld is verplicht',
    resend: 'Opnieuw verzenden',
    'resend-error': 'Er trad een fout op bij het opnieuw verzenden van de webhook ${1}.',
    'resend-success': "De webhook '$1' is succesvol opnieuw verzonden.",
    resending: 'Opnieuw verzenden...',
    response: 'Reactie',
    revenue: 'Omzet',
    'reverse-confirmation': 'Weet u zeker dat u de transactie met de ID $1 wilt vrijgeven?',
    'reverse-create-success': 'Terugboeking succesvol aangemaakt',
    role: 'Rol',
    search: 'Zoek op',
    'search-filters': 'Filters zoeken',
    'select-all': 'Selecteer Alles',
    'deselect-all': 'Alles deselecteren',
    'select-filter': 'Filter selecteren',
    selected: 'geselecteerd',
    'selected-s': '$1 $2 geselecteerd',
    'send-invite': 'Verzend uitnodiging',
    'send-link': 'Verzend link',
    'send-links': 'Verzend links',
    'send-message': 'Send Message',
    'send-message-and-dispute': 'Send message and open Dispute',
    'send-password-reset': 'Wachtwoord reset verzenden',
    'send-recover-email': 'Verstuur herstel Email',
    sending: 'Verzenden...',
    'sent-at': 'Verzonden op',
    'settings-title': 'Instellingen',
    'settlement-date': 'Settlement Date',
    'settlement-details': 'Settlement Details',
    settlements: 'Verrekening',
    settled: 'Afgewikkeld',
    shift: 'Shift $1',
    'shift-id': 'Shift Id',
    'shift-details': 'Shift Details',
    'shifts-title': 'Shifts',
    'shopper-ip-address': 'IP-adres van de Koper',
    shopperEmail: 'E-mail van de Koper',
    shopperInformation: 'Shopperinformatie',
    shopperIp: 'IP-adres van de Koper',
    'show-accessible-stores': 'Toont toegankelijke winkels',
    'show-all': 'Alles Weergeven',
    'show-details': 'Deel details',
    'signed-up-on': 'Aangemeld op $1',
    'social-payments-title': 'Social Payments',
    spanish: 'Spaans',
    'start-date': 'Start Datum',
    'start-time': 'Starttijd',
    'statistics-title': 'Statistiek',
    status: 'Status',
    stock: 'Voorraad',
    'stock-quantity': 'Hoeveelheid voorraad',
    store: 'Winkel',
    stores: 'Winkels',
    'store-name': 'Winkel naam',
    storeId: 'Winkel',
    success: 'Succes',
    'system-language': 'System Taal',
    'system-timezone': 'Systeem Tijdszone',
    'team-users': 'Teamgebruikers',
    terminalPassword: 'Wachtwoord Terminal',
    'new-password': 'Nieuw Wachtwoord',
    'confirm-new-password': 'Bevestig Nieuw Wachtwoord',
    'save-password': 'Wachtwoord Opslaan',
    'changing-password': 'Wachtwoord Wijzigen...',
    'confirm-change-password-message': 'Wijziging wachtwoord Terminal bevestigen?',
    'passwords-do-not-match-message': 'Wachtwoorden komen niet overeen!',
    'change-terminal-password': 'Wijzig je Terminal wachtwoord',
    'password-must-have-six-numbers': 'Het wachtwoord moet uit zes cijfers bestaan!',
    'password-changed-successfully': 'Wachtwoord succesvol gewijzigd!',
    test: 'Test',
    'test-api-key': 'Test API Key',
    'this-month': 'Deze maand',
    'this-week': 'Deze week',
    title: 'Titel',
    today: 'Vandaag',
    total: 'Totaal',
    'total-amount': 'Totaal bedrag',
    'total-revenue': 'Totaal omzeet',
    totals: 'Totalen',
    'totals-per': 'Totalen per $1',
    'transaction-details': 'Transactiegegevens',
    'transaction-type': 'Transactie Type',
    transactionId: 'Transaction Id',
    transactions: 'transacties',
    'transactions-count': 'Transactions Count',
    'transactions-title': 'Transacties',
    'transactions-volume': 'Transactions Volume',
    'transactions-multiple-currencies-found': `Wanneer meerdere valuta's zijn geselecteerd, kan de totale omzet/het bedrag mogelijk niet worden weergegeven.`,
    type: 'Type',
    unit: 'Winkel',
    units: 'Winkels',
    user: 'Gebruiker',
    'user-action-title': 'Weet je het zeker?',
    'user-action-password-reset-confirmation': 'Weet je zeker dat je het wachtwoord van de gebruiker wilt resetten?',
    'user-action-password-reset-success': 'E-mail voor wachtwoordherstel succesvol verzonden!',
    'user-action-activate-user-confirmation': 'Weet je zeker dat je de gebruiker wilt activeren?',
    'user-action-activate-user-success': 'Gebruiker succesvol geactiveerd!',
    'user-action-deactivate-user-confirmation': 'Weet je zeker dat je de gebruiker wilt deactiveren?',
    'user-action-deactivate-user-success': 'Gebruiker succesvol gedeactiveerd!',
    'user-blocked': 'Geblokkeerd',
    'user-details': 'Gebruikersgegevens',
    'user-profile-title': 'Gebruikersprofiel',
    'user-profile-subtitle': 'Beheer uw accountinstellingen en voorkeuren',
    'appearance-settings': 'Uiterlijk',
    'appearance-settings-description': 'Pas het visuele thema en weergavevoorkeuren aan',
    'language-settings': 'Taal & Regio',
    'language-settings-description': 'Stel uw voorkeurstaal en regionale instellingen in',
    'timezone-settings': 'Datum & Tijd',
    'timezone-settings-description': 'Configureer uw tijdzone en datumformaat voorkeuren',
    'theme-mode': 'Thema Modus',
    'theme-mode-description': 'Kies tussen licht en donker thema',
    'light-mode': 'Licht',
    'dark-mode': 'Donker',
    'system-language-description': 'Selecteer uw voorkeurstaal voor de interface',
    'system-timezone-description': 'Kies uw tijdzone voor nauwkeurige datum- en tijdweergave',
    'connected-stores': 'Verbonden Winkels',
    'dashboard-user': 'Dashboard Gebruiker',
    'validation-max-chars': 'De maximum lengte voor dit veld is $1 karakters',
    'view-by': 'Beeld met $1',
    'view-details': 'Details bekijken',
    'view-less': 'Minder Weergeven',
    'view-more': '+$1 meer',
    'view-transaction-details-hint': 'Klik om transactiegegevens te bekijken',
    'visible-columns': 'Zichtbare Kolommen',
    volume: 'Volume',
    webhooks: 'Webhooks',
    week: 'Week',
    weeks: 'Weken',
    won: 'Won',
    year: 'Jaar',
    years: 'Jaren',
    yes: 'Ja',
    yesterday: 'Gisteren',

    // AI Assistant
    ai_smart_assistant_title: 'AI Assistent',
    ai_smart_assistant_smart_suggestions: 'Slimme Suggesties',
    ai_smart_assistant_smart_suggestions_description: 'Vooraf geconfigureerde prompts voor veelvoorkomende bedrijfsactiviteiten. Vul de details in en voer direct uit.',
    ai_smart_assistant_your_question: 'Uw Vraag',
    ai_smart_assistant_selected_request: 'Geselecteerd Verzoek',
    ai_smart_assistant_ai_response: 'AI Antwoord',
    ai_smart_assistant_ready_help: 'Klaar om te helpen!',
    ai_smart_assistant_ready_help_description: 'Stel uw vraag of probeer een van de slimme suggesties.',
    ai_smart_assistant_processing: 'Uw verzoek wordt verwerkt...',
    ai_smart_assistant_placeholder_confirm: 'Bevestig of annuleer de bovenstaande actie voordat u een nieuw bericht verzendt...',
    ai_smart_assistant_placeholder_completed: "Verzoek voltooid. Klik op 'Nieuw Verzoek' om een nieuw gesprek te starten...",
    ai_smart_assistant_placeholder_default: 'Vraag me alles over uw winkelgegevens of probeer de slimme suggesties...',
    ai_smart_assistant_new_request: 'Nieuw Verzoek',
    ai_smart_assistant_send: 'Verzenden',
    ai_smart_assistant_request_canceled: 'Het verzoek is geannuleerd door de gebruiker.',
    ai_smart_assistant_processing_button: 'Verwerken...',
    ai_smart_assistant_characters: 'tekens',
    ai_smart_assistant_tip:
      '💡 Tip: Gebruik Ctrl+Enter om te verzenden • Probeer de slimme suggesties voor snelle acties • Ik vraag bevestiging voordat ik gevoelige bewerkingen uitvoer',
    ai_smart_assistant_confirmation_required: 'Bevestiging Vereist',
    ai_smart_assistant_confirmation_description: 'Bekijk het onderstaande antwoord en bevestig of u wilt doorgaan.',
    ai_smart_assistant_confirm: 'Bevestigen',
    ai_smart_assistant_cancel: 'Annuleren',
    ai_smart_assistant_store_selection: 'Winkelselectie',
    ai_smart_assistant_search_stores: 'Typ om winkels te zoeken...',
    ai_smart_assistant_configure_api_key: 'API-sleutel Configureren',
    ai_smart_assistant_help: 'Hulp',
    ai_smart_assistant_help_tooltip: 'Bekijk documentatie voor AI Smart Assistent',

    // Smart Suggestions
    ai_smart_suggestion_export_orders: 'Bestellingen Exporteren',
    ai_smart_suggestion_export_orders_description: 'Alle betaalde bestellingen van gisteren exporteren',
    ai_smart_suggestion_create_payment_link: 'Betaallink Maken',
    ai_smart_suggestion_create_payment_link_description: 'Een betaallink genereren met aangepaste details',
    ai_smart_suggestion_create_payment_link_template: 'Betaallink maken met referentie {orderRef} van {amount} {currency} en verzenden naar {email}',
    ai_smart_suggestion_refund_transaction: 'Transactie Terugbetalen',
    ai_smart_suggestion_refund_transaction_description: 'Een terugbetaling verwerken voor een specifieke transactie',
    ai_smart_suggestion_refund_transaction_template: 'Transactie {transactionId} terugbetalen voor {amount} {currency}',
    ai_smart_suggestion_order_reference: 'Bestelreferentie',
    ai_smart_suggestion_order_reference_placeholder: 'bijv., BST-001',
    ai_smart_suggestion_amount: 'Bedrag',
    ai_smart_suggestion_amount_placeholder: 'bijv., 50,00',
    ai_smart_suggestion_currency: 'Valuta',
    ai_smart_suggestion_currency_placeholder: 'Selecteer valuta',
    ai_smart_suggestion_customer_email: 'Klant E-mail',
    ai_smart_suggestion_customer_email_placeholder: 'klant@voorbeeld.com',
    ai_smart_suggestion_execute: 'Uitvoeren',
    ai_smart_suggestion_missing_fields: 'Vul alle vereiste velden in:',
    ai_smart_suggestion_retrieve_transaction: 'Transactiedetails Ophalen',
    ai_smart_suggestion_retrieve_transaction_description: 'Gedetailleerde informatie over een specifieke transactie verkrijgen',
    ai_smart_suggestion_retrieve_transaction_template: 'Haal de details op voor transactie ID {transactionId}',
    ai_smart_suggestion_transaction_id: 'Transactie ID',
    ai_smart_suggestion_transaction_id_placeholder: 'bijv: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_export_format: 'Export Formaat',
    ai_smart_suggestion_export_format_placeholder: 'Selecteer formaat',
    ai_smart_suggestion_export_orders_template_with_format: 'Exporteer alle betaalde bestellingen van gisteren in {format} formaat en stuur ze naar mijn email',
    ai_smart_suggestion_find_order: 'Bestelling Zoeken op ID',
    ai_smart_suggestion_find_order_description: 'Gedetailleerde informatie over een specifieke bestelling verkrijgen',
    ai_smart_suggestion_find_order_template: 'Zoek de bestelling met ID {orderId}',
    ai_smart_suggestion_order_id: 'Bestel-ID',
    ai_smart_suggestion_order_id_placeholder: 'bijv: 123e4567-e89b-12d3-a456-426614174000',
    ai_smart_suggestion_search_orders_by_ref: 'Bestellingen Zoeken op Referentie',
    ai_smart_suggestion_search_orders_by_ref_description: 'Recente bestellingen zoeken op referentie (7 dagen)',
    ai_smart_suggestion_search_orders_by_ref_template: 'Bestellingen zoeken met referentie {orderRef} van de laatste 7 dagen',

    // History
    ai_smart_assistant_request_history: 'Verzoekgeschiedenis',
    ai_smart_assistant_clear_all: 'Alles Wissen',
    ai_smart_assistant_no_history: 'Nog geen geschiedenis',
    ai_smart_assistant_no_history_description: 'Uw AI-verzoeken worden hier opgeslagen voor eenvoudige toegang.',

    // Tabs
    // Error messages
    ai_smart_assistant_error_confirmation: 'Sorry, ik heb een fout ondervonden bij het verwerken van uw bevestiging.',
    ai_smart_assistant_error_request: 'Sorry, ik heb een fout ondervonden bij het verwerken van uw verzoek.',
    ai_smart_assistant_error_api_key: 'API-sleutel vereist. Configureer deze eerst.',
    ai_smart_assistant_error_invalid_api_key: 'Ongeldige API-sleutel. Controleer uw configuratie.',
    ai_smart_assistant_error_auth: 'Authenticatieprobleem. Probeer opnieuw in te loggen.',
    // user roles
    'user-role': 'Rol',
    'user-role-admin': 'Beheerder',
    'user-role-manager': 'Manager',
    'user-role-developer': 'Ontwikkelaar',
    'user-role-finance': 'Financiu00ebn',
    'user-role-operator': 'Operator',
    'user-role-user': 'Gebruiker',

    // Getting Started
    welcome: 'Welkom',
    'welcome-back': 'Welkom terug',
    'try-paybyrd': 'Probeer Paybyrd',
    'try-paybyrd-description':
      'Verbind Paybyrd met je website of platform met behulp van onze test-API-sleutel om het integratieproces te verkennen. Zodra je account is goedgekeurd, ontvang je je live API-sleutel om echte betalingen te accepteren.',
    'try-paybyrd-cta': 'Test-API',
    'resume-registration': 'Registratie hervatten',
    'resume-registration-description':
      'We hebben nog wat informatie en documenten van je nodig. Hervat het registratieproces om het af te ronden — je gaat verder waar je gebleven was.',
    'resume-registration-help': 'Hulp nodig? Bekijk ons artikel of neem contact op via de chat. ',
    'resume-registration-link': 'Registratie bij Paybyrd',
    'resume-registration-cta': 'Proces hervatten',
    'init-registration': 'Begin met Paybyrd',
    'init-registration-description':
      'Om betalingen te kunnen accepteren, moet je eerst het juridische onboardingproces voltooien. Zorg dat je de volgende documenten en informatie bij de hand hebt — je kunt op elk moment pauzeren en hervatten.',
    'company-details': 'Bedrijfsgegevens',
    'shareholder-information': 'Aandeelhoudersinformatie',
    'bank-account-details': 'Bankgegevens',
    'business-activity-overview': 'Overzicht van bedrijfsactiviteiten',
    'init-registration-help': '👉 Meer details nodig? Bekijk ons hulpartikel: ',
    'init-registration-link': 'Registratie bij Paybyrd',
    'start-registration-cta': 'Registratie starten',
    'submitted-registration': 'Registratie verzonden!',
    'submitted-registration-description':
      'Ons team beoordeelt je aanvraag. Binnen vijf werkdagen ontvang je een update via e-mail. Als je meer handelaren moet registreren, sturen we een aparte uitnodigingslink.',
    'submitted-registration-help': 'Vragen? Bekijk ons Helpcentrum of neem contact op via de chat.',
    'submitted-registration-cta': 'Ga naar het Helpcentrum',
    'go-to-dashboard-cta': 'Ga naar dashboard',
    'start-next-onboarding-cta': 'Volgende onboarding starten',
    processingData: 'Gegevens verwerken',
    'parent-payment-id': 'Hoofd betalings-ID',
    acquirerId: 'Acquirer-ID',
    'shift-code': 'Dienstcode',
    'providing-access-to': 'Toegang verlenen tot $1',
    'provide-access': 'Toegang verlenen',
    'select-units-type-to-add': 'Selecteer het type eenheden om toe te voegen',
    'access-updated': 'Toegang bijgewerkt!',
    'add-new-access-units': 'Nieuwe toegangseenheid toevoegen',
    'confirm-updating-access': 'Bevestig het bijwerken van toegang',
    'select-group-add': 'Selecteer de groep om toe te voegen',
    'select-merchant-add': 'Selecteer de handelaar om toe te voegen',
    'select-store-add': 'Selecteer de winkel om toe te voegen',
    'all-merchants': 'Alle verkopers',
    'all-stores': 'Alle winkels',
    'no-units-selected': 'Geen eenheden geselecteerd',
    'remove-access': 'Toegang verwijderen',
    'are-you-sure-remove-group': 'Weet u zeker dat u de groep wilt verwijderen?',
    'are-you-sure-remove-merchant': 'Weet u zeker dat u de handelaar wilt verwijderen?',
    'are-you-sure-remove-store': 'Weet u zeker dat u de winkel wilt verwijderen?',
    next: 'Volgende',
    'success-remove-unit': 'Eenheid succesvol verwijderd',
    'selected-items': '$1 $2 geselecteerd',
    item: 'item',
    items: 'items',
    'no-unit-selected-label': 'Als er geen eenheden zijn geselecteerd, worden alle beschikbare eenheden aan de gebruiker toegevoegd',
    'paybyrd-user': 'Paybyrd-gebruiker met toegang tot alle handelaren',
    'no-groups': 'We konden geen groepen vinden voor de geselecteerde gebruiker',
    'no-groups-subtitle': 'U kunt nieuwe toegangseenheden toevoegen met de knop hierboven',
    'no-merchants': 'We konden geen verkopers vinden voor de geselecteerde gebruiker',
    'no-merchants-subtitle': 'U kunt nieuwe toegangseenheden toevoegen met de knop hierboven',
    'no-stores': 'We konden geen winkels vinden voor de geselecteerde gebruiker',
    'no-stores-subtitle': 'U kunt nieuwe toegangseenheden toevoegen met de knop hierboven',
    'invite-new-users': 'Nieuwe gebruikers uitnodigen',
    'add-emails': 'E-mails toevoegen',
    'enter-valid-email': 'Voer een geldig e-mailadres in.',
    'invite-new-user': 'Nieuwe gebruiker uitnodigen',
    invite: 'Uitnodigen',
    close: 'Sluiten',
    'feature-access': 'Functietoegang',
    'view-feature-access': 'Lijst met toegangsfuncties bekijken',
    'paybylink-description': 'Maakt het mogelijk om betaal­links te maken en te beheren.',
    'shifts-description': 'Maakt het mogelijk om diensten aan te maken.',
    'successfull-invite': 'Uitnodiging succesvol verzonden!',
    'manage-role': 'Rol en toegang beheren',
    'changing-user-roles': 'Gebruikersrol wijzigen',
    'role-operator': 'Staat de geselecteerde actie toe in de toegankelijke gebieden.',
    'role-observer': 'Staat de geselecteerde actie toe in de toegankelijke gebieden.',
    'role-admin': 'Staat volledige controle toe binnen de toegankelijke gebieden.',
    current: 'Huidig',
    save: 'Opslaan',
    transactionPayout: 'Transactie-uitbetaling',
    paymentReference: 'Betaalreferentie',
    threeDSecure: '3D Secure',
    installments: 'Betalingen in termijnen',
    installmentAmount: 'Termijnbedrag',
    cardIssuerCountry: 'Land van de kaartuitgever',
    authorizationCode: 'Autorisatiecode',
    LiabilityShift: 'Aansprakelijkheidsverschuiving',
    version: 'Versie',
    transStatus: '3DS-transactiestatus',
    authorizationStatus: '3DS-autorisatiestatus',
    challengeOptions: '3DS-challenge-opties',
    protocolVersion: 'Protocolversie',
    'settlement-status': 'Afwikkeling',
    eci: 'ECI',
    done: 'Voltooid',
    inProgress: 'Bezig',
  },
};
